/* tslint:disable */
/* eslint-disable */
/**
 * Repay
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';
import { DocumentsTypes } from 'common/utils/utils';
import { ILoadDocumentData } from 'components/pages/Lz/LzTab/Documents/DocumentItem';
import { ISearchValues } from 'components/pages/RiskManegment/common/interface';
import { ILzClientShortInfoWithLz } from 'components/pages/Psa/common/service/service';
import {
  GatewayType,
  I2faSettingsUpdate,
  ILzSettingsUpdate,
  ISmsSettingsUpdate,
  SberIdInfo,
  SberIdSertificates,
  SberIdSettingsUpdate,
  UpdateGatewaySettings,
} from 'components/pages/Lz/LzTab/common/interface/interface';
import { IPaymentListFilterValue } from 'components/layout/AnalyticsTab/UI/common/interface/interface';
import { EPaymentMethod } from 'common/utils/statuses';
import { IClassifierSettingsUpdate } from 'components/pages/Lz/MetalTab/EditClassifierSettings';
import { EDirtinessFormula, LoginTwoFactorMode, TIndexType } from 'common/types/common.types';
import { IPsaItemsDataset } from 'components/pages/Settings/common/interface';
import { IPricingMethod } from 'components/pages/User/common/interface/interface';

/**
 *
 * @export
 * @interface ApiError
 */
export interface ApiError {
  /**
   *
   * @type {number}
   * @memberof ApiError
   */
  code?: number;
  /**
   *
   * @type {string}
   * @memberof ApiError
   */
  message?: string;
}
/**
 *
 * @export
 * @interface ArrayWrapper
 */
export interface ArrayWrapper {
  /**
   *
   * @type {Array<number>}
   * @memberof ArrayWrapper
   */
  values: Array<number>;
}
/**
 *
 * @export
 * @interface BindingCreate
 */
export interface BindingCreate {
  /**
   *
   * @type {string}
   * @memberof BindingCreate
   */
  id: string;
}
/**
 *
 * @export
 * @interface BooleanWrapper
 */
export interface BooleanWrapper {
  /**
   *
   * @type {boolean}
   * @memberof BooleanWrapper
   */
  bool: boolean;
}
/**
 *
 * @export
 * @interface BusinessCardCreate
 */
export interface BusinessCardCreate {
  /**
   *
   * @type {string}
   * @memberof BusinessCardCreate
   */
  cardName: string;
  /**
   *
   * @type {string}
   * @memberof BusinessCardCreate
   */
  bindingId: string;
}
/**
 *
 * @export
 * @interface BusinessCardUpdate
 */
export interface BusinessCardUpdate {
  /**
   *
   * @type {string}
   * @memberof BusinessCardUpdate
   */
  cardName: string;
}
/**
 *
 * @export
 * @interface BusinessCardWithPzus
 */
export interface BusinessCardWithPzus {
  /**
   *
   * @type {number}
   * @memberof BusinessCardWithPzus
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof BusinessCardWithPzus
   */
  cardName: string;
  /**
   *
   * @type {string}
   * @memberof BusinessCardWithPzus
   */
  bindingId: string;
  /**
   *
   * @type {number}
   * @memberof BusinessCardWithPzus
   */
  lzId: number;
  /**
   *
   * @type {boolean}
   * @memberof BusinessCardWithPzus
   */
  blocked: boolean;
  /**
   *
   * @type {Array<Pair>}
   * @memberof BusinessCardWithPzus
   */
  pzus?: Array<Pair>;
  /**
   *
   * @type {string}
   * @memberof BusinessCardWithPzus
   */
  blockStatus?: string;

  /**
   *
   * @type {string}
   * @memberof BusinessCardWithPzus
   */
  gatewayType?: string;
}
export interface PaymentTotalBusinessCard {
  /**
   *
   * @type {number}
   * @memberof PaymentTotalBusinessCard
   */
  bcId: number;
  /**
   *
   * @type {number}
   * @memberof PaymentTotalBusinessCard
   */
  cientDaily: number;
  /**
   *
   * @type {number}
   * @memberof PaymentTotalBusinessCard
   */
  spDaily: number;
  /**
   *
   * @type {number}
   * @memberof PaymentTotalBusinessCard
   */
  clientMonthly: number;
  /**
   *
   * @type {number}
   * @memberof PaymentTotalBusinessCard
   */
  spMonthly: number;
}
/**
 *
 * @export
 * @interface BusinessCardWithUsers
 */
export interface BusinessCardWithUsers {
  /**
   *
   * @type {number}
   * @memberof BusinessCardWithUsers
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof BusinessCardWithUsers
   */
  cardName: string;
  /**
   *
   * @type {boolean}
   * @memberof BusinessCardWithUsers
   */
  blocked: boolean;
  /**
   *
   * @type {Array<number>}
   * @memberof BusinessCardWithUsers
   */
  users?: Array<number>;
}
/**
 *
 * @export
 * @interface CitizenshipDictItem
 */
export interface CitizenshipDictItem {
  /**
   *
   * @type {number}
   * @memberof CitizenshipDictItem
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof CitizenshipDictItem
   */
  citizenship: string;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum ClassifierCode {
  Black = 'METAL_BLACK',
  Color = 'METAL_COLOR',
  WASTE_PAPER = 'WASTE_PAPER',
  AUTO_CATALYST = 'AUTO_CATALYST',
  AUTO_ACCUMULATOR = 'AUTO_ACCUMULATOR',
  WOODEN_PALLET = 'WOODEN_PALLET',
  AGRICULTURAL_PRODUCT = 'AGRICULTURAL_PRODUCT',
  RADIO_PART = 'RADIO_PART',
  PVC_POLYETHYLENE = 'PVC_POLYETHYLENE',
}
/**
 *
 * @export
 * @interface IdWrapper
 */
export interface IdWrapper {
  /**
   *
   * @type {number}
   * @memberof IdWrapper
   */
  id: number;
}
/**
 *
 * @export
 * @interface PassportData
 */
export interface PassportData {
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportSn: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  patronymic: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  sex: string;
  /**
   *
   * @type {string | null}
   * @memberof PassportData
   */
  dateOfBirth: string | null;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  placeOfBirth: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportIssuedDate: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportIssuedBy: string;
  /**
   *
   * @type {string}
   * @memberof PassportData
   */
  passportUnitCode: string;
}
/**
 *
 * @export
 * @interface AddFile
 */
export interface AddFile {
  /**
   *
   * @type {number}
   * @memberof AddFile
   */
  id: number;
}
/**
 *
 * @export
 * @interface Login
 */
export interface Login {
  /**
   *
   * @type {string}
   * @memberof Login
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof Login
   */
  password: string;
  /**
   *
   * @type {string}
   * @memberof Login
   */
  code?: string;
}
/**
 *
 * @export
 * @interface LzClientCreate
 */
export interface LzClientCreate {
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  fullName: string;
  /**
   *
   * @type {number}
   * @memberof LzClientCreate
   */
  citizenshipId: number;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  passportSn: string;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  inn?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  birthday: string;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  passportIssueDate: string;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  passportExpireDate: string;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  passportIssuedBy: string;
  /**
   *
   * @type {string}
   * @memberof LzClientCreate
   */
  passportUnitCode: string;
  /**
   *
   * @type {number}
   * @memberof LzClientCreate
   */
  passportScanId?: number;
  /**
   *
   * @type {boolean}
   * @memberof LzClientCreate
   */
  checkPassportData?: boolean;
}
export interface LzClientUpdate {
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  fullName: string;
  /**
   *
   * @type {number}
   * @memberof LzClientUpdate
   */
  citizenshipId: number | null;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  passportSn: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  inn?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  passportIssueDate?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  passportExpireDate?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  passportIssuedBy?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  passportUnitCode?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientUpdate
   */
  passportRegistrationAddress?: string;
  /**
   *
   * @type {number}
   * @memberof LzClientUpdate
   */
  passportScanId?: number;
  /**
   *
   * @type {boolean}
   * @memberof LzClientUpdate
   */
  checkPassportData?: boolean;
}
/**
 *
 * @export
 * @interface LzClientPaymentCardCreate
 */
export interface LzClientPaymentCardCreate {
  /**
   *
   * @type {string}
   * @memberof LzClientPaymentCardCreate
   */
  pan: string;
}
/**
 *
 * @export
 * @interface LzClientPaymentCardInfo
 */
export interface LzClientPaymentCardInfo {
  /**
   *
   * @type {number}
   * @memberof LzClientPaymentCardInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof LzClientPaymentCardInfo
   */
  pan: string;
  /**
   *
   * @type {string}
   * @memberof LzClientPaymentCardInfo
   */
  bankBrand: string;
}
/**
 *
 * @export
 * @interface LzClientShortInfo
 */
export interface LzClientShortInfo {
  /**
   *
   * @type {number}
   * @memberof LzClientShortInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  fullName: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  passportSn: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  passportSns?: string[];
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  citizenship: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  birthday?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  passportIssuedBy?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  passportIssueDate?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  passportExpireDate?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  passportUnitCode?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  passportRegistrationAddress?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  inn?: string;
  /**
   *
   * @type {string}
   * @memberof LzClientShortInfo
   */
  address: string;
  /**
   *
   * @type {number}
   * @memberof LzClientShortInfo
   */
  passportScanId?: number;
}
/**
 *
 * @export
 * @interface LzCreate
 */
export interface LzCreate {
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  inn: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  kpp?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  businessAddress: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  actualAddress?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  rs: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  executiveFullName?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  executivePosition?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  executiveWorkPhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  executiveAdditionalPhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  executiveMobilePhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  okpo?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  commissionMode: string;
  /**
   *
   * @type {number}
   * @memberof LzCreate
   */
  ogrn?: number;
  /**
   *
   * @type {number}
   * @memberof LzCreate
   */
  ogrnip?: number;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  contactPersonFullName?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  contactPersonMobilePhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  contactPersonEmail?: string;
  /**
   *
   * @type {GatewayType}
   * @memberof LzCreate
   */
  gatewayType?: GatewayType;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  psaInfoTemplate?: string;
}
/**
 *
 * @export
 * @interface LzFullInfo
 */
export interface LzFullInfo {
  /**
   *
   * @type {number}
   * @memberof LzFullInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  inn: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  kpp?: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  businessAddress: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  actualAddress?: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  rs: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  executiveFullName?: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  executivePosition?: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  executiveWorkPhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  executiveAdditionalPhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  executiveMobilePhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzFullInfo
   */
  okpo?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  commissionMode: string;
  /**
   *
   * @type {number}
   * @memberof LzCreate
   */
  ogrn?: number;
  /**
   *
   * @type {number}
   * @memberof LzCreate
   */
  ogrnip?: number;
  /**
   *
   * @type {boolean}
   * @memberof LzCreate
   */
  passportRecognizeEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LzCreate
   */
  innLzClientUpdateEnabled: boolean;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  contactPersonFullName?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  contactPersonMobilePhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  contactPersonEmail?: string;
  /**
   *
   * @type {string}
   * @memberof LzCreate
   */
  psaInfoTemplate?: string;
}
/**
 *
 * @export
 * @interface LzGatewayCredentialsUpsert
 */
export interface LzGatewayCredentialsUpsert {
  /**
   *
   * @type {string}
   * @memberof LzGatewayCredentialsUpsert
   */
  login: string;
  /**
   *
   * @type {string}
   * @memberof LzGatewayCredentialsUpsert
   */
  password: string;
}
/**
 *
 * @export
 * @interface LzClassifierSettings
 */
export interface LzClassifierSettings {
  /**
   *
   * @type {	ClassifierCode}
   * @memberof LzClassifierSettings
   */
  lzId: number;
  /**
   *
   * @type {	ClassifierCode}
   * @memberof LzClassifierSettings
   */
  classifierCode: ClassifierCode;
  /**
   *
   * @type {number}
   * @memberof LzClassifierSettings
   */
  weightPrecision?: number;
  /**
   *
   * @type {string[]}
   * @memberof LzClassifierSettings
   */
  massUnit?: string;
  /**
   *
   * @type {number}
   * @memberof LzClassifierSettings
   */
  minCommission?: number;
}
/**
 *
 * @export
 * @interface LzGatewayCredentialsUpsert
 */
export interface LzSettings {
  /**
   *
   * @type {number}
   * @memberof LzSettings
   */
  id: number;
  /**
   *
   * @type {boolean}
   * @memberof LzSettings
   */
  passportRecognizeEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LzSettings
   */
  innCheckEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LzSettings
   */
  innLzClientUpdateEnabled: boolean;
  /**
   *
   * @type {string}
   * @memberof LzSettings
   */
  smsConfirmationMode: string;
  /**
   *
   * @type {number[]}
   * @memberof LzSettings
   */
  smsUsers?: number[];
  /**
   *
   * @type {boolean}
   * @memberof LzSettings
   */
  twoFactorAuthEnabled: boolean;
  /**
   *
   * @type {GatewayType}
   * @memberof LzSettings
   */
  gatewayType: GatewayType;
  /**
   *
   * @type {EDirtinessFormula}
   * @memberof LzSettings
   */
  dirtinessFormula: EDirtinessFormula;
}
/**
 *
 * @export
 * @interface LzGatewayCredentialsUpsert
 */
export interface LzSberIdCredentialsUpsert {
  /**
   *
   * @type {string}
   * @memberof LzSberIdCredentialsUpsert
   */
  sberIdClientId: string;
  /**
   *
   * @type {string}
   * @memberof LzSberIdCredentialsUpsert
   */
  sberIdClientSecret: string;
}
export interface LzIdSberCredentials {
  /**
   *
   * @type {string}
   * @memberof LzSberIdCredentialsUpsert
   */
  sberIdClientId: string;
  /**
   *
   * @type {string}
   * @memberof LzSberIdCredentialsUpsert
   */
  sberIdClientSecret: string;
  /**
   *
   * @type {boolean}
   * @memberof LzSberIdCredentialsUpsert
   */
  sberIdIsConnected: boolean;
  /**
   *
   * @type {number}
   * @memberof LzSberIdCredentialsUpsert
   */
  lzId: number;
}
/**
 *
 * @export
 * @interface LzInfo
 */
/**
 *
 * @export
 * @interface LzIsConnectedToSberId
 */
export interface LzIsConnectedToSberId {
  /**
   *
   * @type {boolean}
   * @memberof LzIsConnectedToSberId
   */
  bool: boolean;
}
/**
 *
 * @export
 * @interface LzSberIdLoginUrl
 */
export interface LzSberIdLoginUrl {
  /**
   *
   * @type {string}
   * @memberof LzSberIdLoginUrl
   */
  url: string;
}
/**
 *
 * @export
 * @interface LzSberIdLogOut
 */
export interface LzSberIdLogOut {
  /**
   *
   * @type {boolean}
   * @memberof LzSberIdLoginUrl
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface LzInfo
 */
export interface LzInfo {
  /**
   *
   * @type {number}
   * @memberof LzInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  inn: string;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  businessAddress: string;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  executiveFullName?: string;
  /**
   *
   * @type {number}
   * @memberof LzInfo
   */
  lzClientPaymentSum?: number;
  /**
   *
   * @type {number}
   * @memberof LzInfo
   */
  pzuCount?: number;
  /**
   *
   * @type {number}
   * @memberof LzInfo
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  lzInn: string;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  lzBusinessAddress: string;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  lzClientIndex?: string;
  /**
   *
   * @type {string}
   * @memberof LzInfo
   */
  lzTotalIndex?: string;
  /**
   *
   * @type {number}
   * @memberof LzInfo
   */
  paymentSum?: number;
}

export interface LzIndexInfo {
  /**
   *
   * @type {number}
   * @memberof LzIndexInfo
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof LzIndexInfo
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof LzIndexInfo
   */
  lzInn?: string;
  /**
   *
   * @type {string}
   * @memberof LzIndexInfo
   */
  lzOkpo?: string;
  /**
   *
   * @type {string}
   * @memberof LzIndexInfo
   */

  lzKpp?: string;
  /**
   *
   * @type {string}
   * @memberof LzIndexInfo
   */
  lzBusinessAddress?: string;
  /**
   *
   * @type {string}
   * @memberof LzIndexInfo
   */
  lzActualAddress?: string;
  /**
   *
   * @type {string}
   * @memberof LzIndexInfo
   */
  lzRs?: string;
  /**
   *
   * @type {TIndexType}
   * @memberof LzIndexInfo
   */
  lzClientIndex?: TIndexType;
  /**
   *
   * @type {TIndexType}
   * @memberof LzIndexInfo
   */
  lzTotalIndex?: TIndexType;
  /**
   *
   * @type {number}
   * @memberof LzIndexInfo
   */
  paymentSum?: number;
  /**
   *
   * @type {number}
   * @memberof LzIndexInfo
   */
  lzOgrn?: number;
  /**
   *
   * @type {number}
   * @memberof LzIndexInfo
   */
  lzOgrnip?: number;
  /**
   *
   * @type {TIndexType}
   * @memberof LzIndexInfo
   */
  psaIndex?: TIndexType;
  /**
   *
   * @type {TIndexType}
   * @memberof LzIndexInfo
   */
  locationIndex?: TIndexType;
  /**
   *
   * @type {TIndexType}
   * @memberof LzIndexInfo
   */
  lzDocumentIndex?: TIndexType;
}

export interface LzPzuIndex {
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  pzuId?: number;
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  lzId?: number;
  /**
   *
   * @type {string}
   * @memberof LzPzuIndex
   */
  pzuName?: string;
  /**
   *
   * @type {string}
   * @memberof LzPzuIndex
   */
  pzuAddress?: string;
  /**
   *
   * @type {string}
   * @memberof LzPzuIndex
   */
  psaIndex?: string;
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  psaScore?: number;
  /**
   *
   * @type {string}
   * @memberof LzPzuIndex
   */
  pzuClientIndex?: string;
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  pzuClientScore?: number;
  /**
   *
   * @type {string}
   * @memberof LzPzuIndex
   */
  lzDocumentIndex?: string;
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  lzDocumentScore?: number;
  /**
   *
   * @type {string}
   * @memberof LzPzuIndex
   */
  locationIndex?: string;
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  locationScore?: number;
  /**
   *
   * @type {string}
   * @memberof LzPzuIndex
   */
  pzuTotalIndex?: string;
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  pzuTotalScore?: number;
  /**
   *
   * @type {number}
   * @memberof LzPzuIndex
   */
  paymentSum?: number;
}

/**
 *
 * @export
 * @interface LzShortInfo
 */
export interface LzShortInfo {
  /**
   *
   * @type {number}
   * @memberof LzShortInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof LzShortInfo
   */
  name: string;
}
/**
 *
 * @export
 * @interface LzUpdate
 */
export interface LzUpdate {
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  inn: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  kpp?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  businessAddress: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  actualAddress?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  rs: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  executiveFullName?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  executivePosition?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  executiveWorkPhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  executiveAdditionalPhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  executiveMobilePhone?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  okpo?: string;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  commissionMode?: string;
  /**
   *
   * @type {number}
   * @memberof LzUpdate
   */
  ogrn?: number;
  /**
   *
   * @type {number}
   * @memberof LzUpdate
   */
  ogrnip?: number;
  /**
   *
   * @type {string}
   * @memberof LzUpdate
   */
  psaInfoTemplate?: string;
}
/**
 *
 * @export
 * @interface MetalDictItem
 */
export interface MetalDictItem {
  /**
   *
   * @type {number}
   * @memberof MetalDictItem
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  generalName: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  generalCode?: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  class_?: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  classCode?: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  classifier?: string;
  /**
   *
   * @type {ClassifierCode}
   * @memberof MetalDictItem
   */
  classifierCode: ClassifierCode;
  /**
   *
   * @type {string}
   * @memberof MetalDictItem
   */
  massUnit?: ClassifierCode;
}
/**
 *
 * @export
 * @interface MetalDictItemWithFavorites
 */
export interface MetalDictItemWithFavorites {
  /**
   *
   * @type {number}
   * @memberof MetalDictItemWithFavorites
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof MetalDictItemWithFavorites
   */
  classifier?: string;
  /**
   *
   * @type {string}
   * @memberof MetalDictItemWithFavorites
   */
  name: string;
  /**
   *
   * @type {ClassifierCode}
   * @memberof MetalDictItemWithFavorites
   */
  classifierCode: ClassifierCode;
  /**
   *
   * @type {string}
   * @memberof MetalDictItemWithFavorites
   */
  generalName: string;
  /**
   *
   * @type {boolean}
   * @memberof MetalDictItemWithFavorites
   */
  isFavorite: boolean;
  /**
   *
   * @type {number}
   * @memberof MetalDictItemWithFavorites
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof MetalDictItemWithFavorites
   */
  massUnit: string;
}
/**
 *
 * @export
 * @interface ForbiddenClassifiersList
 */
export interface ForbiddenClassifiersList {
  /**
   *
   * @type {string[]}
   * @memberof ForbiddenClassifiersList
   */
  forbiddenClassifiers: string[];
}
/**
 *
 * @export
 * @interface MetalTariffCreate
 */
export interface MetalTariffCreate {
  /**
   *
   * @type {number}
   * @memberof MetalTariffCreate
   */
  metalId: number;
  /**
   *
   * @type {string}
   * @memberof MetalTariffCreate
   */
  startDate: string;
  /**
   *
   * @type {string}
   * @memberof MetalTariffCreate
   */
  endDate?: string;
  /**
   *
   * @type {number}
   * @memberof MetalTariffCreate
   */
  price: number;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum MetalTariffStatus {
  Current = 'CURRENT',
  Future = 'FUTURE',
  Archive = 'ARCHIVE',
}

/**
 *
 * @export
 * @interface MetalTariffUpdate
 */
export interface MetalTariffUpdate {
  /**
   *
   * @type {boolean}
   * @memberof MetalTariffUpdate
   */
  archived: boolean;
}
/**
 *
 * @export
 * @interface MetalTariffWithLz
 */
export interface MetalTariffWithLz {
  /**
   *
   * @type {number}
   * @memberof MetalTariffWithLz
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof MetalTariffWithLz
   */
  startDate: string;
  /**
   *
   * @type {string}
   * @memberof MetalTariffWithLz
   */
  endDate?: string;
  /**
   *
   * @type {number}
   * @memberof MetalTariffWithLz
   */
  price: number;
  /**
   *
   * @type {number}
   * @memberof MetalTariffWithLz
   */
  pzuId: number;
  /**
   *
   * @type {MetalTariffStatus}
   * @memberof MetalTariffWithLz
   */
  status: MetalTariffStatus;
  /**
   *
   * @type {string}
   * @memberof MetalTariffWithLz
   */
  pzuName: string;
  /**
   *
   * @type {number}
   * @memberof MetalTariffWithLz
   */
  lzId: number;
  /**
   *
   * @type {number}
   * @memberof MetalTariffWithLz
   */
  metalId: number;
  /**
   *
   * @type {string}
   * @memberof MetalTariffWithLz
   */
  metalName: string;
  /**
   *
   * @type {string}
   * @memberof MetalTariffWithLz
   */
  metalMassUnit: string;
  /**
   *
   * @type {string}
   * @memberof MetalTariffWithLz
   */
  metalClassifierCode: ClassifierCode;
}
/**
 *
 * @export
 * @interface PageWrapperBusinessCardWithPzus
 */
export interface PageWrapperBusinessCardWithPzus {
  /**
   *
   * @type {number}
   * @memberof PageWrapperBusinessCardWithPzus
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperBusinessCardWithPzus
   */
  rowCount: number;
  /**
   *
   * @type {Array<BusinessCardWithPzus>}
   * @memberof PageWrapperBusinessCardWithPzus
   */
  elements?: Array<BusinessCardWithPzus>;
}
/**
 *
 * @export
 * @interface PageWrapperBusinessCardWithUsers
 */
export interface PageWrapperBusinessCardWithUsers {
  /**
   *
   * @type {number}
   * @memberof PageWrapperBusinessCardWithUsers
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperBusinessCardWithUsers
   */
  rowCount: number;
  /**
   *
   * @type {Array<BusinessCardWithUsers>}
   * @memberof PageWrapperBusinessCardWithUsers
   */
  elements?: Array<BusinessCardWithUsers>;
}
/**
 *
 * @export
 * @interface PageWrapperLzClientShortInfo
 */
export interface PageWrapperLzClientShortInfo {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzClientShortInfo
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzClientShortInfo
   */
  rowCount: number;
  /**
   *
   * @type {Array<LzClientShortInfo>}
   * @memberof PageWrapperLzClientShortInfo
   */
  elements?: Array<LzClientShortInfo>;
}
/**
 *
 * @export
 * @interface PageWrapperLzInfo
 */
export interface PageWrapperLzInfo {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzInfo
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzInfo
   */
  rowCount: number;
  /**
   *
   * @type {Array<LzInfo>}
   * @memberof PageWrapperLzInfo
   */
  elements?: Array<LzInfo>;
}
export interface PageWrapperLzInfo {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzInfo
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzInfo
   */
  rowCount: number;
  /**
   *
   * @type {Array<LzInfo>}
   * @memberof PageWrapperLzInfo
   */
  elements?: Array<LzInfo>;
}
export interface PageWrapperLzPzuIndex {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzInfo
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzInfo
   */
  rowCount: number;
  /**
   *
   * @type {Array<LzInfo>}
   * @memberof PageWrapperLzInfo
   */
  elements?: Array<LzPzuIndex>;
}
/**
 *
 * @export
 * @interface PageWrapperLzShortInfo
 */
export interface PageWrapperLzShortInfo {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzShortInfo
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLzShortInfo
   */
  rowCount: number;
  /**
   *
   * @type {Array<LzShortInfo>}
   * @memberof PageWrapperLzShortInfo
   */
  elements?: Array<LzShortInfo>;
}
/**
 *
 * @export
 * @interface PageWrapperMetalDictItemWithFavorites
 */
export interface PageWrapperMetalDictItemWithFavorites {
  /**
   *
   * @type {number}
   * @memberof PageWrapperMetalDictItemWithFavorites
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperMetalDictItemWithFavorites
   */
  rowCount: number;
  /**
   *
   * @type {Array<MetalDictItemWithFavorites>}
   * @memberof PageWrapperMetalDictItemWithFavorites
   */
  elements?: Array<MetalDictItemWithFavorites>;
}
/**
 *
 * @export
 * @interface PageWrapperMetalTariffWithLz
 */
export interface PageWrapperMetalTariffWithLz {
  /**
   *
   * @type {number}
   * @memberof PageWrapperMetalTariffWithLz
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperMetalTariffWithLz
   */
  rowCount: number;
  /**
   *
   * @type {Array<MetalTariffWithLz>}
   * @memberof PageWrapperMetalTariffWithLz
   */
  elements?: Array<MetalTariffWithLz>;
}
/**
 *
 * @export
 * @interface PageWrapperPaymentWithPzuAndClient
 */
export interface PageWrapperPaymentWithPzuAndClient {
  /**
   *
   * @type {number}
   * @memberof PageWrapperPaymentWithPzuAndClient
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPaymentWithPzuAndClient
   */
  rowCount: number;
  /**
   *
   * @type {Array<PaymentWithPzuAndClient>}
   * @memberof PageWrapperPaymentWithPzuAndClient
   */
  elements?: Array<PaymentWithPzuAndClient>;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPaymentWithPzuAndClient
   */
  sum: number;
}
/**
 *
 * @export
 * @interface PageWrapperPsaTotalPayment
 */
export interface PageWrapperPsaTotalPayment {
  /**
   *
   * @type {number}
   * @memberof PageWrapperPsaTotalPayment
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPsaTotalPayment
   */
  rowCount: number;
  /**
   *
   * @type {Array<PsaTotalPayment>}
   * @memberof PageWrapperPsaTotalPayment
   */
  elements?: Array<PsaTotalPayment>;
}
/**
 *
 * @export
 * @interface PageWrapperPsaWithClientLzAndScan
 */
export interface PageWrapperPsaWithClientLzAndScan {
  /**
   *
   * @type {number}
   * @memberof PageWrapperPsaWithClientLzAndScan
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPsaWithClientLzAndScan
   */
  rowCount: number;
  /**
   *
   * @type {Array<PsaWithClientLzAndScan>}
   * @memberof PageWrapperPsaWithClientLzAndScan
   */
  elements?: Array<PsaWithClientLzAndScan>;
}

export interface PageWrapperPsaComplience {
  /**
   *
   * @type {number}
   * @memberof PageWrapperPsaWithClientLzAndScan
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPsaWithClientLzAndScan
   */
  rowCount: number;
  /**
   *
   * @type {Array<PsaWithClientLzAndScan>}
   * @memberof PageWrapperPsaWithClientLzAndScan
   */
  elements?: Array<PsaCompliance>;
}
/**
 *
 * @export
 * @interface PageWrapperPzuInfo
 */
export interface PageWrapperPzuInfo {
  /**
   *
   * @type {number}
   * @memberof PageWrapperPzuInfo
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPzuInfo
   */
  rowCount: number;
  /**
   *
   * @type {Array<PzuInfo>}
   * @memberof PageWrapperPzuInfo
   */
  elements?: Array<PzuInfo>;
}
/**
 *
 * @export
 * @interface PageWrapperPzuUserInfo
 */
export interface PageWrapperPzuUserInfo {
  users: any;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPzuUserInfo
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPzuUserInfo
   */
  rowCount: number;
  /**
   *
   * @type {Array<PzuUserInfo>}
   * @memberof PageWrapperPzuUserInfo
   */
  elements?: Array<PzuUserInfo>;
}
/**
 *
 * @export
 * @interface PageWrapperPzuWithLz
 */
export interface PageWrapperPzuWithLz {
  /**
   *
   * @type {number}
   * @memberof PageWrapperPzuWithLz
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperPzuWithLz
   */
  rowCount: number;
  /**
   *
   * @type {Array<PzuWithLz>}
   * @memberof PageWrapperPzuWithLz
   */
  elements?: Array<PzuWithLz>;
}
/**
 *
 * @export
 * @interface PageWrapperUserInfoWithLz
 */
export interface PageWrapperUserInfoWithLz {
  /**
   *
   * @type {number}
   * @memberof PageWrapperUserInfoWithLz
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperUserInfoWithLz
   */
  rowCount: number;
  /**
   *
   * @type {Array<UserInfoWithLz>}
   * @memberof PageWrapperUserInfoWithLz
   */
  elements?: Array<UserInfoWithLz>;
}

/**
 *
 * @export
 * @interface PageWrapperUserInfoWithLzV2
 */
export interface PageWrapperUserInfoWithLzV2 {
  /**
   *
   * @type {number}
   * @memberof PageWrapperUserInfoWithLzV2
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperUserInfoWithLzV2
   */
  rowCount: number;
  /**
   *
   * @type {Array<UserInfoWithLzV2>}
   * @memberof PageWrapperUserInfoWithLzV2
   */
  elements?: Array<UserInfoWithLzV2>;
}
/**
 *
 * @export
 * @interface Pair
 */
export interface Pair {
  /**
   *
   * @type {number}
   * @memberof Pair
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof Pair
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof Pair
   */
  size?: number;
  /**
   *
   * @type {string}
   * @memberof Pair
   */
  gatewayType?: string;
}
/**
 *
 * @export
 * @interface PasswordForgot
 */
export interface PasswordForgot {
  /**
   *
   * @type {string}
   * @memberof PasswordForgot
   */
  email: string;
}
/**
 *
 * @export
 * @interface PasswordRestore
 */
export interface PasswordRestore {
  /**
   *
   * @type {string}
   * @memberof PasswordRestore
   */
  token: string;
  /**
   *
   * @type {string}
   * @memberof PasswordRestore
   */
  code: string;
  /**
   *
   * @type {string}
   * @memberof PasswordRestore
   */
  newPassword: string;
}
/**
 *
 * @export
 * @interface PaymentCreate
 */
export interface PaymentCreate {
  /**
   *
   * @type {number}
   * @memberof PaymentCreate
   */
  lzClientPaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof PaymentCreate
   */
  lzClientPaymentCardId: number;
  /**
   *
   * @type {number}
   * @memberof PaymentCreate
   */
  businessCardId: number;
}

/**
 *
 * @export
 * @interface StatementCorrection
 */
export interface StatementCorrection {
  /**
   *
   * @type {number}
   * @memberof StatementCorrection
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof StatementCorrection
   */
  ['payment-created-at-from']: string;
  /**
   *
   * @type {string}
   * @memberof StatementCorrection
   */
  ['payment-created-at-to']: string;
  /**
   *
   * @type {string}
   * @memberof StatementCorrection
   */
  file: string;
}
/**
 *
 * @export
 * @interface PsaPaymentList
 */
export interface PsaPaymentList {
  /**
   *
   * @type {number}
   * @memberof PsaPaymentList
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PsaPaymentList
   */
  status: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof PsaPaymentList
   */
  createdAt: string;
}
/**
 *
 * @export
 * @interface PaymentFullInfo
 */
export interface PaymentFullInfo {
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  id: number;
  /**
   *
   * @type {PaymentStatus}
   * @memberof PaymentFullInfo
   */
  status: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  errorMessage?: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  psaId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  lzClientPaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  spFeePaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  creditStatus?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  creditId: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  debitStatus?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  debitId: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  lzClientId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  lzClientFullName: string;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  lzClientPassportSn: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  lzClientCardId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  lzClientCardPan: string;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  lzClientCitizenship: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  businessCardId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  businessCardName: string;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  businessCardBindingId: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  pzuId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  pzuName: string;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  userSurname: string;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  userName: string;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  userPatronymic?: string;
  /**
   *
   * @type {Array<Pair>}
   * @memberof PaymentFullInfo
   */
  scans?: Array<Pair>;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  creditActionCode?: number;
  /**
   *
   * @type {number}
   * @memberof PaymentFullInfo
   */
  parentId?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  creditRrn?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  debitRrn?: string;
  /**
   *
   * @type {string}
   * @memberof PaymentFullInfo
   */
  lzClientPaymentPhone?: string;
  /**
   *
   * @type {GatewayType}
   * @memberof PaymentFullInfo
   */
  gatewayType?: GatewayType;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum PaymentStatus {
  Created = 'CREATED',
  CreditStatus = 'CREDIT_STATUS',
  Done = 'DONE',
  Error = 'ERROR',
  CreditRegister = 'CREDIT_REGISTER',
  CreditBind = 'CREDIT_BIND',
  DebitRegister = 'DEBIT_REGISTER',
  DebitPerform = 'DEBIT_PERFORM',
  DebitStatus = 'DEBIT_STATUS',
  Reverse = 'REVERSE',
}

/**
 *
 * @export
 * @interface PaymentWithPzuAndClient
 */
export interface PaymentWithPzuAndClient {
  /**
   *
   * @type {number}
   * @memberof PaymentWithPzuAndClient
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PaymentWithPzuAndClient
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof PaymentWithPzuAndClient
   */
  createdBy: number;
  /**
   *
   * @type {PaymentStatus}
   * @memberof PaymentWithPzuAndClient
   */
  status: PaymentStatus;
  /**
   *
   * @type {number}
   * @memberof PaymentWithPzuAndClient
   */
  lzClientPaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof PaymentWithPzuAndClient
   */
  spFeePaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof PaymentWithPzuAndClient
   */
  lzId: number;
  /**
   *
   * @type {number}
   * @memberof PaymentWithPzuAndClient
   */
  pzuId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentWithPzuAndClient
   */
  pzuName: string;
  /**
   *
   * @type {string}
   * @memberof PaymentWithPzuAndClient
   */
  lzName: string;
  /**
   *
   * @type {number}
   * @memberof PaymentWithPzuAndClient
   */
  psaId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentWithPzuAndClient
   */
  clientFullName: string;
}
/**
 *
 * @export
 * @interface PercentWrapper
 */
export interface PercentWrapper {
  /**
   *
   * @type {number}
   * @memberof PercentWrapper
   */
  percent: number;
  /**
   *
   * @type {number}
   * @memberof PercentWrapper
   */
  sberPercent?: number;
  /**
   *
   * @type {string}
   * @memberof PercentWrapper
   */
  startDate?: string;
}
/**
 *
 * @export
 * @interface PercentWrapperWithDate
 */
export interface PercentWrapperWithDate {
  /**
   *
   * @type {number}
   * @memberof PercentWrapperWithDate
   */
  percent: number;
  /**
   *
   * @type {number}
   * @memberof PercentWrapperWithDate
   */
  sberPercent?: number;
  /**
   *
   * @type {string}
   * @memberof PercentWrapperWithDate
   */
  startDate?: string;
}
/**
 *
 * @export
 * @interface CommissionInfo
 */
export interface CommissionInfo {
  /**
   *
   * @type {number}
   * @memberof CommissionInfo
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof CommissionInfo
   */
  lzId: number;
  /**
   *
   * @type {number}
   * @memberof CommissionInfo
   */
  percent: number;
  /**
   *
   * @type {number}
   * @memberof CommissionInfo
   */
  sberPercent?: number;
  /**
   *
   * @type {string}
   * @memberof CommissionInfo
   */
  startDate?: string;
}
/**
 *
 * @export
 * @interface TotalWeight
 */
export interface TotalWeight {
  /**
   *
   * @type {ClassifierCode}
   * @memberof TotalWeight
   */
  classifierCode: ClassifierCode;
  /**
   *
   * @type {number}
   * @memberof TotalWeight
   */
  value: number;
}
/**
 *
 * @export
 * @interface TotalRub
 */
export interface TotalRub {
  /**
   *
   * @type {ClassifierCode}
   * @memberof TotalRub
   */
  classifierCode: ClassifierCode;
  /**
   *
   * @type {number}
   * @memberof TotalRub
   */
  value: number;
}
/**
 *
 * @export
 * @interface PzuTotal
 */
export interface PzuTotal {
  /**
   *
   * @type {number}
   * @memberof PzuTotal
   */
  pzuId: number;
  /**
   *
   * @type {string}
   * @memberof PzuTotal
   */
  pzuName: string;
  /**
   *
   * @type {Array<TotalRub>}
   * @memberof PzuTotal
   */
  rub: Array<TotalRub>;
}
/**
 *
 * @export
 * @interface MonthlyRevenues
 */
export interface MonthlyRevenues {
  /**
   *
   * @type {string}
   * @memberof MonthlyRevenues
   */
  month: string;
  /**
   *
   * @type {Array<TotalRub>}
   * @memberof MonthlyRevenues
   */
  revenue: Array<TotalRub>;
}
/**
 *
 * @export
 * @interface AnalyticsWrapper
 */
export interface AnalyticsWrapper {
  /**
   *
   * @type {Array<TotalWeight>}
   * @memberof AnalyticsWrapper
   */
  totalWeight: Array<TotalWeight>;
  /**
   *
   * @type {Array<TotalRub>}
   * @memberof AnalyticsWrapper
   */
  totalRub: Array<TotalRub>;
  /**
   *
   * @type {Array<PzuTotal>}
   * @memberof AnalyticsWrapper
   */
  pzuTotalRevenues: Array<PzuTotal>;
  /**
   *
   * @type {Array<MonthlyRevenues>}
   * @memberof AnalyticsWrapper
   */
  monthlyRevenues: Array<MonthlyRevenues>;
}
/**
 *
 * @export
 * @interface LzMetalValume
 */
export interface LzMetalValume {
  /**
   *
   * @type {number}
   * @memberof LzMetalValume
   */
  lzId: number;
  /**
   *
   * @type {number}
   * @memberof LzMetalValume
   */
  paymentSumWeight: number;
  /**
   *
   * @type {number}
   * @memberof LzMetalValume
   */
  paymentSumVolume: number;
  /**
   *
   * @type {string}
   * @memberof LzMetalValume
   */
  paymentPeriod: string;
  /**
   *
   * @type {ClassifierCode}
   * @memberof LzMetalValume
   */
  classifierCode: ClassifierCode;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum PricingMethod {
  Strict = 'STRICT',
  Relaxed = 'RELAXED',
  None = 'NONE',
}
/**
 *
 * @export
 * @interface PsaCreate
 */
export interface PsaCreate {
  /**
   *
   * @type {number}
   * @memberof PsaCreate
   */
  lzClientId: number;
  /**
   *
   * @type {string}
   * @memberof PsaCreate
   */
  lzClientTransportNumber?: string;
  /**
   *
   * @type {string}
   * @memberof PsaCreate
   */
  lzClientTransportBrand?: string;
  /**
   *
   * @type {string}
   * @memberof PsaCreate
   */
  ownershipJustification: string;
  /**
   *
   * @type {ClassifierCode}
   * @memberof PsaCreate
   */
  classifierCode: ClassifierCode;
  /**
   *
   * @type {string}
   * @memberof PsaCreate
   */
  psaInfo?: string;
  /**
   *
   * @type {string}
   * @memberof PsaCreate
   */
  businessCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaCreate
   */
  lzClientPaymentCardId?: number;
  /**
   *
   * @type {number}
   * @memberof PsaCreate
   */
  vehicleCheckId?: number;
  /**
   *
   * @type {EPaymentMethod}
   * @memberof PsaCreate
   */
  paymentType: EPaymentMethod;
  /**
   *
   * @type {number}
   * @memberof PsaCreate
   */
  lzClientTransportModelId?: number;
  /**
   *
   * @type {number}
   * @memberof PsaCreate
   */
  lzClientTransportBrandId?: number;
}
/**
 *
 * @export
 * @interface PsaItemCreate
 */
export interface PsaItemCreate {
  /**
   *
   * @type {number}
   * @memberof PsaItemCreate
   */
  metalId: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemCreate
   */
  weightGross: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemCreate
   */
  weightContainer: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemCreate
   */
  dirtiness: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemCreate
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof PsaItemInfo
   */
  additionalInfo?: string;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  dirtinessPercent?: number;
}
/**
 *
 * @export
 * @interface PsaItemInfo
 */
export interface PsaItemInfo {
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  metalId: number;
  /**
   *
   * @type {string}
   * @memberof PsaItemInfo
   */
  metalName: string;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  psaId: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  weightGross: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  weightContainer: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  dirtiness: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof PsaItemInfo
   */
  additionalInfo?: string;
  /**
   *
   * @type {string}
   * @memberof PsaItemInfo
   */
  metalMassUnit?: string;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  dirtinessPercent?: number;
}
/**
 *
 * @export
 * @interface PsaItemUpdate
 */
export interface PassportInfo {
  /**
   *
   * @type {boolean}
   * @memberof PsaItemInfo
   */
  isValid: boolean;
  /**
   *
   * @type {	string}
   * @memberof PsaItemInfo
   */
  passportCheckDate: string;
  /**
   *
   * @type {string}
   * @memberof PsaItemInfo
   */
  passportSn: string;
  /**
   *
   * @type {number}
   * @memberof PsaItemInfo
   */
  citizenshipId: number;
}
/**
 *
 * @export
 * @interface PsaItemUpdate
 */
export interface PsaItemUpdate {
  /**
   *
   * @type {number}
   * @memberof PsaItemUpdate
   */
  metalId: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemUpdate
   */
  weightGross: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemUpdate
   */
  weightContainer: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemUpdate
   */
  dirtiness: number;
  /**
   *
   * @type {number}
   * @memberof PsaItemUpdate
   */
  price: number;
  /**
   *
   * @type {string}
   * @memberof PsaItemUpdate
   */
  additionalInfo?: string;
  /**
   *
   * @type {number}
   * @memberof PsaItemUpdate
   */
  dirtinessPercent?: number;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum PsaStatus {
  Draft = 'DRAFT',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Paid = 'PAID',
  PaymentError = 'PAYMENT_ERROR',
  Archived = 'ARCHIVED',
  PaidCash = 'PAID_CASH',
}

export enum PaymentMethods {
  Vtorium = 'VTORIUM',
  Cash = 'CASH',
}

/**
 *
 * @export
 * @interface PsaTotalPayment
 */
export interface PsaTotalPayment {
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  psaId: number;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  psaStatus: PsaStatus;
  /**
   *
   * @type {string}
   * @memberof PsaTotalPayment
   */
  psaCreatedAt: string;
  /**
   *
   * @type {string}
   * @memberof PsaTotalPayment
   */
  lzClientFullName: string;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  businessCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaTotalPayment
   */
  businessCardName?: string;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  lzClientPaymentCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaTotalPayment
   */
  lzClientPaymentCardPan?: string;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  lzClientId: number;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  pzuId: number;
  /**
   *
   * @type {string}
   * @memberof PsaTotalPayment
   */
  pzuName: string;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  lzClientPaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  spFeePaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  commissionPercent: number;
  /**
   *
   * @type {number}
   * @memberof PsaTotalPayment
   */
  sberPercent?: number;
}
/**
 *
 * @export
 * @interface PsaUpdate
 */
export interface PsaUpdate {
  /**
   *
   * @type {number}
   * @memberof PsaUpdate
   */
  lzClientId: number;
  /**
   *
   * @type {string}
   * @memberof PsaUpdate
   */
  lzClientTransportNumber?: string;
  /**
   *
   * @type {string}
   * @memberof PsaUpdate
   */
  lzClientTransportBrand?: string;
  /**
   *
   * @type {string}
   * @memberof PsaUpdate
   */
  ownershipJustification: string;
  /**
   *
   * @type {string}
   * @memberof PsaUpdate
   */
  psaInfo?: string;
  /**
   *
   * @type {number}
   * @memberof PsaUpdate
   */
  businessCardId?: number;
  /**
   *
   * @type {number}
   * @memberof PsaUpdate
   */
  lzClientPaymentCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaUpdate
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof PsaUpdate
   */
  lzClientTransportBrandId?: number;
}
/**
 *
 * @export
 * @interface PsaWithClientAndScan
 */
export interface PsaWithClientAndScan {
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  createdAt: string;
  /**
   *
   * @type {PsaStatus}
   * @memberof PsaWithClientAndScan
   */
  status: PsaStatus;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  pzuId: number;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  pzuName: string;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  lzClientId: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientFullName: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientInn?: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientAddress: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientPassportSn: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientCitizenship: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  ownershipJustification: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientTransportBrand?: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientTransportNumber?: string;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  successPaymentId?: number;
  /**
   *
   * @type {Array<Pair>}
   * @memberof PsaWithClientAndScan
   */
  scans?: Array<Pair>;
  /**
   *
   * @type {ClassifierCode}
   * @memberof PsaWithClientAndScan
   */
  classifierCode: ClassifierCode;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzOkpo?: string;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  psaInfo?: string;
  /**
   *
   * @type {PricingMethod}
   * @memberof PsaWithClientAndScan
   */
  pricingMethod: PricingMethod;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  pzuAddress: string;
  /**
   *
   * @type {Pair}
   * @memberof PsaWithClientAndScan
   */
  passportScan?: Pair;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  businessCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  businessCardName?: string;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  lzClientPaymentCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  lzClientPaymentCardPan?: string;
  /**
   *
   * @type {EPaymentMethod}
   * @memberof PsaWithClientAndScan
   */
  paymentType: EPaymentMethod;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientAndScan
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  lzClientTransportModelId?: number;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  lzClientTransportBrandId?: number;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  createdBy: number;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientAndScan
   */
  lzClientPaymentPhone?: string;
}
/**
 *
 * @export
 * @interface PsaIndex
 */
export interface PsaIndex {
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  businessCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  businessCardName?: string;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  fakePassportIndex?: TIndexType;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  fakePassportScore?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  hour24Index?: TIndexType;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  hour24Score?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  locationIndex: string;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  locationScore: number;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  lzClientCardId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  lzClientCardPan?: string;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  lzClientFullName?: string;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  lzClientId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  lzClientInn?: string;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  lzClientPassportSn?: string;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  lzClientPaymentAmount?: number;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  lzId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  lzName?: string;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  priceIndex?: TIndexType;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  priceScore?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  psaCreatedAt?: string;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  psaId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  psaScanIndex?: TIndexType;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  psaScanScore?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  psaVirtualId?: string;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  pzuId?: number;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  pzuName?: string;
  /**
   *
   * @type {string}
   * @memberof PsaIndex
   */
  weightIndex?: TIndexType;
  /**
   *
   * @type {number}
   * @memberof PsaIndex
   */
  weightTotalScore?: number;
  /**
   *TIndexType
   * @type {TIndexType}
   * @memberof PsaIndex
   */
  numberIndex?: TIndexType;
  /**
   *
   * @type {TIndexType}
   * @memberof PsaIndex
   */
  modelIndex?: TIndexType;
  /**
   *
   * @type {TIndexType}
   * @memberof PsaIndex
   */
  weightContainerIndex?: TIndexType;
  /**
   *
   * @type {TIndexType}
   * @memberof PsaIndex
   */
  weightNettoIndex?: TIndexType;
  /**
   *
   * @type {TIndexType}
   * @memberof PsaIndex
   */
  weightPedestrianIndex?: TIndexType;
  /**
   *
   * @type {boolean}
   * @memberof PsaIndex
   */
  lzClientHasTs?: boolean;
}
/**
 *
 * @export
 * @interface PsaSetStatus
 */
export interface PsaSetStatus {
  /**
   *
   * @type {string}
   * @memberof PsaSetStatus
   */
  status: string;
}
/**
 *
 * @export
 * @interface PsaWithClientLzAndScan
 */
export interface PsaWithClientLzAndScan {
  /**
   *
   * @type {number}
   * @memberof PsaWithClientLzAndScan
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientLzAndScan
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientLzAndScan
   */
  createdBy: number;
  /**
   *
   * @type {PsaStatus}
   * @memberof PsaWithClientLzAndScan
   */
  status: PsaStatus;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientLzAndScan
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientLzAndScan
   */
  lzName: string;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientLzAndScan
   */
  pzuId: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientLzAndScan
   */
  pzuName: string;
  /**
   *
   * @type {number}
   * @memberof PsaWithClientLzAndScan
   */
  lzClientId: number;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientLzAndScan
   */
  lzClientFullName: string;
  /**
   *
   * @type {Array<Pair>}
   * @memberof PsaWithClientLzAndScan
   */
  scans?: Array<Pair>;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientLzAndScan
   */
  psaInfo?: string;
  /**
   *
   * @type {EPaymentMethod}
   * @memberof PsaWithClientLzAndScan
   */
  paymentType?: EPaymentMethod;
  /**
   *
   * @type {string}
   * @memberof PsaWithClientLzAndScan
   */
  description?: string;
}
export interface PsaCompliance {
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  psaId: string;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  psaCreatedAt: string;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  pzuName: string;
  /**
   *
   * @type {number}
   * @memberof PsaCompliance
   */
  lzClientId: number;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  lzClientFullName: string;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  psaVirtualId?: string;
  /**
   *
   * @type {number}
   * @memberof PsaCompliance
   */
  priceScore?: number;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  lzClientPassportSn?: string;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  psaScanIndex?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  hour24Index?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  priceIndex?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof PsaCompliance
   */
  weightIndex?: TIndexType;
  /**
   *
   * @type {number}
   * @memberof PsaCompliance
   */
  lzClientPaymentAmount?: string;
  /**
   *
   * @type {number}
   * @memberof PsaCompliance
   */
  psaClassifierCode?: string;
}
/**
 *
 * @export
 * @interface PzuCreate
 */
export interface PzuCreate {
  /**
   *
   * @type {string}
   * @memberof PzuCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PzuCreate
   */
  address: string;
  /**
   *
   * @type {number}
   * @memberof PzuCreate
   */
  lzId: number;
  /**
   *
   * @type {PricingMethod}
   * @memberof PzuCreate
   */
  pricingMethod?: PricingMethod;
  /**
   *
   * @type {string}
   * @memberof PzuCreate
   */
  tag?: string;
}
/**
 *
 * @export
 * @interface PzuInfo
 */
export interface PzuInfo {
  /**
   *
   * @type {number}
   * @memberof PzuInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PzuInfo
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PzuInfo
   */
  address: string;
  /**
   *
   * @type {PricingMethod}
   * @memberof PzuInfo
   */
  pricingMethod: PricingMethod;
}
/**
 *
 * @export
 * @interface PzuUpdate
 */
export interface PzuUpdate {
  /**
   *
   * @type {string}
   * @memberof PzuUpdate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PzuUpdate
   */
  address: string;
  /**
   *
   * @type {boolean}
   * @memberof PzuUpdate
   */
  archived: boolean;
  /**
   *
   * @type {PricingMethod}
   * @memberof PzuUpdate
   */
  pricingMethod?: PricingMethod;
  /**
   *
   * @type {string}
   * @memberof PzuUpdate
   */
  tag?: string;
}
/**
 *
 * @export
 * @interface PzuUserInfo
 */
export interface PzuUserInfo {
  /**
   *
   * @type {number}
   * @memberof PzuUserInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PzuUserInfo
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof PzuUserInfo
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PzuUserInfo
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof PzuUserInfo
   */
  email: string;
  /**
   *
   * @type {UserStatus}
   * @memberof PzuUserInfo
   */
  status: UserStatus;
}
/**
 *
 * @export
 * @interface PzuWithLz
 */
export interface PzuWithLz {
  lzClientPaymentSum: any;
  successPaymentsCount: any;
  /**
   *
   * @type {number}
   * @memberof PzuWithLz
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PzuWithLz
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PzuWithLz
   */
  address: string;
  /**
   *
   * @type {number}
   * @memberof PzuWithLz
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof PzuWithLz
   */
  lzName: string;
  /**
   *
   * @type {PricingMethod}
   * @memberof PzuWithLz
   */
  pricingMethod: PricingMethod;
  /**
   *
   * @type {string}
   * @memberof PzuWithLz
   */
  tag?: string;
  /**
   *
   * @type {number}
   * @memberof PzuWithLz
   */
  dailyPaymentLimit?: number;
  /**
   *
   * @type {number}
   * @memberof PzuWithLz
   */
  weeklyPaymentLimit?: number;
  /**
   *
   * @type {number}
   * @memberof PzuWithLz
   */
  monthlyPaymentLimit?: number;
}
/**
 *
 * @export
 * @interface SuccessWrapper
 */
export interface SuccessWrapper {
  /**
   *
   * @type {boolean}
   * @memberof SuccessWrapper
   */
  success: boolean;
}
/**
 *
 * @export
 * @interface HasLzClientReport
 */
export interface HasLzClientReport {
  /**
   *
   * @type {boolean}
   * @memberof HasLzClientReport
   */
  bool: boolean;
}
/**
 *
 * @export
 * @interface UrlWrapper
 */
export interface UrlWrapper {
  /**
   *
   * @type {string}
   * @memberof UrlWrapper
   */
  url: string;
}
/**
 *
 * @export
 * @interface UserCreate
 */
export interface UserCreate {
  /**
   *
   * @type {number}
   * @memberof UserCreate
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof UserCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserCreate
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof UserCreate
   */
  patronymic?: string;
  /**
   *
   * @type {string}
   * @memberof UserCreate
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserCreate
   */
  phone?: string;
  /**
   *
   * @type {Array<UserRole>}
   * @memberof UserCreate
   */
  roles: Array<UserRole>;
  /**
   *
   * @type {boolean}
   * @memberof UserCreate
   */
  isWebAllowed: boolean;
  /**
   *
   * @type {number}
   * @memberof UserCreate
   */
  maxPaymentAmount?: number;
  /**
   *
   * @type {IPricingMethod}
   * @memberof UserCreate
   */
  pricingMethod?: IPricingMethod;
}
/**
 *
 * @export
 * @interface UserInfoWithLz
 */
export interface UserInfoWithLz {
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLz
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLz
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLz
   */
  name: string;
  /**
   *
   * @type {Array<UserRole>}
   * @memberof UserInfoWithLz
   */
  roles: Array<UserRole>;
  /**
   *
   * @type {UserStatus}
   * @memberof UserInfoWithLz
   */
  status: UserStatus;
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLz
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLz
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLz
   */
  patronymic?: string;
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLz
   */
  maxPaymentAmount?: number;
}
/**
 *
 * @export
 * @interface UserInfoWithLzV2
 */
export interface UserInfoWithLzV2 {
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLzV2
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzV2
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzV2
   */
  name: string;
  /**
   *
   * @type {Array<UserRole>}
   * @memberof UserInfoWithLzV2
   */
  roles: Array<UserRole>;
  /**
   *
   * @type {UserStatus}
   * @memberof UserInfoWithLzV2
   */
  status: UserStatus;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzV2
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzV2
   */
  phone: string;
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLzV2
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzV2
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzV2
   */
  patronymic?: string;
  /**
   *
   * @type {Pair[]}
   * @memberof UserInfoWithLzV2
   */
  pzus?: Pair[];
  /**
   *
   * @type {boolean}
   * @memberof UserInfoWithLzV2
   */
  isWebAllowed: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserInfoWithLzV2
   */
  isSmsRequired?: boolean;
}
/**
 *
 * @export
 * @interface UserInfoWithLzPzus
 */
export interface UserInfoWithLzPzus {
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLzPzus
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzPzus
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzPzus
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzPzus
   */
  patronymic?: string;
  /**
   *
   * @type {Array<UserRole>}
   * @memberof UserInfoWithLzPzus
   */
  roles: Array<UserRole>;
  /**
   *
   * @type {UserStatus}
   * @memberof UserInfoWithLzPzus
   */
  status: UserStatus;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzPzus
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzPzus
   */
  phone?: string;
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLzPzus
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof UserInfoWithLzPzus
   */
  lzName: string;
  /**
   *
   * @type {Array<Pair>}
   * @memberof UserInfoWithLzPzus
   */
  pzus?: Array<Pair>;
  /**
   *
   * @type {boolean}
   * @memberof UserInfoWithLzPzus
   */
  isWebAllowed: boolean;
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLzPzus
   */
  avatarId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UserInfoWithLzPzus
   */
  isSmsRequired?: boolean;
  /**
   *
   * @type {number}
   * @memberof UserInfoWithLzPzus
   */
  maxPaymentAmount?: number;
  /**
   *
   * @type {IPricingMethod}
   * @memberof UserInfoWithLzPzus
   */
  pricingMethod?: IPricingMethod;
  /**
   *
   * @type {LoginTwoFactorMode}
   * @memberof UserInfoWithLzPzus
   */
  loginTwoFactorMode: LoginTwoFactorMode;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum UserRole {
  AppAdmin = 'ROLE_APP_ADMIN',
  LzAdmin = 'ROLE_LZ_ADMIN',
  PzuInspector = 'ROLE_PZU_INSPECTOR',
  PzuCashier = 'ROLE_PZU_CASHIER',
  LzAccountant = 'ROLE_LZ_ACCOUNTANT',
  AppViewer = 'ROLE_COMPLIANCE_OFFICER',
  TechSupport = 'ROLE_TECH_SUPPORT',
}

/**
 *
 * @export
 * @interface UserSetRoles
 */
export interface UserSetRoles {
  /**
   *
   * @type {Array<UserRole>}
   * @memberof UserSetRoles
   */
  roles: Array<UserRole>;
}
/**
 *
 * @export
 * @interface UserSetStatus
 */
export interface UserSetStatus {
  /**
   *
   * @type {UserStatus}
   * @memberof UserSetStatus
   */
  status: UserStatus;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum UserStatus {
  ExpiredCredentials = 'EXPIRED_CREDENTIALS',
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
}

/**
 *
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
  /**
   *
   * @type {number}
   * @memberof UserUpdate
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof UserUpdate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserUpdate
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof UserUpdate
   */
  patronymic?: string;
  /**
   *
   * @type {string}
   * @memberof UserUpdate
   */
  phone?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserUpdate
   */
  isWebAllowed: boolean;
  /**
   *
   * @type {number}
   * @memberof UserUpdate
   */
  maxPaymentAmount?: number;
  /**
   *
   * @type {IPricingMethod}
   * @memberof UserUpdate
   */
  pricingMethod?: IPricingMethod;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum ReportType {
  REPORT_PAYMENTS = 'REPORT_PAYMENTS',
  REPORT_LZ_PAYMENT_AMOUNTS = 'REPORT_LZ_PAYMENT_AMOUNTS',
}

/**
 *
 * @export
 * @enum {string}
 */
export enum MailSchedule {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
}

/**
 *
 * @export
 * @interface MailListCreate
 */
export interface MailListCreate {
  /**
   *
   * @type {number}
   * @memberof MailListCreate
   */
  lzId: number;
  /**
   *
   * @type {boolean}
   * @memberof MailListCreate
   */
  active: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof MailListCreate
   */
  reportType: ReportType;
  /**
   *
   * @type {MailSchedule}
   * @memberof MailListCreate
   */
  mailSchedule: MailSchedule;
  /**
   *
   * @type {string[]}
   * @memberof MailListCreate
   */
  ccList?: string[];
}
/**
 *
 * @export
 * @interface MailList
 */
export interface MailList {
  /**
   *
   * @type {number}
   * @memberof MailList
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof MailList
   */
  lzId: number;
  /**
   *
   * @type {number}
   * @memberof MailList
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof MailList
   */
  createdAt: string;
  /**
   *
   * @type {boolean}
   * @memberof MailList
   */
  active: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof MailList
   */
  reportType: ReportType;
  /**
   *
   * @type {MailSchedule}
   * @memberof MailList
   */
  mailSchedule: MailSchedule;
  /**
   *
   * @type {string}
   * @memberof MailList
   */
  executedAt?: string;
  /**
   *
   * @type {string}
   * @memberof MailList
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof MailList
   */
  email: string;
  /**
   *
   * @type {string[]}
   * @memberof MailList
   */
  ccList: string[];
}
/**
 *
 * @export
 * @interface PageWrapperMailLists
 */
export interface PageWrapperMailLists {
  /**
   *
   * @type {number}
   * @memberof PageWrapperMailLists
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperMailLists
   */
  rowCount: number;
  /**
   *
   * @type {Array<MailList>}
   * @memberof PageWrapperMailLists
   */
  elements?: Array<MailList>;
}
/**
 *
 * @export
 * @interface MailListUpdate
 */
export interface MailListUpdate {
  /**
   *
   * @type {boolean}
   * @memberof LzUpdate
   */
  active: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof LzUpdate
   */
  reportType: ReportType;
  /**
   *
   * @type {MailSchedule}
   * @memberof LzUpdate
   */
  mailSchedule: MailSchedule;
  /**
   *
   * @type {string[]}
   * @memberof MailList
   */
  ccList?: string[];
}
/**
 *
 * @export
 * @interface PageWrapperTransactionsList
 */
export interface PageWrapperTransactionsList {
  /**
   *
   * @type {number}
   * @memberof PageWrapperTransactionsList
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperTransactionsList
   */
  rowCount: number;
  /**
   *
   * @type {Array<TransactionInfo>}
   * @memberof PageWrapperTransactionsList
   */
  elements?: Array<TransactionInfo>;
}
/**
 *
 * @export
 * @interface PageWrapperLsList
 */
export interface PageWrapperLsList {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLsList
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLsList
   */
  rowCount: number;
  /**
   *
   * @type {Array<TransactionInfo>}
   * @memberof PageWrapperLsList
   */
  elements?: Array<LsInfo>;
}
/**
 *
 * @export
 * @interface PageWrapperLsTransactionList
 */
export interface PageWrapperLsTransactionList {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLsList
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLsList
   */
  rowCount: number;
  /**
   *
   * @type {Array<TransactionInfo>}
   * @memberof PageWrapperLsList
   */
  elements?: Array<LsTransactionInfo>;
}
export interface PageWrapperLsTransactionList {
  /**
   *
   * @type {number}
   * @memberof PageWrapperLsList
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperLsList
   */
  rowCount: number;
  /**
   *
   * @type {Array<TransactionInfo>}
   * @memberof PageWrapperLsList
   */
  elements?: Array<LsTransactionInfo>;
}
/**
 *
 * @export
 * @interface ComplianceLzData
 */
export interface ComplianceLzData {
  /**
   *
   * @type {number}
   * @memberof ComplianceLzData
   */
  lzId: number;
  /**
   *
   * @type {number}
   * @memberof ComplianceLzData
   */
  paymentCount: number;
  /**
   *
   * @type {number}
   * @memberof ComplianceLzData
   */
  paymentSumVolume: number;
  /**
   *
   * @type {number}
   * @memberof ComplianceLzData
   */
  paymentAvgVolume: number;
  /**
   *
   * @type {string}
   * @memberof ComplianceLzData
   */
  paymentPeriod: string;
}
/**
 *
 * @export
 * @interface TransactionInfo
 */
export interface TransactionInfo {
  /**
   *
   * @type {number}
   * @memberof TransactionInfo
   */
  psaId: number;
  /**
   *
   * @type {string}
   * @memberof TransactionInfo
   */
  psaCreatedAt: string;
  /**
   *
   * @type {string}
   * @memberof TransactionInfo
   */
  lzClientPassportSn: string;
  /**
   *
   * @type {string}
   * @memberof TransactionInfo
   */
  psaVirtualId: string;
  /**
   *
   * @type {number}
   * @memberof TransactionInfo
   */
  lzClientPaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof TransactionInfo
   */
  lzClientId: number;
  /**
   *
   * @type {number}
   * @memberof TransactionInfo
   */
  lzClientFullName: string;
  /**
   *
   * @type {string}
   * @memberof TransactionInfo
   */
  lzClientInn: string;
  /**
   *
   * @type {number}
   * @memberof TransactionInfo
   */
  pzuName: string;
  /**
   *
   * @type {boolean}
   * @memberof TransactionInfo
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof TransactionInfo
   */
  hasPsaScan: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TransactionInfo
   */
  hasPassportScan: boolean;
  /**
   *
   * @type {number}
   * @memberof TransactionInfo
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof TransactionInfo
   */
  inn: number;
  /**
   *
   * @type {string}
   * @memberof TransactionInfo
   */
  businessAddress: string;
}
/**
 *
 * @export
 * @interface LsInfo
 */
export interface LsInfo {
  /**
   *
   * @type {array}
   * @memberof LsInfo
   */
  fullNames: Array<Record<string, unknown>>;
  /**
   *
   * @type {number}
   * @memberof LsInfo
   */
  paymentSum: number;
  /**
   *
   * @type {number}
   * @memberof LsInfo
   */
  paymentCount: number;
  /**
   *
   * @type {number}
   * @memberof LsInfo
   */
  blackMetalWeight: number;
  /**
   *
   * @type {number}
   * @memberof LsInfo
   */
  colorMetalWeight: number;
  /**
   *
   * @type {number}
   * @memberof LsInfo
   */
  wastePaperWeight: number;
  /**
   *
   * @type {array}
   * @memberof LsInfo
   */
  passportSns: Array<Record<string, unknown>>;
  /**
   *
   * @type {string}
   * @memberof LsInfo
   */
  passportSn: string;
  /**
   *
   * @type {boolean}
   * @memberof LsInfo
   */
  hasPassportScan: boolean;
  /**
   *
   * @type {number}
   * @memberof LsInfo
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof LsInfo
   */
  passportScanId: number;
  /**
   *
   * @type {string}
   * @memberof LsInfo
   */
  lzClientIndex?: string;
}

export interface LsIndex {
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  weight30Index?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  weight92Index?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  weight183Index?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  weight365Index?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  lzClientIndex?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  weightTotalIndex?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  locationIndex?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  fakePassportIndex?: TIndexType;
  /**
   *
   * @type {string}
   * @memberof LsIndex
   */
  fullName?: string;
}
/**
 *
 * @export
 * @interface LsTransactionInfo
 */
export interface LsTransactionInfo {
  /**
   *
   * @type {number}
   * @memberof LsTransactionInfo
   */
  lzClientId: number;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  lzClientPassportSn: string;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  lzClientFullName: string;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  lzName: string;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  pzuName: string;
  /**
   *
   * @type {number}
   * @memberof LsTransactionInfo
   */
  psaId: number;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  psaCreatedAt: string;
  /**
   *
   * @type {number}
   * @memberof LsTransactionInfo
   */
  lzClientPaymentAmount: number;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  psaClassifierCode: string;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  lzClientTransportBrand: string;
  /**
   *
   * @type {string}
   * @memberof LsTransactionInfo
   */
  lzClientTransportNumber: string;
}
/**
 *
 * @export
 * @interface NewsCreate
 */
export interface NewsCreate {
  /**
   *
   * @type {string}
   * @memberof NewsCreate
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof NewsCreate
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof NewsCreate
   */
  link?: string;
  /**
   *
   * @type {string}
   * @memberof NewsCreate
   */
  newsType?: string;
}
/**
 *
 * @export
 * @interface NewsCurrent
 */
export interface NewsCurrent {
  /**
   *
   * @type {number}
   * @memberof NewsCurrent
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof NewsCurrent
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof NewsCurrent
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof NewsCurrent
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof NewsCreate
   */
  link?: string;
}
/**
 *
 * @export
 * @interface NewsUpdate
 */
export interface NewsUpdate {
  /**
   *
   * @type {string}
   * @memberof NewsUpdate
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof NewsUpdate
   */
  text: string;
  /**
   *
   * @type {boolean}
   * @memberof NewsUpdate
   */
  archived: boolean;
  /**
   *
   * @type {string}
   * @memberof NewsCreate
   */
  link?: string;
  /**
   *
   * @type {string}
   * @memberof NewsCreate
   */
  newsType?: string;
}
/**
 *
 * @export
 * @interface PageWrapperNews
 */
export interface PageWrapperNews {
  /**
   *
   * @type {number}
   * @memberof PageWrapperNews
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperNews
   */
  rowCount: number;
  /**
   *
   * @type {Array<NewsCurrent>}
   * @memberof PageWrapperNews
   */
  elements?: Array<NewsCurrent>;
}
/**
 *
 * @export
 * @interface DocumentInfo
 */
export interface DocumentInfo {
  /**
   *
   * @type {number}
   * @memberof DocumentInfo
   */
  id: number;
  /**
   *
   * @type {DocumentsTypes}
   * @memberof DocumentInfo
   */
  type: DocumentsTypes;
  /**
   *
   * @type {string}
   * @memberof DocumentInfo
   */
  name: string;
}
/**
 *
 * @export
 * @interface DocumentInfo
 */
export interface ComplianceDocumentInfo {
  /**
   *
   * @type {string}
   * @memberof DocumentInfo
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof DocumentInfo
   */
  externalId: string;
  /**
   *
   * @type {string}
   * @memberof DocumentInfo
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof DocumentInfo
   */
  issuedAt: string;
  /**
   *
   * @type {string}
   * @memberof DocumentInfo
   */
  expiresAt: string;
}
/**
 *
 * @export
 * @interface CounterpartyReportInfo
 */
export interface CounterpartyReportInfo {
  /**
   *
   * @type {number}
   * @memberof CounterpartyReportInfo
   */
  reportId: number;
  /**
   *
   * @type {number}
   * @memberof CounterpartyReportInfo
   */
  userId: number;
  /**
   *
   * @type {number}
   * @memberof CounterpartyReportInfo
   */
  lzId: number;
  /**
   *
   * @type {UserRole}
   * @memberof CounterpartyReportInfo
   */
  userRole: UserRole;
  /**
   *
   * @type {number}
   * @memberof CounterpartyReportInfo
   */
  counterpartyId: number;
  /**
   *
   * @type {string}
   * @memberof CounterpartyReportInfo
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CounterpartyReportInfo
   */
  inn: string;
  /**
   *
   * @type {string}
   * @memberof CounterpartyReportInfo
   */
  reportDate: string;
  /**
   *
   * @type {number}
   * @memberof CounterpartyReportInfo
   */
  pdfLength: number;
}
/**
 *
 * @export
 * @interface CounterpartyReports
 */
export interface CounterpartyReports {
  /**
   *
   * @type {string}
   * @memberof CounterpartyReports
   */
  startDate: string;
  /**
   *
   * @type {string}
   * @memberof CounterpartyReports
   */
  endDate: string;
  /**
   *
   * @type {number}
   * @memberof CounterpartyReports
   */
  checksLeft: number;
  /**
   *
   * @type {CounterpartyReportInfo[]}
   * @memberof CounterpartyReports
   */
  reports: CounterpartyReportInfo[];
}
/**
 *
 * @export
 * @interface IVehicleInfo
 */
export interface IVehicleInfo {
  /**
   *
   * @type {string}
   * @memberof IVehicleInfo
   */
  number: string;
  /**
   *
   * @type {string}
   * @memberof IVehicleInfo
   */
  brand: string;
  /**
   *
   * @type {string}
   * @memberof IVehicleInfo
   */
  model: string;
  /**
   *
   * @type {number}
   * @memberof IVehicleInfo
   */
  loadCapacity: number;
  /**
   *
   * @type {number}
   * @memberof IVehicleInfo
   */
  vehicleCheckId: number;
}
//

export type ComplianceSettings = Record<string, number>;

/**
 *
 * @export
 * @interface IVehicleModel
 */
export interface IVehicleModel {
  /**
   *
   * @type {string}
   * @memberof IVehicleModel
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IVehicleModel
   */
  name: string;
}

/**
 *
 * @export
 * @interface ComplianceSettingsHistory
 */
export interface ComplianceSettingsHistory {
  /**
   *
   * @type {number}
   * @memberof ComplianceSettingsHistory
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof ComplianceSettingsHistory
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof ComplianceSettingsHistory
   */
  createdBy: number;
  /**
   *
   * @type {string}
   * @memberof ComplianceSettingsHistory
   */
  userName: string;
}

export interface GroupCommissionPayment {
  /**
   *
   * @type {number}
   * @memberof GroupCommissionPayment
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof GroupCommissionPayment
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof GroupCommissionPayment
   */
  status: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof GroupCommissionPayment
   */
  errorMessage?: string;
  /**
   *
   * @type {number}
   * @memberof GroupCommissionPayment
   */
  spFeePaymentAmount?: number;
  /**
   *
   * @type {string}
   * @memberof GroupCommissionPayment
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof GroupCommissionPayment
   */
  businessCardId: number;
  /**
   *
   * @type {number}
   * @memberof GroupCommissionPayment
   */
  lzId: number;
  /**
   *
   * @type {string}
   * @memberof GroupCommissionPayment
   */
  businessCardName: string;
}

export interface PageWrapperGroupCommissionPayment {
  /**
   *
   * @type {number}
   * @memberof PageWrapperNews
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperNews
   */
  rowCount: number;
  /**
   *
   * @type {Array<NewsCurrent>}
   * @memberof PageWrapperNews
   */
  elements?: Array<GroupCommissionPayment>;
}

export interface SberIdPayments {
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  psaId: number;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  lzClientPaymentAmount: number;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  sberApiCommissionAmount: number;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  createdAt: string;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  status: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof SberIdPayments
   */
  errorMessage?: string;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  spFeePaymentAmount?: number;
  /**
   *
   * @type {string}
   * @memberof SberIdPayments
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof SberIdPayments
   */
  lzName?: string;
  /**
   *
   * @type {string}
   * @memberof SberIdPayments
   */
  psaInfo?: string;
  /**
   *
   * @type {string}
   * @memberof SberIdPayments
   */
  pzuName?: string;
  /**
   *
   * @type {string}
   * @memberof SberIdPayments
   */
  clientFullName?: string;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  businessCardId: number;
  /**
   *
   * @type {number}
   * @memberof SberIdPayments
   */
  lzId: number;
}

export interface PageWrapperSberIdPayments {
  /**
   *
   * @type {number}
   * @memberof PageWrapperSberIdPayments
   */
  pageCount: number;
  /**
   *
   * @type {number}
   * @memberof PageWrapperSberIdPayments
   */
  rowCount: number;
  /**
   *
   * @type {Array<SberIdPayments>}
   * @memberof PageWrapperSberIdPayments
   */
  elements?: Array<SberIdPayments>;
}
export interface VendorSettings {
  /**
   *
   * @type {string}
   * @memberof VendorSettings
   */
  updatedAt?: string;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettings
   */
  fnsEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettings
   */
  idxEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettings
   */
  prizmaEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettings
   */
  dtbGatewayEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettings
   */
  sberapiGatewayEnabled?: boolean;
}
export interface VendorSettingsUpdate {
  /**
   *
   * @type {boolean}
   * @memberof VendorSettingsUpdate
   */
  fnsEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettingsUpdate
   */
  idxEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettingsUpdate
   */
  prizmaEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettingsUpdate
   */
  dtbGatewayEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof VendorSettingsUpdate
   */
  sberapiGatewayEnabled: boolean;
}

export interface LzClientTransportCreate {
  /**
   *
   * @type {string}
   * @memberof LzClientTransportCreate
   */
  number: string;
  /**
   *
   * @type {boolean}
   * @memberof LzClientTransportCreate
   */
  brand?: string;
  /**
   *
   * @type {boolean}
   * @memberof LzClientTransportCreate
   */
  brandId?: number;
}
export interface LzClientTransportInfo {
  /**
   *
   * @type {number}
   * @memberof LzClientTransportInfo
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof LzClientTransportInfo
   */
  number: string;
  /**
   *
   * @type {boolean}
   * @memberof LzClientTransportInfo
   */
  brand?: string;
  /**
   *
   * @type {boolean}
   * @memberof LzClientTransportInfo
   */
  brandId?: number;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum CertificateStatus {
  ACCEPTED = 'ACCEPTED',
  CHECKERROR = 'CHECKERROR',
  CREATED = 'CREATED',
  DELIVERED = 'DELIVERED',
  EXPORTED = 'EXPORTED',
  PROCESSED = 'PROCESSED',
  PUBLISHED_BY_BANK = 'PUBLISHED_BY_BANK',
  READY_TO_SEND = 'READY_TO_SEND',
  REFUSEDBYBANK = 'REFUSEDBYBANK',
  REQUISITEERROR = 'REQUISITEERROR',
  TRIED = 'TRIED',
  WAIT_FOR_APPROVE = 'WAIT_FOR_APPROVE',
}

export interface SberIdStatus {
  /**
   *
   * @type {number}
   * @memberof SberIdStatus
   */
  lzId: number;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  hasSberIdClientId?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  hasSberIdClientSecret?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  hasSberIdClientLogin?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  hasTlsClientCertPassword?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  hasTlsClientCert?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  isRefreshTokenValid?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  isUserInfoValid?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  isEdsCsrSent?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SberIdStatus
   */
  isEdsActivated?: boolean;
  /**
   *
   * @type {CertificateStatus}
   * @memberof SberIdStatus
   */
  edsStatus?: CertificateStatus;
}
/**
 *
 * @export
 * @interface SberIdUserInfo
 */
export interface SberIdUserInfo {
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  clientFullName?: string;
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  clientEmail: string;
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  clientOrgName: string;
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  clientOrgUnit: string;
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  clientUserPosition: string;
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  sberIdClientLogin: string;
}
/**
 *
 * @export
 * @interface SberIdUserInfoUpdate
 */
export interface SberIdUserInfoUpdate {
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  sberIdClientLogin?: string;
}
/**
 *
 * @export
 * @interface SberIdEdsInfo
 */
export interface SberIdEdsInfo {
  /**
   *
   * @type {number}
   * @memberof SberIdUserInfo
   */
  lzId: number;
  /**
   *
   * @type {CertificateStatus}
   * @memberof SberIdUserInfo
   */
  edsStatus: CertificateStatus;
  /**
   *
   * @type {string}
   * @memberof SberIdUserInfo
   */
  edsExpiresAt: string;
}
/**
 *
 * @export
 * @interface CertificateStatusWrapper
 */
export interface CertificateStatusWrapper {
  /**
   *
   * @type {string}
   * @memberof CertificateStatusWrapper
   */
  status?: CertificateStatus;
  /**
   *
   * @type {string}
   * @memberof CertificateStatusWrapper
   */
  statusText?: string;
  /**
   *
   * @type {boolean}
   * @memberof CertificateStatusWrapper
   */
  final: boolean;
}
/**
 *
 * @export
 * @interface CertificateStatusWrapper
 */
export interface CertificateStatusWrapper1 {
  /**
   *
   * @type {string}
   * @memberof CertificateStatusWrapper
   */
  status?: CertificateStatus;
}
/**
 *
 * @export
 * @interface LzClientPaymentPhoneInfo
 */
export interface LzClientPaymentPhoneInfo {
  /**
   *
   * @type {number}
   * @memberof CertificateStatusWrapper
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof CertificateStatusWrapper
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof CertificateStatusWrapper
   */
  bankBrand: string;
}
/**
 *
 * @export
 * @interface LzClientPaymentPhoneCreate
 */
export interface LzClientPaymentPhoneCreate {
  /**
   *
   * @type {string}
   * @memberof LzClientPaymentPhoneCreate
   */
  phone: string;
}
/**
 *
 * @export
 * @interface CommissionResponse
 */
export interface CommissionResponse {
  /**
   *
   * @type {string}
   * @memberof CommissionResponse
   */
  commission?: string;
  /**
   *
   * @type {string}
   * @memberof CommissionResponse
   */
  receiverFullName?: string;
}
/**
 *
 * @export
 * @interface PasswordRestoreSendSms
 */
export interface PasswordRestoreSendSms {
  /**
   *
   * @type {string}
   * @memberof PasswordRestoreSendSms
   */
  token: string;
}
/**
 *
 * @export
 * @interface 	UserSetLoginTwoFactorMode
 */
export interface UserSetLoginTwoFactorMode {
  /**
   *
   * @type {LoginTwoFactorMode}
   * @memberof 	UserSetLoginTwoFactorMode
   */
  mode: LoginTwoFactorMode;
}
/**
 *
 * @export
 * @interface 	PzuSetPaymentLimits
 */
export interface PzuSetPaymentLimits {
  /**
   *
   * @type {number}
   * @memberof 	PzuSetPaymentLimits
   */
  dailyPaymentLimit?: number | null;
  /**
   *
   * @type {number}
   * @memberof 	PzuSetPaymentLimits
   */
  weeklyPaymentLimit?: number | null;
  /**
   *
   * @type {number}
   * @memberof 	PzuSetPaymentLimits
   */
  monthlyPaymentLimit?: number | null;
}
/**
 *
 * @export
 * @interface 	PzuPaymentLimitsBalance
 */
export interface PzuPaymentLimitsBalance {
  /**
   *
   * @type {number}
   * @memberof 	PzuPaymentLimitsBalance
   */
  dailyPaymentLimit?: number | null;
  /**
   *
   * @type {number}
   * @memberof 	PzuPaymentLimitsBalance
   */
  weeklyPaymentLimit?: number | null;
  /**
   *
   * @type {number}
   * @memberof 	PzuPaymentLimitsBalance
   */
  monthlyPaymentLimit?: number | null;
  /**
   *
   * @type {number}
   * @memberof 	PzuPaymentLimitsBalance
   */
  dailyPaymentSum?: number | null;
  /**
   *
   * @type {number}
   * @memberof 	PzuPaymentLimitsBalance
   */
  weeklyPaymentSum?: number | null;
  /**
   *
   * @type {number}
   * @memberof 	PzuPaymentLimitsBalance
   */
  monthlyPaymentSum?: number | null;
}
/**
 * AuthControllerApi - axios parameter creator
 * @export
 */
export const AuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {PasswordForgot} passwordForgot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword: async (passwordForgot: PasswordForgot, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'passwordForgot' is not null or undefined
      if (passwordForgot === null || passwordForgot === undefined) {
        throw new RequiredError(
          'passwordForgot',
          'Required parameter passwordForgot was null or undefined when calling forgotPassword.',
        );
      }
      const localVarPath = `/auth/forgot-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof passwordForgot !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(passwordForgot !== undefined ? passwordForgot : {})
        : passwordForgot || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Login} [login]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login: async (login?: Login, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['X-User-Platform'] = 'WEB';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof login !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(login !== undefined ? login : {}) : login || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/refresh-token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Refresh-Token required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Refresh-Token')
            : await configuration.apiKey;
        localVarHeaderParameter['Refresh-Token'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PasswordRestore} passwordRestore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    restorePassword: async (passwordRestore: PasswordRestore, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'passwordRestore' is not null or undefined
      if (passwordRestore === null || passwordRestore === undefined) {
        throw new RequiredError(
          'passwordRestore',
          'Required parameter passwordRestore was null or undefined when calling restorePassword.',
        );
      }
      const localVarPath = `/auth/restore-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['Referrer-Policy'] = 'no-referer';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof passwordRestore !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(passwordRestore !== undefined ? passwordRestore : {})
        : passwordRestore || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Login} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    restorePasswordSmsCode: async (token: PasswordRestoreSendSms, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/restore-password/sms-code`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarHeaderParameter['X-User-Platform'] = 'WEB';
      localVarHeaderParameter['Referrer-Policy'] = 'no-referer';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof token !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(token !== undefined ? token : {}) : token || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthControllerApi - functional programming interface
 * @export
 */
export const AuthControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {PasswordForgot} passwordForgot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotPassword(
      passwordForgot: PasswordForgot,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await AuthControllerApiAxiosParamCreator(configuration).forgotPassword(
        passwordForgot,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {Login} [login]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login(
      login?: Login,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await AuthControllerApiAxiosParamCreator(configuration).login(login, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refreshToken(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await AuthControllerApiAxiosParamCreator(configuration).refreshToken(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {PasswordRestore} passwordRestore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async restorePassword(
      passwordRestore: PasswordRestore,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await AuthControllerApiAxiosParamCreator(configuration).restorePassword(
        passwordRestore,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {PasswordRestoreSendSms} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async restorePasswordSmsCode(
      token: PasswordRestoreSendSms,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ phone: string }>> {
      const localVarAxiosArgs = await AuthControllerApiAxiosParamCreator(configuration).restorePasswordSmsCode(
        token,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AuthControllerApi - factory interface
 * @export
 */
export const AuthControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {PasswordForgot} passwordForgot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(passwordForgot: PasswordForgot, options?: any): AxiosPromise<SuccessWrapper> {
      return AuthControllerApiFp(configuration)
        .forgotPassword(passwordForgot, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {Login} [login]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(login?: Login, options?: any): AxiosPromise<void> {
      return AuthControllerApiFp(configuration)
        .login(login, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(options?: any): AxiosPromise<void> {
      return AuthControllerApiFp(configuration)
        .refreshToken(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {PasswordRestore} passwordRestore
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    restorePassword(passwordRestore: PasswordRestore, options?: any): AxiosPromise<SuccessWrapper> {
      return AuthControllerApiFp(configuration)
        .restorePassword(passwordRestore, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {PasswordRestoreSendSms} [token]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    restorePasswordSmsCode(token: PasswordRestoreSendSms, options?: any): AxiosPromise<{ phone: string }> {
      return AuthControllerApiFp(configuration)
        .restorePasswordSmsCode(token, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
export class AuthControllerApi extends BaseAPI {
  /**
   *
   * @param {PasswordForgot} passwordForgot
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  public forgotPassword(passwordForgot: PasswordForgot, options?: any) {
    return AuthControllerApiFp(this.configuration)
      .forgotPassword(passwordForgot, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Login} [login]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  public login(login?: Login, options?: any) {
    return AuthControllerApiFp(this.configuration)
      .login(login, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  public refreshToken(options?: any) {
    return AuthControllerApiFp(this.configuration)
      .refreshToken(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PasswordRestore} passwordRestore
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  public restorePassword(passwordRestore: PasswordRestore, options?: any) {
    return AuthControllerApiFp(this.configuration)
      .restorePassword(passwordRestore, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * BusinessCardControllerApi - axios parameter creator
 * @export
 */
export const BusinessCardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {BusinessCardCreate} businessCardCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBusinessCard: async (
      lzId: number,
      businessCardCreate: BusinessCardCreate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling addBusinessCard.');
      }
      // verify required parameter 'businessCardCreate' is not null or undefined
      if (businessCardCreate === null || businessCardCreate === undefined) {
        throw new RequiredError(
          'businessCardCreate',
          'Required parameter businessCardCreate was null or undefined when calling addBusinessCard.',
        );
      }
      const localVarPath = `/lzs/{lzId}/business-cards`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof businessCardCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(businessCardCreate !== undefined ? businessCardCreate : {})
        : businessCardCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bindBusinessCard: async (pzuId: number, businessCardId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling bindBusinessCard.',
        );
      }
      // verify required parameter 'businessCardId' is not null or undefined
      if (businessCardId === null || businessCardId === undefined) {
        throw new RequiredError(
          'businessCardId',
          'Required parameter businessCardId was null or undefined when calling bindBusinessCard.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/business-cards/{businessCardId}`
        .replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)))
        .replace(`{${'businessCardId'}}`, encodeURIComponent(String(businessCardId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardListByPzuIdAndUserId: async (
      pzuId: number,
      userId: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling getBusinessCardListByPzuIdAndUserId.',
        );
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling getBusinessCardListByPzuIdAndUserId.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/users/{userId}/business-cards`
        .replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)))
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {number} [size]
     * @param {boolean} [blocked]
     * @param {Set<number>} [pzuIds]
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardPageWithPzusByLzId: async (
      lzId: number,
      page: number,
      size?: number,
      blocked?: boolean,
      pzuIds?: Set<number>,
      nameLike?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getBusinessCardPageWithPzusByLzId.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getBusinessCardPageWithPzusByLzId.',
        );
      }
      const localVarPath = `/lzs/{lzId}/business-cards`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (blocked !== undefined) {
        localVarQueryParameter['blocked'] = blocked;
      }

      if (pzuIds) {
        localVarQueryParameter['pzu-ids'] = pzuIds;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardWithPzus: async (businessCardId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'businessCardId' is not null or undefined
      if (businessCardId === null || businessCardId === undefined) {
        throw new RequiredError(
          'businessCardId',
          'Required parameter businessCardId was null or undefined when calling getBusinessCardWithPzus.',
        );
      }
      const localVarPath = `/business-cards/{businessCardId}`.replace(
        `{${'businessCardId'}}`,
        encodeURIComponent(String(businessCardId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentTotalByBusinessCardId: async (businessCardId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'businessCardId' is not null or undefined
      if (businessCardId === null || businessCardId === undefined) {
        throw new RequiredError(
          'businessCardId',
          'Required parameter businessCardId was null or undefined when calling getPaymentTotalByBusinessCardId.',
        );
      }
      const localVarPath = `/business-cards/{businessCardId}/payment-total-current`.replace(
        `{${'businessCardId'}}`,
        encodeURIComponent(String(businessCardId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardWithUsersPageByPzuId: async (
      pzuId: number,
      page: number,
      nameLike?: string,
      blocked?: boolean,
      size?: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling getBusinessCardWithUsersPageByPzuId.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getBusinessCardWithUsersPageByPzuId.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/business-cards`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      if (blocked !== undefined) {
        localVarQueryParameter['blocked'] = blocked;
      }

      if (size) {
        localVarQueryParameter['size'] = size;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {BooleanWrapper} booleanWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setBusinessCardBlocked: async (
      businessCardId: number,
      booleanWrapper: BooleanWrapper,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'businessCardId' is not null or undefined
      if (businessCardId === null || businessCardId === undefined) {
        throw new RequiredError(
          'businessCardId',
          'Required parameter businessCardId was null or undefined when calling setBusinessCardBlocked.',
        );
      }
      // verify required parameter 'booleanWrapper' is not null or undefined
      if (booleanWrapper === null || booleanWrapper === undefined) {
        throw new RequiredError(
          'booleanWrapper',
          'Required parameter booleanWrapper was null or undefined when calling setBusinessCardBlocked.',
        );
      }
      const localVarPath = `/business-cards/{businessCardId}/set-blocked`.replace(
        `{${'businessCardId'}}`,
        encodeURIComponent(String(businessCardId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof booleanWrapper !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(booleanWrapper !== undefined ? booleanWrapper : {})
        : booleanWrapper || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unbindBusinessCard: async (pzuId: number, businessCardId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling unbindBusinessCard.',
        );
      }
      // verify required parameter 'businessCardId' is not null or undefined
      if (businessCardId === null || businessCardId === undefined) {
        throw new RequiredError(
          'businessCardId',
          'Required parameter businessCardId was null or undefined when calling unbindBusinessCard.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/business-cards/{businessCardId}`
        .replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)))
        .replace(`{${'businessCardId'}}`, encodeURIComponent(String(businessCardId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {BusinessCardUpdate} businessCardUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBusinessCard: async (
      businessCardId: number,
      businessCardUpdate: BusinessCardUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'businessCardId' is not null or undefined
      if (businessCardId === null || businessCardId === undefined) {
        throw new RequiredError(
          'businessCardId',
          'Required parameter businessCardId was null or undefined when calling updateBusinessCard.',
        );
      }
      // verify required parameter 'businessCardUpdate' is not null or undefined
      if (businessCardUpdate === null || businessCardUpdate === undefined) {
        throw new RequiredError(
          'businessCardUpdate',
          'Required parameter businessCardUpdate was null or undefined when calling updateBusinessCard.',
        );
      }
      const localVarPath = `/business-cards/{businessCardId}`.replace(
        `{${'businessCardId'}}`,
        encodeURIComponent(String(businessCardId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof businessCardUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(businessCardUpdate !== undefined ? businessCardUpdate : {})
        : businessCardUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SberApiControllerApi - axios parameter creator
 * @export
 */
export const SberApiControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncToSberApi: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling addBusinessCard.');
      }
      const localVarPath = `/sber-id/lzs/{lzId}/sync-business-cards`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      localVarRequestOptions.data = { lzId };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    createSberPayment: async (
      psaId: number,
      paymentCreate: PaymentCreate,
      smsCode?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter psaId was null or undefined when calling createPayment.');
      }
      // verify required parameter 'paymentCreate' is not null or undefined
      if (paymentCreate === null || paymentCreate === undefined) {
        throw new RequiredError(
          'paymentCreate',
          'Required parameter paymentCreate was null or undefined when calling createPayment.',
        );
      }
      const localVarPath = `/sber-id/psas/{psaId}/payments`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (smsCode && smsCode !== '') {
        localVarQueryParameter['sms-code'] = smsCode;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof paymentCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(paymentCreate !== undefined ? paymentCreate : {})
        : paymentCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdUserInfoUpdate} userInfoUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSberIdUserInfo: async (
      lzId: number,
      userInfoUpdate: SberIdUserInfoUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createPayment.');
      }
      // verify required parameter 'paymentCreate' is not null or undefined
      if (userInfoUpdate === null || userInfoUpdate === undefined) {
        throw new RequiredError(
          'paymentCreate',
          'Required parameter paymentCreate was null or undefined when calling createPayment.',
        );
      }
      const localVarPath = `/sber-id/{lzId}/user-info`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof userInfoUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(userInfoUpdate !== undefined ? userInfoUpdate : {})
        : userInfoUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdTokenInfo: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getSberIdStatusData.',
        );
      }
      const localVarPath = `/sber-id/{lzId}/token-info`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdUserInfo: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getSberIdUserInfo.',
        );
      }
      const localVarPath = `/sber-id/{lzId}/user-info`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateSertificate: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createPayment.');
      }
      const localVarPath = `/sber-id/{lzId}/activate-certificate`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncBusinessCards: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling syncBusinessCards.',
        );
      }
      const localVarPath = `/sber-id/{lzId}/sync-business-cards`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCsr: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createCsr.');
      }
      const localVarPath = `/sber-id/{lzId}/create-csr`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCsr: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getSberIdUserInfo.',
        );
      }
      const localVarPath = `/sber-id/{lzId}/csr-pdf`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateEds: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling activateEds.');
      }
      const localVarPath = `/sber-id/{lzId}/activate-eds`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEdsStatus: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getEdsStatus.');
      }
      const localVarPath = `/sber-id/{lzId}/eds-status`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEdsInfo: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getEdsStatus.');
      }
      const localVarPath = `/sber-id/{lzId}/eds-info`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BusinessCardControllerApi - functional programming interface
 * @export
 */
export const BusinessCardControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {BusinessCardCreate} businessCardCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addBusinessCard(
      lzId: number,
      businessCardCreate: BusinessCardCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(configuration).addBusinessCard(
        lzId,
        businessCardCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bindBusinessCard(
      pzuId: number,
      businessCardId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(configuration).bindBusinessCard(
        pzuId,
        businessCardId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBusinessCardListByPzuIdAndUserId(
      pzuId: number,
      userId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pair>>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(
        configuration,
      ).getBusinessCardListByPzuIdAndUserId(pzuId, userId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {number} [size]
     * @param {boolean} [blocked]
     * @param {Set<number>} [pzuIds]
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBusinessCardPageWithPzusByLzId(
      lzId: number,
      page: number,
      size?: number,
      blocked?: boolean,
      pzuIds?: Set<number>,
      nameLike?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperBusinessCardWithPzus>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(
        configuration,
      ).getBusinessCardPageWithPzusByLzId(lzId, page, size, blocked, pzuIds, nameLike, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBusinessCardWithPzus(
      businessCardId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BusinessCardWithPzus>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(configuration).getBusinessCardWithPzus(
        businessCardId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentTotalByBusinessCardId(
      businessCardId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentTotalBusinessCard>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(
        configuration,
      ).getPaymentTotalByBusinessCardId(businessCardId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBusinessCardWithUsersPageByPzuId(
      pzuId: number,
      page: number,
      nameLike?: string,
      blocked?: boolean,
      size?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperBusinessCardWithUsers>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(
        configuration,
      ).getBusinessCardWithUsersPageByPzuId(pzuId, page, nameLike, blocked, size, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {BooleanWrapper} booleanWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setBusinessCardBlocked(
      businessCardId: number,
      booleanWrapper: BooleanWrapper,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(configuration).setBusinessCardBlocked(
        businessCardId,
        booleanWrapper,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unbindBusinessCard(
      pzuId: number,
      businessCardId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(configuration).unbindBusinessCard(
        pzuId,
        businessCardId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} businessCardId
     * @param {BusinessCardUpdate} businessCardUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateBusinessCard(
      businessCardId: number,
      businessCardUpdate: BusinessCardUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await BusinessCardControllerApiAxiosParamCreator(configuration).updateBusinessCard(
        businessCardId,
        businessCardUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const SberApiControllerApiFb = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async syncToSberId(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).syncToSberApi(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {string} smsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createSberPayment(
      psaId: number,
      paymentCreate: PaymentCreate,
      smsCode?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).createSberPayment(
        psaId,
        paymentCreate,
        smsCode,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSberIdTokenInfo(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SberIdStatus>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).getSberIdTokenInfo(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSberIdUserInfo(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SberIdUserInfo>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).getSberIdUserInfo(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdUserInfoUpdate} updateUserInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSberIdUserInfo(
      lzId: number,
      updateUserInfo: SberIdUserInfoUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).updateSberIdUserInfo(
        lzId,
        updateUserInfo,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activateSertificate(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).activateSertificate(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async syncBusinessCards(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).syncBusinessCards(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCsr(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateStatusWrapper>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).createCsr(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCsr(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<[string]>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).getCsr(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activateEds(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateStatusWrapper>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).activateEds(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEdsStatus(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertificateStatusWrapper1>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).getEdsStatus(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEdsInfo(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SberIdEdsInfo>> {
      const localVarAxiosArgs = await SberApiControllerApiAxiosParamCreator(configuration).getEdsInfo(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * BusinessCardControllerApi - factory interface
 * @export
 */
export const BusinessCardControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {BusinessCardCreate} businessCardCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addBusinessCard(lzId: number, businessCardCreate: BusinessCardCreate, options?: any): AxiosPromise<IdWrapper> {
      return BusinessCardControllerApiFp(configuration)
        .addBusinessCard(lzId, businessCardCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bindBusinessCard(pzuId: number, businessCardId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return BusinessCardControllerApiFp(configuration)
        .bindBusinessCard(pzuId, businessCardId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardListByPzuIdAndUserId(pzuId: number, userId: number, options?: any): AxiosPromise<Array<Pair>> {
      return BusinessCardControllerApiFp(configuration)
        .getBusinessCardListByPzuIdAndUserId(pzuId, userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {number} [size]
     * @param {boolean} [blocked]
     * @param {Set<number>} [pzuIds]
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardPageWithPzusByLzId(
      lzId: number,
      page: number,
      size?: number,
      blocked?: boolean,
      pzuIds?: Set<number>,
      nameLike?: string,
      options?: any,
    ): AxiosPromise<PageWrapperBusinessCardWithPzus> {
      return BusinessCardControllerApiFp(configuration)
        .getBusinessCardPageWithPzusByLzId(lzId, page, size, blocked, pzuIds, nameLike, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardWithPzus(businessCardId: number, options?: any): AxiosPromise<BusinessCardWithPzus> {
      return BusinessCardControllerApiFp(configuration)
        .getBusinessCardWithPzus(businessCardId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentTotalByBusinessCardId(businessCardId: number, options?: any): AxiosPromise<PaymentTotalBusinessCard> {
      return BusinessCardControllerApiFp(configuration)
        .getPaymentTotalByBusinessCardId(businessCardId, options)
        .then(request => request(axios, basePath))
        .catch(Err => {
          if (Err.code === 3000) {
            throw Error('По данной карте нет платежей с начала месяца');
          } else if (Err.code === 5003) {
            throw Error('Карта не выбрана');
          }
          throw Err;
        });
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBusinessCardWithUsersPageByPzuId(
      pzuId: number,
      page: number,
      nameLike?: string,
      blocked?: boolean,
      size?: number,
      options?: any,
    ): AxiosPromise<PageWrapperBusinessCardWithUsers> {
      return BusinessCardControllerApiFp(configuration)
        .getBusinessCardWithUsersPageByPzuId(pzuId, page, nameLike, blocked, size, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} businessCardId
     * @param {BooleanWrapper} booleanWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setBusinessCardBlocked(
      businessCardId: number,
      booleanWrapper: BooleanWrapper,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return BusinessCardControllerApiFp(configuration)
        .setBusinessCardBlocked(businessCardId, booleanWrapper, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} businessCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unbindBusinessCard(pzuId: number, businessCardId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return BusinessCardControllerApiFp(configuration)
        .unbindBusinessCard(pzuId, businessCardId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} businessCardId
     * @param {BusinessCardUpdate} businessCardUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBusinessCard(
      businessCardId: number,
      businessCardUpdate: BusinessCardUpdate,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return BusinessCardControllerApiFp(configuration)
        .updateBusinessCard(businessCardId, businessCardUpdate, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const SberApiControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncToSber(lzId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return SberApiControllerApiFb(configuration)
        .syncToSberId(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {PaymentCreate} paymentCreate
     * @param {string} smsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSberPayment(psaId: number, paymentCreate: PaymentCreate, smsCode?: string) {
      return SberApiControllerApiFb(configuration)
        .createSberPayment(psaId, paymentCreate, smsCode)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdTokenInfo(lzId: number, options?: any): AxiosPromise<SberIdStatus> {
      return SberApiControllerApiFb(configuration)
        .getSberIdTokenInfo(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdUserInfo(lzId: number, options?: any): AxiosPromise<SberIdUserInfo> {
      return SberApiControllerApiFb(configuration)
        .getSberIdUserInfo(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdUserInfoUpdate} updateUserInfo
     * @param {string} smsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSberIdUserInfo(lzId: number, updateUserInfo: SberIdUserInfoUpdate) {
      return SberApiControllerApiFb(configuration)
        .updateSberIdUserInfo(lzId, updateUserInfo)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateSertificate(lzId: number) {
      return SberApiControllerApiFb(configuration)
        .activateSertificate(lzId)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncBusinessCards(lzId: number) {
      return SberApiControllerApiFb(configuration)
        .syncBusinessCards(lzId)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCsr(lzId: number) {
      return SberApiControllerApiFb(configuration)
        .createCsr(lzId)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCsr(lzId: number, options?: any): AxiosPromise<[string]> {
      return SberApiControllerApiFb(configuration)
        .getCsr(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateEds(lzId: number) {
      return SberApiControllerApiFb(configuration)
        .activateEds(lzId)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEdsStatus(lzId: number, options?: any): AxiosPromise<CertificateStatusWrapper1> {
      return SberApiControllerApiFb(configuration)
        .getEdsStatus(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEdsInfo(lzId: number, options?: any): AxiosPromise<SberIdEdsInfo> {
      return SberApiControllerApiFb(configuration)
        .getEdsInfo(lzId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * BusinessCardControllerApi - object-oriented interface
 * @export
 * @class BusinessCardControllerApi
 * @extends {BaseAPI}
 */
export class BusinessCardControllerApi extends BaseAPI {
  /**
   *
   * @param {number} lzId
   * @param {BusinessCardCreate} businessCardCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public addBusinessCard(lzId: number, businessCardCreate: BusinessCardCreate, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .addBusinessCard(lzId, businessCardCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {number} businessCardId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public bindBusinessCard(pzuId: number, businessCardId: number, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .bindBusinessCard(pzuId, businessCardId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public getBusinessCardListByPzuIdAndUserId(pzuId: number, userId: number, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .getBusinessCardListByPzuIdAndUserId(pzuId, userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {number} page
   * @param {number} [size]
   * @param {boolean} [blocked]
   * @param {Set<number>} [pzuIds]
   * @param {string} [nameLike]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public getBusinessCardPageWithPzusByLzId(
    lzId: number,
    page: number,
    size?: number,
    blocked?: boolean,
    pzuIds?: Set<number>,
    nameLike?: string,
    options?: any,
  ) {
    return BusinessCardControllerApiFp(this.configuration)
      .getBusinessCardPageWithPzusByLzId(lzId, page, size, blocked, pzuIds, nameLike, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} businessCardId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public getBusinessCardWithPzus(businessCardId: number, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .getBusinessCardWithPzus(businessCardId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {number} page
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public getBusinessCardWithUsersPageByPzuId(pzuId: number, page: number, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .getBusinessCardWithUsersPageByPzuId(pzuId, page, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} businessCardId
   * @param {BooleanWrapper} booleanWrapper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public setBusinessCardBlocked(businessCardId: number, booleanWrapper: BooleanWrapper, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .setBusinessCardBlocked(businessCardId, booleanWrapper, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {number} businessCardId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public unbindBusinessCard(pzuId: number, businessCardId: number, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .unbindBusinessCard(pzuId, businessCardId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} businessCardId
   * @param {BusinessCardUpdate} businessCardUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BusinessCardControllerApi
   */
  public updateBusinessCard(businessCardId: number, businessCardUpdate: BusinessCardUpdate, options?: any) {
    return BusinessCardControllerApiFp(this.configuration)
      .updateBusinessCard(businessCardId, businessCardUpdate, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CommissionControllerApi - axios parameter creator
 * @export
 */
export const CommissionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {PercentWrapper} percentWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCommission: async (lzId: number, percentWrapper: PercentWrapper, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createCommission.');
      }
      // verify required parameter 'percentWrapper' is not null or undefined
      if (percentWrapper === null || percentWrapper === undefined) {
        throw new RequiredError(
          'percentWrapper',
          'Required parameter percentWrapper was null or undefined when calling createCommission.',
        );
      }
      const localVarPath = `/lzs/{lzId}/commissions`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof percentWrapper !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(percentWrapper !== undefined ? percentWrapper : {})
        : percentWrapper || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommission: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getCommission.');
      }
      const localVarPath = `/lzs/{lzId}/commissions`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommissionV2: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getCommission.');
      }
      const localVarPath = `/v2/lzs/{lzId}/commissions`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCommissionsById: async (commissionId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'scanId' is not null or undefined
      if (commissionId === null || commissionId === undefined) {
        throw new RequiredError(
          'commissionId',
          'Required parameter scanId was null or undefined when calling deleteCommissionsById.',
        );
      }
      const localVarPath = `/commissions/{commissionId}`.replace(
        `{${'commissionId'}}`,
        encodeURIComponent(String(commissionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {PaymentCreate} percentWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberApiCommissions: async (
      psaId: number,
      commissionData: PaymentCreate | null,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError(
          'psaId',
          'Required parameter psaId was null or undefined when calling getSberApiCommissions.',
        );
      }
      // verify required parameter 'percentWrapper' is not null or undefined
      if (commissionData === null || commissionData === undefined) {
        throw new RequiredError(
          'percentWrapper',
          'Required parameter percentWrapper was null or undefined when calling createCommission.',
        );
      }
      const localVarPath = `/psas/{psaId}/commissions`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof commissionData !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(commissionData !== undefined ? commissionData : {})
        : commissionData || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CommissionControllerApi - functional programming interface
 * @export
 */
export const CommissionControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {PercentWrapper} percentWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCommission(
      lzId: number,
      percentWrapper: PercentWrapper,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await CommissionControllerApiAxiosParamCreator(configuration).createCommission(
        lzId,
        percentWrapper,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCommission(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PercentWrapper>> {
      const localVarAxiosArgs = await CommissionControllerApiAxiosParamCreator(configuration).getCommission(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCommissionV2(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionInfo[]>> {
      const localVarAxiosArgs = await CommissionControllerApiAxiosParamCreator(configuration).getCommissionV2(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} commissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteCommissionsById(
      commissionId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await CommissionControllerApiAxiosParamCreator(configuration).deleteCommissionsById(
        commissionId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSberApiCommissions(
      psaId: number,
      paymentCreate: PaymentCreate | null,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionResponse>> {
      const localVarAxiosArgs = await CommissionControllerApiAxiosParamCreator(configuration).getSberApiCommissions(
        psaId,
        paymentCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * CommissionControllerApi - factory interface
 * @export
 */
export const CommissionControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {PercentWrapper} percentWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCommission(lzId: number, percentWrapper: PercentWrapper, options?: any): AxiosPromise<IdWrapper> {
      return CommissionControllerApiFp(configuration)
        .createCommission(lzId, percentWrapper, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommission(lzId: number, options?: any): AxiosPromise<PercentWrapper> {
      return CommissionControllerApiFp(configuration)
        .getCommission(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommissionV2(lzId: number, options?: any): AxiosPromise<CommissionInfo[]> {
      return CommissionControllerApiFp(configuration)
        .getCommissionV2(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} commissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCommissionsById(commissionId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return CommissionControllerApiFp(configuration)
        .deleteCommissionsById(commissionId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberApiCommissions(
      psaId: number,
      paymentCreate: PaymentCreate | null,
      options?: any,
    ): AxiosPromise<CommissionResponse> {
      return CommissionControllerApiFp(configuration)
        .getSberApiCommissions(psaId, paymentCreate, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CommissionControllerApi - object-oriented interface
 * @export
 * @class CommissionControllerApi
 * @extends {BaseAPI}
 */
export class CommissionControllerApi extends BaseAPI {
  /**
   *
   * @param {number} lzId
   * @param {PercentWrapper} percentWrapper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommissionControllerApi
   */
  public createCommission(lzId: number, percentWrapper: PercentWrapper, options?: any) {
    return CommissionControllerApiFp(this.configuration)
      .createCommission(lzId, percentWrapper, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommissionControllerApi
   */
  public getCommission(lzId: number, options?: any) {
    return CommissionControllerApiFp(this.configuration)
      .getCommission(lzId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * DevControllerApi - axios parameter creator
 * @export
 */
export const DevControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ping: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/ping`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    version: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/version`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DevControllerApi - functional programming interface
 * @export
 */
export const DevControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ping(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await DevControllerApiAxiosParamCreator(configuration).ping(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async version(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await DevControllerApiAxiosParamCreator(configuration).version(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * DevControllerApi - factory interface
 * @export
 */
export const DevControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ping(options?: any): AxiosPromise<string> {
      return DevControllerApiFp(configuration)
        .ping(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    version(options?: any): AxiosPromise<string> {
      return DevControllerApiFp(configuration)
        .version(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * DevControllerApi - object-oriented interface
 * @export
 * @class DevControllerApi
 * @extends {BaseAPI}
 */
export class DevControllerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DevControllerApi
   */
  public ping(options?: any) {
    return DevControllerApiFp(this.configuration)
      .ping(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DevControllerApi
   */
  public version(options?: any) {
    return DevControllerApiFp(this.configuration)
      .version(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * LzClientControllerApi - axios parameter creator
 * @export
 */
export const LzClientControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} page
     * @param {string} passportSnLike
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsPage: async (
      page: number,
      passportSnLike?: string,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/compliance/lz-clients`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (passportSnLike !== undefined) {
        localVarQueryParameter['passport-sn-like'] = passportSnLike;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} passportSnLike
     * @param {string} paymentSumFrom
     * @param {string} paymentSumTo
     * @param {string} paymentCountFrom
     * @param {string} paymentCountTo
     * @param {string} lzClientIndex
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsPageIndexes: async (
      page: number,
      passportSnLike?: string,
      paymentSumFrom?: number,
      paymentSumTo?: number,
      paymentCountFrom?: string,
      paymentCountTo?: string,
      lzClientIndex?: string,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/compliance/lz-client-indexes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (passportSnLike !== undefined) {
        localVarQueryParameter['lz-client-passport-sn-like'] = passportSnLike;
      }
      if (paymentSumFrom !== undefined) {
        localVarQueryParameter['payment-sum-from'] = paymentSumFrom;
      }
      if (paymentSumTo !== undefined) {
        localVarQueryParameter['payment-sum-to'] = paymentSumTo;
      }
      if (paymentCountFrom !== undefined) {
        localVarQueryParameter['payment-count-from'] = paymentCountFrom;
      }
      if (paymentCountTo !== undefined) {
        localVarQueryParameter['payment-count-to'] = paymentCountTo;
      }
      if (lzClientIndex !== undefined) {
        localVarQueryParameter['lz-client-index'] = lzClientIndex;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<number>} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsIndexesById: async (id?: number[], options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/compliance/lz-client-indexes/${id}`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} passportSn
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsTransactionPage: async (
      page: number,
      lzClientIds?: string,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/compliance/lz-clients/transactions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      localVarQueryParameter['lz-client-ids'] = lzClientIds;

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzClientCreate} lzClientCreate
     * @param {boolean} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClient: async (
      lzId: number,
      lzClientCreate: LzClientCreate,
      executeEhecks: boolean,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createLzClient.');
      }
      // verify required parameter 'lzClientCreate' is not null or undefined
      if (lzClientCreate === null || lzClientCreate === undefined) {
        throw new RequiredError(
          'lzClientCreate',
          'Required parameter lzClientCreate was null or undefined when calling createLzClient.',
        );
      }
      const localVarPath = `/lzs/{lzId}/lz-clients`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarQueryParameter['execute-checks'] = executeEhecks;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      if (lzClientCreate?.checkPassportData !== undefined) {
        queryParameters.set('passport-complex-check', `${lzClientCreate.checkPassportData}`);
        delete lzClientCreate?.checkPassportData;
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzClientCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzClientCreate !== undefined ? lzClientCreate : {})
        : lzClientCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzClientUpdate} lzClientUpdate
     * @param {boolean} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLzClient: async (
      lzId: number,
      lzClientUpdate: LzClientUpdate,
      executeEhecks: boolean,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createLzClient.');
      }
      // verify required parameter 'lzClientCreate' is not null or undefined
      if (lzClientUpdate === null || lzClientUpdate === undefined) {
        throw new RequiredError(
          'lzClientUpadte',
          'Required parameter lzClientCreate was null or undefined when calling createLzClient.',
        );
      }
      const localVarPath = '/lz-clients/'.replace('*', '') + encodeURIComponent(String(lzId));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarQueryParameter['execute-checks'] = executeEhecks;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      if (lzClientUpdate?.checkPassportData !== undefined) {
        queryParameters.set('passport-complex-check', `${lzClientUpdate.checkPassportData}`);
        delete lzClientUpdate?.checkPassportData;
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzClientUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzClientUpdate !== undefined ? lzClientUpdate : {})
        : lzClientUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientUpdate} lzClientUpdate
     * @param {boolean} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeLzClientPassport: async (
      lzClientId: number,
      lzClientUpdate: LzClientUpdate,
      executeEhecks?: boolean,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createLzClient.');
      }
      // verify required parameter 'lzClientCreate' is not null or undefined
      if (lzClientUpdate === null || lzClientUpdate === undefined) {
        throw new RequiredError(
          'lzClientUpadte',
          'Required parameter lzClientCreate was null or undefined when calling createLzClient.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/change-passport-data`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarQueryParameter['execute-checks'] = executeEhecks;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      if (lzClientUpdate?.checkPassportData !== undefined) {
        queryParameters.set('passport-complex-check', `${lzClientUpdate.checkPassportData}`);
        delete lzClientUpdate?.checkPassportData;
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzClientUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzClientUpdate !== undefined ? lzClientUpdate : {})
        : lzClientUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {string[]} paymentTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasLzClientPayments: async (
      lzClientId: number,
      paymentTypes?: string[],
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling hasLzClientPayments.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/has-payments`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (paymentTypes) {
        localVarQueryParameter['payment-types'] = paymentTypes;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientPaymentCardCreate} lzClientPaymentCardCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClientPaymentCard: async (
      lzClientId: number,
      lzClientPaymentCardCreate: LzClientPaymentCardCreate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling createLzClientPaymentCard.',
        );
      }
      // verify required parameter 'lzClientPaymentCardCreate' is not null or undefined
      if (lzClientPaymentCardCreate === null || lzClientPaymentCardCreate === undefined) {
        throw new RequiredError(
          'lzClientPaymentCardCreate',
          'Required parameter lzClientPaymentCardCreate was null or undefined when calling createLzClientPaymentCard.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/payment-cards`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzClientPaymentCardCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzClientPaymentCardCreate !== undefined ? lzClientPaymentCardCreate : {})
        : lzClientPaymentCardCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCitizenshipDictList: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/citizenship-dict-items`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientPaymentCardsListByLzClientId: async (lzClientId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling getLzClientPaymentCardsListByLzClientId.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/payment-cards`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientById: async (lzClientId: number, psaId?: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling getLzClientById.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (psaId) {
        localVarQueryParameter['psaId'] = psaId;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [lzClientsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientsByIds: async (lzClientIds: string[], options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientIds === null || lzClientIds === undefined) {
        throw new RequiredError(
          'lzClientsIds',
          'Required parameter lzClientIds was null or undefined when calling getLzClientsByIds.',
        );
      }
      const localVarPath = `/compliance/lz-clients/{lzClientIds}`.replace(
        `{${'lzClientIds'}}`,
        encodeURIComponent(String(lzClientIds)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {string} [fullNameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientsPageByLzId: async (
      lzId: number,
      page: number,
      fullNameLike?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getLzClientsPageByLzId.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getLzClientsPageByLzId.',
        );
      }
      const localVarPath = `/lzs/{lzId}/lz-clients`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (fullNameLike !== undefined) {
        localVarQueryParameter['fullNameLike'] = fullNameLike;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientTransportCreate} lzClientTransportCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClientTransport: async (
      lzClientId: number,
      lzClientTransportCreate: LzClientTransportCreate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling createLzClientPaymentCard.',
        );
      }
      // verify required parameter 'lzClientTransportCreate' is not null or undefined
      if (lzClientTransportCreate === null || lzClientTransportCreate === undefined) {
        throw new RequiredError(
          'lzClientPaymentCardCreate',
          'Required parameter lzClientTransportCreate was null or undefined when calling createLzClientTransport.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/transports`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzClientTransportCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzClientTransportCreate !== undefined ? lzClientTransportCreate : {})
        : lzClientTransportCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientTransport: async (lzClientId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling getLzClientById.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/transports`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientPaymentPhones: async (lzClientId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling getLzClientPaymentPhones.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/payment-phones`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientUpdate} LzClientPaymentPhoneCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClientPaymentPhone: async (
      lzClientId: number,
      phone: LzClientPaymentPhoneCreate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling createLzClientPaymentPhone.',
        );
      }
      // verify required parameter 'lzClientCreate' is not null or undefined
      if (phone === null || phone === undefined) {
        throw new RequiredError(
          'lzClientUpadte',
          'Required parameter lzClientCreate was null or undefined when calling createLzClientPaymentPhone.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/payment-phones`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }

      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof phone !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(phone !== undefined ? phone : {}) : phone || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LzClientControllerApi - functional programming interface
 * @export
 */
export const LzClientControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {LzClientCreate} lzClientCreate
     * @param {boolean} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLzClient(
      lzId: number,
      lzClientCreate: LzClientCreate,
      executeEhecks: boolean,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).createLzClient(
        lzId,
        lzClientCreate,
        executeEhecks,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzClientUpdate} lzClientUpdate
     * @param {boolean} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLzClient(
      lzId: number,
      lzClientUpdate: LzClientUpdate,
      executeEhecks: boolean,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).updateLzClient(
        lzId,
        lzClientUpdate,
        executeEhecks,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientUpdate} lzClientUpdate
     * @param {LzClientUpdate} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeLzClientPassport(
      lzClientId: number,
      lzClientUpdate: LzClientUpdate,
      executeEhecks?: boolean,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).changeLzClientPassport(
        lzClientId,
        lzClientUpdate,
        executeEhecks,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientPaymentCardCreate} lzClientPaymentCardCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLzClientPaymentCard(
      lzClientId: number,
      lzClientPaymentCardCreate: LzClientPaymentCardCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).createLzClientPaymentCard(
        lzClientId,
        lzClientPaymentCardCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCitizenshipDictList(
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CitizenshipDictItem>>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getCitizenshipDictList(
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzClientPaymentCardsListByLzClientId(
      lzClientId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LzClientPaymentCardInfo>>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(
        configuration,
      ).getLzClientPaymentCardsListByLzClientId(lzClientId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzClientById(
      lzClientId: number,
      psaId?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ILzClientShortInfoWithLz>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLzClientById(
        lzClientId,
        psaId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} [lzClientsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzClientsByIds(
      lzClientsIds: string[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ILzClientShortInfoWithLz>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLzClientsByIds(
        lzClientsIds,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {string} [fullNameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzClientsPageByLzId(
      lzId: number,
      page: number,
      fullNameLike?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLzClientShortInfo>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLzClientsPageByLzId(
        lzId,
        page,
        fullNameLike,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [passportSnLike]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLsPage(
      page: number,
      passportSnLike?: string,
      sort?: string[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLsList>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLsPage(
        page,
        passportSnLike,
        sort,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [passportSnLike]
     * @param {string} [paymentSumFrom]
     * @param {string} [paymentSumTo]
     * @param {string} [paymentCountFrom]
     * @param {string} [paymentCountTo]
     * @param {string} [lzClientIndex]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLsPageIndexes(
      page: number,
      passportSnLike?: string,
      paymentSumFrom?: number,
      paymentSumTo?: number,
      paymentCountFrom?: string,
      paymentCountTo?: string,
      lzClientIndex?: string,
      sort?: string[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLsList>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLsPageIndexes(
        page,
        passportSnLike,
        paymentSumFrom,
        paymentSumTo,
        paymentCountFrom,
        paymentCountTo,
        lzClientIndex,
        sort,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {Array<number>} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLsIndexesById(
      id: number[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LsIndex>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLsIndexesById(
        id,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [passportSn]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLsTransactionPage(
      page: number,
      lzClientIds?: string,
      sort?: string[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLsTransactionList>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLsTransactionPage(
        page,
        lzClientIds,
        sort,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {string[]} paymentTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hasLzClientPayments(
      lzClientId: number,
      paymentTypes?: string[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HasLzClientReport>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).hasLzClientPayments(
        lzClientId,
        paymentTypes,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientTransportCreate} lzClientTransportCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLzClientTransport(
      lzClientId: number,
      lzClientTransportCreate: LzClientTransportCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).createLzClientTransport(
        lzClientId,
        lzClientTransportCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzClientTransport(
      lzClientId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzClientTransportInfo[]>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLzClientTransport(
        lzClientId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzClientPaymentPhones(
      lzClientId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzClientPaymentPhoneInfo[]>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).getLzClientPaymentPhones(
        lzClientId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {phone} LzClientPaymentPhoneCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLzClientPaymentPhone(
      lzClientId: number,
      phone: LzClientPaymentPhoneCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await LzClientControllerApiAxiosParamCreator(configuration).createLzClientPaymentPhone(
        lzClientId,
        phone,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * LzClientControllerApi - factory interface
 * @export
 */
export const LzClientControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {LzClientCreate} lzClientCreate
     * @param {boolean} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClient(
      lzId: number,
      lzClientCreate: LzClientCreate,
      executeEhecks: boolean,
      options?: any,
    ): AxiosPromise<IdWrapper> {
      return LzClientControllerApiFp(configuration)
        .createLzClient(lzId, lzClientCreate, executeEhecks, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {LzClientUpdate} lzClientUpdate
     * @param {boolean} executeEhecks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLzClient(
      lzId: number,
      lzClientUpdate: LzClientUpdate,
      executeEhecks: boolean,
      options?: any,
    ): AxiosPromise<IdWrapper> {
      return LzClientControllerApiFp(configuration)
        .updateLzClient(lzId, lzClientUpdate, executeEhecks, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {lzClientId} lzClientId
     * @param {lzClientId} executeEhecks
     * @param {LzClientUpdate} lzClientUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeLzClientPassport(
      lzClientId: number,
      lzClientUpdate: LzClientUpdate,
      executeEhecks?: boolean,
      options?: any,
    ): AxiosPromise<IdWrapper> {
      return LzClientControllerApiFp(configuration)
        .changeLzClientPassport(lzClientId, lzClientUpdate, executeEhecks, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {LzClientPaymentCardCreate} lzClientPaymentCardCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClientPaymentCard(
      lzClientId: number,
      lzClientPaymentCardCreate: LzClientPaymentCardCreate,
      options?: any,
    ): AxiosPromise<IdWrapper> {
      return LzClientControllerApiFp(configuration)
        .createLzClientPaymentCard(lzClientId, lzClientPaymentCardCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCitizenshipDictList(options?: any): AxiosPromise<Array<CitizenshipDictItem>> {
      return LzClientControllerApiFp(configuration)
        .getCitizenshipDictList(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientPaymentCardsListByLzClientId(
      lzClientId: number,
      options?: any,
    ): AxiosPromise<Array<LzClientPaymentCardInfo>> {
      return LzClientControllerApiFp(configuration)
        .getLzClientPaymentCardsListByLzClientId(lzClientId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientById(lzClientId: number, psaId?: number, options?: any): AxiosPromise<ILzClientShortInfoWithLz> {
      return LzClientControllerApiFp(configuration)
        .getLzClientById(lzClientId, psaId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} [lzClientsIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientsByIds(lzClientsIds: string[], options?: any): AxiosPromise<ILzClientShortInfoWithLz> {
      return LzClientControllerApiFp(configuration)
        .getLzClientsByIds(lzClientsIds, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {string} [fullNameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientsPageByLzId(
      lzId: number,
      page: number,
      fullNameLike?: string,
      options?: any,
    ): AxiosPromise<PageWrapperLzClientShortInfo> {
      return LzClientControllerApiFp(configuration)
        .getLzClientsPageByLzId(lzId, page, fullNameLike, options)
        .then(request => request(axios, basePath));
    },

    /**
     *
     * @param {number} page
     * @param {string} [passportSnLike]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsList(page: number, passportSnLike?: string, sort?: string[], options?: any): AxiosPromise<PageWrapperLsList> {
      return LzClientControllerApiFp(configuration)
        .getLsPage(page, passportSnLike, sort, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [passportSnLike]
     * @param {string} [paymentSumFrom]
     * @param {string} [paymentSumTo]
     * @param {string} [paymentCountFrom]
     * @param {string} [paymentCountTo]
     * @param {string} [lzClientIndex]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsListIndexes(
      page: number,
      passportSnLike?: string,
      paymentSumFrom?: number,
      paymentSumTo?: number,
      paymentCountFrom?: string,
      paymentCountTo?: string,
      lzClientIndex?: string,
      sort?: string[],
      options?: any,
    ): AxiosPromise<PageWrapperLsList> {
      return LzClientControllerApiFp(configuration)
        .getLsPageIndexes(
          page,
          passportSnLike,
          paymentSumFrom,
          paymentSumTo,
          paymentCountFrom,
          paymentCountTo,
          lzClientIndex,
          sort,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {Array<number>} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsIndexById(id: number[]): AxiosPromise<LsIndex> {
      return LzClientControllerApiFp(configuration)
        .getLsIndexesById(id)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [passportSn]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLsTransactionList(
      page: number,
      lzClientIds?: string,
      sort?: string[],
      options?: any,
    ): AxiosPromise<PageWrapperLsTransactionList> {
      return LzClientControllerApiFp(configuration)
        .getLsTransactionPage(page, lzClientIds, sort, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {string[]} paymentTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasLzClientPayments(lzClientId: number, paymentTypes?: string[], options?: any): AxiosPromise<HasLzClientReport> {
      return LzClientControllerApiFp(configuration)
        .hasLzClientPayments(lzClientId, paymentTypes, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {lzClientTransportCreate} LzClientTransportCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClientTransport(
      lzClientId: number,
      lzClientTransportCreate: LzClientTransportCreate,
      options?: any,
    ): AxiosPromise<IdWrapper> {
      return LzClientControllerApiFp(configuration)
        .createLzClientTransport(lzClientId, lzClientTransportCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientTransport(lzClientId: number, options?: any): AxiosPromise<LzClientTransportInfo[]> {
      return LzClientControllerApiFp(configuration)
        .getLzClientTransport(lzClientId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzClientPaymentPhones(lzClientId: number, options?: any): AxiosPromise<LzClientPaymentPhoneInfo[]> {
      return LzClientControllerApiFp(configuration)
        .getLzClientPaymentPhones(lzClientId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {lzClientId} lzClientId
     * @param {phone} LzClientPaymentPhoneCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLzClientPaymentPhone(
      lzClientId: number,
      phone: LzClientPaymentPhoneCreate,
      options?: any,
    ): AxiosPromise<IdWrapper> {
      return LzClientControllerApiFp(configuration)
        .createLzClientPaymentPhone(lzClientId, phone, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * LzClientControllerApi - object-oriented interface
 * @export
 * @class LzClientControllerApi
 * @extends {BaseAPI}
 */
export class LzClientControllerApi extends BaseAPI {
  /**
   *
   * @param {number} lzId
   * @param {LzClientCreate} lzClientCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzClientControllerApi
   */
  public createLzClient(lzId: number, lzClientCreate: LzClientCreate, options?: any) {
    return LzClientControllerApiFp(this.configuration)
      .createLzClient(lzId, lzClientCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzClientId
   * @param {LzClientPaymentCardCreate} lzClientPaymentCardCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzClientControllerApi
   */
  public createLzClientPaymentCard(
    lzClientId: number,
    lzClientPaymentCardCreate: LzClientPaymentCardCreate,
    options?: any,
  ) {
    return LzClientControllerApiFp(this.configuration)
      .createLzClientPaymentCard(lzClientId, lzClientPaymentCardCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzClientControllerApi
   */
  public getCitizenshipDictList(options?: any) {
    return LzClientControllerApiFp(this.configuration)
      .getCitizenshipDictList(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzClientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzClientControllerApi
   */
  public getLzClientPaymentCardsListByLzClientId(lzClientId: number, options?: any) {
    return LzClientControllerApiFp(this.configuration)
      .getLzClientPaymentCardsListByLzClientId(lzClientId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {number} page
   * @param {string} [fullNameLike]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzClientControllerApi
   */
  public getLzClientsPageByLzId(lzId: number, page: number, fullNameLike?: string, options?: any) {
    return LzClientControllerApiFp(this.configuration)
      .getLzClientsPageByLzId(lzId, page, fullNameLike, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * LzControllerApi - axios parameter creator
 * @export
 */
export const LzControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {LzCreate} lzCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLz: async (lzCreate: LzCreate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzCreate' is not null or undefined
      if (lzCreate === null || lzCreate === undefined) {
        throw new RequiredError('lzCreate', 'Required parameter lzCreate was null or undefined when calling createLz.');
      }
      const localVarPath = `/lzs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzCreate !== undefined ? lzCreate : {})
        : lzCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLz: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getLz.');
      }
      const localVarPath = `/lzs/{lzId}`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzSettings: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getLz.');
      }
      const localVarPath = `/lzs/{lzId}/settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActiveClassifiers: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getLz.');
      }
      const localVarPath = `/metal-dict/active-classifiers`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getForbiddenClassifiers: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getForbiddenClassifiers.',
        );
      }
      const localVarPath = `/lzs/{lzId}/forbidden-classifiers`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClassifierSettings: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getForbiddenClassifiers.',
        );
      }
      const localVarPath = `/lzs/{lzId}/classifier-settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzIsConnectedToSberId: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getLzSberId.');
      }
      const localVarPath = `/sber-id/{lzId}/is-connected`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdLoginUrl: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getLzSberId.');
      }
      const localVarPath = `/sber-id/{lzId}/login-url`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logOutSberId: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling logOutSberId.');
      }
      const localVarPath = `/sber-id/{lzId}/disconnect`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzInfoPage: async (
      page: number,
      nameLike?: string,
      innLike?: string,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError('page', 'Required parameter page was null or undefined when calling getLzInfoPage.');
      }
      const localVarPath = `/lzs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      if (innLike !== undefined) {
        localVarQueryParameter['inn-like'] = innLike;
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzInfoIndexById: async (lzId?: string, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/compliance/lz-indexes/${lzId}`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} lzId
     * @param {Array<string>} sort
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzPzuIndexes: async (
      page: number,
      lzId?: string,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      if (page === null || page === undefined) {
        throw new RequiredError('page', 'Required parameter page was null or undefined when calling getLzInfoPage.');
      }
      // verify required parameter 'page' is not null or undefined
      const localVarPath = `/compliance/pzu-indexes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }
      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (lzId !== undefined) {
        localVarQueryParameter['lz-id'] = lzId;
      }
      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzShortInfoPage: async (page: number, nameLike?: string, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getLzShortInfoPage.',
        );
      }
      const localVarPath = `/lzs/short-info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzUpdate} lzUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLz: async (lzId: number, lzUpdate: LzUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling updateLz.');
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (lzUpdate === null || lzUpdate === undefined) {
        throw new RequiredError('lzUpdate', 'Required parameter lzUpdate was null or undefined when calling updateLz.');
      }
      const localVarPath = `/lzs/{lzId}`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzUpdate !== undefined ? lzUpdate : {})
        : lzUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ILzSettingsUpdate} lzSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLzSettings: async (
      lzId: number,
      lzSettingsUpdate: ILzSettingsUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling updateLz.');
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (lzSettingsUpdate === null || lzSettingsUpdate === undefined) {
        throw new RequiredError('lzUpdate', 'Required parameter lzUpdate was null or undefined when calling updateLz.');
      }
      const localVarPath = `/lzs/{lzId}/settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzSettingsUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzSettingsUpdate !== undefined ? lzSettingsUpdate : {})
        : lzSettingsUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {string[]} forbiddenClassifiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setBlockClassifiers: async (lzId: number, forbiddenClassifiers: any, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling setBlockClassifiers.',
        );
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (forbiddenClassifiers === null || forbiddenClassifiers === undefined) {
        throw new RequiredError(
          'lzUpdate',
          'Required parameter lzUpdate was null or undefined when calling setBlockClassifiers.',
        );
      }
      const localVarPath = `/lzs/{lzId}/forbidden-classifiers`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof forbiddenClassifiers !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(forbiddenClassifiers !== undefined ? forbiddenClassifiers : {})
        : forbiddenClassifiers || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ClassifierCode} classifierCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteClassifierSettings: async (
      lzId: number,
      classifierCode: ClassifierCode,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'scanId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter scanId was null or undefined when calling deleteClassifierSettings.',
        );
      }
      if (classifierCode === null || classifierCode === undefined) {
        throw new RequiredError(
          'classifierCode',
          'Required parameter classifierCode was null or undefined when calling deleteClassifierSettings.',
        );
      }
      const localVarPath = `/lzs/{lzId}/classifier-settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (classifierCode) {
        localVarQueryParameter['classifier-code'] = classifierCode;
      }

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {IClassifierSettingsUpdate} classifierSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setClassifierSettings: async (
      lzId: number,
      classifierSettings: IClassifierSettingsUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling setClassifierSettings.',
        );
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (classifierSettings === null || classifierSettings === undefined) {
        throw new RequiredError(
          'classifierSettings',
          'Required parameter lzUpdate was null or undefined when calling setClassifierSettings.',
        );
      }
      const localVarPath = `/lzs/{lzId}/classifier-settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof classifierSettings !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(classifierSettings !== undefined ? classifierSettings : {})
        : classifierSettings || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ISmsSettingsUpdate} updateSmsSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSmsSettings: async (
      lzId: number,
      updateSmsSettings: ISmsSettingsUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling updateLz.');
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (updateSmsSettings === null || updateSmsSettings === undefined) {
        throw new RequiredError('lzUpdate', 'Required parameter lzUpdate was null or undefined when calling updateLz.');
      }
      const localVarPath = `/lzs/{lzId}/sms-settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (updateSmsSettings.smsConfirmCode && updateSmsSettings.smsConfirmCode !== '') {
        localVarQueryParameter['sms-code'] = updateSmsSettings.smsConfirmCode;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof updateSmsSettings !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(updateSmsSettings !== undefined ? updateSmsSettings : {})
        : updateSmsSettings || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {faSetting} I2faSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update2faSettings: async (lzId: number, faSetting: I2faSettingsUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling update2faSettings.',
        );
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (faSetting === null || faSetting === undefined) {
        throw new RequiredError(
          'lzUpdate',
          'Required parameter lzUpdate was null or undefined when calling update2faSettings.',
        );
      }
      const localVarPath = `/lzs/{lzId}/2fa-settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof faSetting !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(faSetting !== undefined ? faSetting : {})
        : faSetting || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertLzPaymentBindingCredentials: async (
      lzId: number,
      lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling upsertLzPaymentBindingCredentials.',
        );
      }
      // verify required parameter 'lzGatewayCredentialsUpsert' is not null or undefined
      if (lzGatewayCredentialsUpsert === null || lzGatewayCredentialsUpsert === undefined) {
        throw new RequiredError(
          'lzGatewayCredentialsUpsert',
          'Required parameter lzGatewayCredentialsUpsert was null or undefined when calling upsertLzPaymentBindingCredentials.',
        );
      }
      const localVarPath = `/lzs/{lzId}/payment-binding-credentials`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzGatewayCredentialsUpsert !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzGatewayCredentialsUpsert !== undefined ? lzGatewayCredentialsUpsert : {})
        : lzGatewayCredentialsUpsert || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzSberIdCredentialsUpsert} lzSberIdCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertLzSberIdCredentials: async (
      lzId: number,
      lzSberIdCredentialsUpsert: LzSberIdCredentialsUpsert,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling upsertLzSberIdCredentials.',
        );
      }
      // verify required parameter 'LzSberIdCredentialsUpsert' is not null or undefined
      if (lzSberIdCredentialsUpsert === null || lzSberIdCredentialsUpsert === undefined) {
        throw new RequiredError(
          'upsertLzSberIdCredentials',
          'Required parameter upsertLzSberIdCredentials was null or undefined when calling upsertLzSberIdCredentials.',
        );
      }
      const localVarPath = `/lzs/{lzId}/sber-id`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzSberIdCredentialsUpsert !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzSberIdCredentialsUpsert !== undefined ? lzSberIdCredentialsUpsert : {})
        : lzSberIdCredentialsUpsert || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertLzPaymentGatewayCredentials: async (
      lzId: number,
      lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling upsertLzPaymentGatewayCredentials.',
        );
      }
      // verify required parameter 'lzGatewayCredentialsUpsert' is not null or undefined
      if (lzGatewayCredentialsUpsert === null || lzGatewayCredentialsUpsert === undefined) {
        throw new RequiredError(
          'lzGatewayCredentialsUpsert',
          'Required parameter lzGatewayCredentialsUpsert was null or undefined when calling upsertLzPaymentGatewayCredentials.',
        );
      }
      const localVarPath = `/lzs/{lzId}/payment-gateway-credentials`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof lzGatewayCredentialsUpsert !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(lzGatewayCredentialsUpsert !== undefined ? lzGatewayCredentialsUpsert : {})
        : lzGatewayCredentialsUpsert || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzSberCredentials: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getLzSberIdCredentials.',
        );
      }
      const localVarPath = `/lzs/{lzId}/sber-id`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }
      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ILzSettingsUpdate} lzSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateGatewaySettings: async (
      lzId: number,
      gatewaySettingsUpdate: UpdateGatewaySettings,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling updateLz.');
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (gatewaySettingsUpdate === null || gatewaySettingsUpdate === undefined) {
        throw new RequiredError(
          'gatewaySettingsUpdate',
          'Required parameter gatewaySettingsUpdate was null or undefined when calling updateGatewaySettings.',
        );
      }
      const localVarPath = `/lzs/{lzId}/gateway-settings`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof gatewaySettingsUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(gatewaySettingsUpdate !== undefined ? gatewaySettingsUpdate : {})
        : gatewaySettingsUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {sberIdSettings} SberIdSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSberIdSettings: async (
      lzId: number,
      sberIdSettings: SberIdSettingsUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling update2faSettings.',
        );
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (sberIdSettings === null || sberIdSettings === undefined) {
        throw new RequiredError(
          'sberIdSettings',
          'Required parameter sberIdSettings was null or undefined when calling updateSberIdSettings.',
        );
      }
      const localVarPath = `/sber-id/{lzId}`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof sberIdSettings !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(sberIdSettings !== undefined ? sberIdSettings : {})
        : sberIdSettings || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdSettings: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getSberIdSettings.',
        );
      }
      const localVarPath = `/lzs/{lzId}/sber-id`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdSertificates} [sertificates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadSberIdSertificates: async (
      lzId: number,
      sertificates: SberIdSertificates,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling loadSberIdSertificates.',
        );
      }

      if (sertificates === null || sertificates === undefined) {
        throw new RequiredError(
          'sertificates',
          'Required parameter sertificates was null or undefined when calling loadSberIdSertificates.',
        );
      }

      const localVarPath = `/lzs/{lzId}/sber-id/certificates`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (sertificates !== undefined) {
        localVarFormParams.append('tls_client_trust', sertificates.tlsClientTrust as any);
        localVarFormParams.append('tls_client_cert', sertificates.tlsClientCert as any);
        localVarFormParams.append('eds_private_key', sertificates.edsPrivateKey as any);
        localVarFormParams.append('eds_certificate', sertificates.edsCertificate as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {File} [sertificates]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadClientSertificate: async (lzId: number, sertificate: File, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling loadClientSertificate.',
        );
      }

      if (sertificate === null || sertificate === undefined) {
        throw new RequiredError(
          'sertificates',
          'Required parameter sertificates was null or undefined when calling loadClientSertificate.',
        );
      }

      const localVarPath = `/sber-id/{lzId}/client-cert`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (sertificate !== undefined) {
        localVarFormParams.append('file', sertificate);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {any} additionalProps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFrontStorage: async (lzId: number, additionalProps: any, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling updateFrontStorage.',
        );
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (additionalProps === null || additionalProps === undefined) {
        throw new RequiredError(
          'lzUpdate',
          'Required parameter lzUpdate was null or undefined when calling updateFrontStorage.',
        );
      }
      const localVarPath = `/lzs/{lzId}/front-storage`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof additionalProps !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(additionalProps !== undefined ? additionalProps : {})
        : additionalProps || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFrontStorage: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getFrontStorage.');
      }
      const localVarPath = `/lzs/{lzId}/front-storage`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LzControllerApi - functional programming interface
 * @export
 */
export const LzControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {LzCreate} lzCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLz(
      lzCreate: LzCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).createLz(lzCreate, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLz(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzFullInfo>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLz(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzSettings(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzSettings>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLzSettings(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActiveClassifiers(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string[]>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getActiveClassifiers(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getForbiddenClassifiers(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForbiddenClassifiersList>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getForbiddenClassifiers(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getClassifierSettings(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzClassifierSettings[]>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getClassifierSettings(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzIsConnectedToSberId(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzIsConnectedToSberId>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLzIsConnectedToSberId(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzSberCredentials(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzIdSberCredentials>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLzSberCredentials(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSberIdLoginUrl(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzSberIdLoginUrl>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getSberIdLoginUrl(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logOutSberId(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzSberIdLogOut>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).logOutSberId(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzInfoPage(
      page: number,
      nameLike?: string,
      innLike?: string,
      sort?: Array<string>,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLzInfo>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLzInfoPage(
        page,
        nameLike,
        innLike,
        sort,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzInfoIndexById(
      lzId?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzIndexInfo>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLzInfoIndexById(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} lzId
     * @param {Array<string>} sort
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzPzuIndexes(
      page: number,
      lzId?: string,
      sort?: Array<string>,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLzInfo>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLzPzuIndexes(
        page,
        lzId,
        sort,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzShortInfoPage(
      page: number,
      nameLike?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLzShortInfo>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getLzShortInfoPage(
        page,
        nameLike,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzUpdate} lzUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLz(
      lzId: number,
      lzUpdate: LzUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).updateLz(lzId, lzUpdate, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ILzSettingsUpdate} lzSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLzSettings(
      lzId: number,
      lzSettingsUpdate: ILzSettingsUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).updateLzSettings(
        lzId,
        lzSettingsUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {string[]} forbiddenClassifiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setBlockClassifiers(
      lzId: number,
      forbiddenClassifiers: any,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).setBlockClassifiers(
        lzId,
        forbiddenClassifiers,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ClassifierCode} classifierCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteClassifierSettings(
      lzId: number,
      classifierCode: ClassifierCode,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).deleteClassifierSettings(
        lzId,
        classifierCode,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {IClassifierSettingsUpdate} classifierSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setClassifierSettings(
      lzId: number,
      classifierSettings: IClassifierSettingsUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).setClassifierSettings(
        lzId,
        classifierSettings,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ILzSettingsUpdate} updateSmsSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSmsSettings(
      lzId: number,
      updateSmsSettings: ISmsSettingsUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).updateSmsSettings(
        lzId,
        updateSmsSettings,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {faSetting} I2faSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update2faSettings(
      lzId: number,
      faSetting: I2faSettingsUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).update2faSettings(
        lzId,
        faSetting,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdSertificates} sertificates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loadSberIdSertificates(
      lzId: number,
      sertificates: SberIdSertificates,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).loadSberIdSertificates(
        lzId,
        sertificates,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdSertificates} sertificates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loadClientSertificate(
      lzId: number,
      sertificate: File,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).loadClientSertificate(
        lzId,
        sertificate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertLzPaymentBindingCredentials(
      lzId: number,
      lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).upsertLzPaymentBindingCredentials(
        lzId,
        lzGatewayCredentialsUpsert,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzSberIdCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertLzSberIdCredentials(
      lzId: number,
      lzSberIdCredentialsUpsert: LzSberIdCredentialsUpsert,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).upsertLzSberIdCredentials(
        lzId,
        lzSberIdCredentialsUpsert,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertLzPaymentGatewayCredentials(
      lzId: number,
      lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).upsertLzPaymentGatewayCredentials(
        lzId,
        lzGatewayCredentialsUpsert,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {UpdateGatewaySettings} gatewaySettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateGatewaySettings(
      lzId: number,
      gatewaySettingsUpdate: UpdateGatewaySettings,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).updateGatewaySettings(
        lzId,
        gatewaySettingsUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {faSetting} SberIdSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSberIdSettings(
      lzId: number,
      sberIdSettings: SberIdSettingsUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).updateSberIdSettings(
        lzId,
        sberIdSettings,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSberIdSettings(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SberIdInfo>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getSberIdSettings(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {any} additionalProps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateFrontStorage(
      lzId: number,
      additionalProps: any,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).updateFrontStorage(
        lzId,
        additionalProps,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getFrontStorage(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await LzControllerApiAxiosParamCreator(configuration).getFrontStorage(lzId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * LzControllerApi - factory interface
 * @export
 */
export const LzControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {LzCreate} lzCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLz(lzCreate: LzCreate, options?: any): AxiosPromise<IdWrapper> {
      return LzControllerApiFp(configuration)
        .createLz(lzCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLz(lzId: number, options?: any): AxiosPromise<LzFullInfo> {
      return LzControllerApiFp(configuration)
        .getLz(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzIsConnectedToSberId(lzId: number, options?: any): AxiosPromise<LzIsConnectedToSberId> {
      return LzControllerApiFp(configuration)
        .getLzIsConnectedToSberId(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzSberCredentials(lzId: number, options?: any): AxiosPromise<LzIdSberCredentials> {
      return LzControllerApiFp(configuration)
        .getLzSberCredentials(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdLoginUrl(lzId: number, options?: any): AxiosPromise<LzSberIdLoginUrl> {
      return LzControllerApiFp(configuration)
        .getSberIdLoginUrl(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logOutSberId(lzId: number, options?: any): AxiosPromise<LzSberIdLogOut> {
      return LzControllerApiFp(configuration)
        .logOutSberId(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzInfoPage(
      page: number,
      nameLike?: string,
      innLike?: string,
      sort?: Array<string>,
      options?: any,
    ): AxiosPromise<PageWrapperLzInfo> {
      return LzControllerApiFp(configuration)
        .getLzInfoPage(page, nameLike, innLike, sort, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzInfoIndexById(lzId?: string, options?: any): AxiosPromise<LzIndexInfo> {
      return LzControllerApiFp(configuration)
        .getLzInfoIndexById(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} lzId
     * @param {Array<string>} sort
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzPzuIndexes(
      page: number,
      lzId?: string,
      sort?: Array<string>,
      options?: any,
    ): AxiosPromise<PageWrapperLzPzuIndex> {
      return LzControllerApiFp(configuration)
        .getLzPzuIndexes(page, lzId, sort, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzShortInfoPage(page: number, nameLike?: string, options?: any): AxiosPromise<PageWrapperLzShortInfo> {
      return LzControllerApiFp(configuration)
        .getLzShortInfoPage(page, nameLike, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {LzUpdate} lzUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLz(lzId: number, lzUpdate: LzUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .updateLz(lzId, lzUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {LzUpdate} lzUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLzSettings(lzId: number, lzSettingsUpdate: ILzSettingsUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .updateLzSettings(lzId, lzSettingsUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {string[]} forbiddenClassifiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setBlockClassifiers(lzId: number, forbiddenClassifiers: any, options?: any): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .setBlockClassifiers(lzId, forbiddenClassifiers, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {ClassifierCode} classifierCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteClassifierSettings(
      lzId: number,
      classifierCode: ClassifierCode,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .deleteClassifierSettings(lzId, classifierCode, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {IClassifierSettingsUpdate} classifierSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setClassifierSettings(
      lzId: number,
      classifierSettings: IClassifierSettingsUpdate,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .setClassifierSettings(lzId, classifierSettings, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {ISmsSettingsUpdate} updateSmsSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSmsSettings(
      lzId: number,
      updateSmsSettings: ISmsSettingsUpdate,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .updateSmsSettings(lzId, updateSmsSettings, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {ISmsSettingsUpdate} I2faSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update2faSettings(lzId: number, faSetting: I2faSettingsUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .update2faSettings(lzId, faSetting, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertLzPaymentBindingCredentials(
      lzId: number,
      lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .upsertLzPaymentBindingCredentials(lzId, lzGatewayCredentialsUpsert, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertLzSberIdCredentials(
      lzId: number,
      lzSberIdCredentialsUpsert: LzSberIdCredentialsUpsert,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .upsertLzSberIdCredentials(lzId, lzSberIdCredentialsUpsert, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertLzPaymentGatewayCredentials(
      lzId: number,
      lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .upsertLzPaymentGatewayCredentials(lzId, lzGatewayCredentialsUpsert, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzSettings(lzId: number, options?: any): AxiosPromise<LzSettings> {
      return LzControllerApiFp(configuration)
        .getLzSettings(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActiveClassifiers(lzId: number, options?: any): AxiosPromise<string[]> {
      return LzControllerApiFp(configuration)
        .getActiveClassifiers(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getForbiddenClassifiers(lzId: number, options?: any): AxiosPromise<ForbiddenClassifiersList> {
      return LzControllerApiFp(configuration)
        .getForbiddenClassifiers(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getClassifierSettings(lzId: number, options?: any): AxiosPromise<LzClassifierSettings[]> {
      return LzControllerApiFp(configuration)
        .getClassifierSettings(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {UpdateGatewaySettings} gatewaySettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateGatewaySettings(
      lzId: number,
      gatewaySettingsUpdate: UpdateGatewaySettings,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .updateGatewaySettings(lzId, gatewaySettingsUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdSettingsUpdate} sberIdSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSberIdSettings(
      lzId: number,
      sberIdSettings: SberIdSettingsUpdate,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .updateSberIdSettings(lzId, sberIdSettings, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdSettings(lzId: number, options?: any): AxiosPromise<SberIdInfo> {
      return LzControllerApiFp(configuration)
        .getSberIdSettings(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {SberIdSertificates} sertificates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadSberIdSertificates(
      lzId: number,
      sertificates: SberIdSertificates,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .loadSberIdSertificates(lzId, sertificates, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {File} sertificate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadClientSertificate(lzId: number, sertificate: File, options?: any): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .loadClientSertificate(lzId, sertificate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {any} additionalProps
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFrontStorage(lzId: number, additionalProps: any, options?: any): AxiosPromise<SuccessWrapper> {
      return LzControllerApiFp(configuration)
        .updateFrontStorage(lzId, additionalProps, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFrontStorage(lzId: number, options?: any): AxiosPromise<any> {
      return LzControllerApiFp(configuration)
        .getFrontStorage(lzId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * LzControllerApi - object-oriented interface
 * @export
 * @class LzControllerApi
 * @extends {BaseAPI}
 */
export class LzControllerApi extends BaseAPI {
  /**
   *
   * @param {LzCreate} lzCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzControllerApi
   */
  public createLz(lzCreate: LzCreate, options?: any) {
    return LzControllerApiFp(this.configuration)
      .createLz(lzCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzControllerApi
   */
  public getLz(lzId: number, options?: any) {
    return LzControllerApiFp(this.configuration)
      .getLz(lzId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} page
   * @param {string} [nameLike]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzControllerApi
   */
  public getLzInfoPage(page: number, nameLike?: string, options?: any) {
    return LzControllerApiFp(this.configuration)
      .getLzInfoPage(page, nameLike, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} page
   * @param {string} [nameLike]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzControllerApi
   */
  public getLzShortInfoPage(page: number, nameLike?: string, options?: any) {
    return LzControllerApiFp(this.configuration)
      .getLzShortInfoPage(page, nameLike, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {LzUpdate} lzUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzControllerApi
   */
  public updateLz(lzId: number, lzUpdate: LzUpdate, options?: any) {
    return LzControllerApiFp(this.configuration)
      .updateLz(lzId, lzUpdate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzControllerApi
   */
  public upsertLzPaymentBindingCredentials(
    lzId: number,
    lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
    options?: any,
  ) {
    return LzControllerApiFp(this.configuration)
      .upsertLzPaymentBindingCredentials(lzId, lzGatewayCredentialsUpsert, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {LzGatewayCredentialsUpsert} lzGatewayCredentialsUpsert
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LzControllerApi
   */
  public upsertLzPaymentGatewayCredentials(
    lzId: number,
    lzGatewayCredentialsUpsert: LzGatewayCredentialsUpsert,
    options?: any,
  ) {
    return LzControllerApiFp(this.configuration)
      .upsertLzPaymentGatewayCredentials(lzId, lzGatewayCredentialsUpsert, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * MetalTariffControllerApi - axios parameter creator
 * @export
 */
export const MetalTariffControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} pzuId
     * @param {MetalTariffCreate} metalTariffCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMetalTariff: async (
      pzuId: number,
      metalTariffCreate: MetalTariffCreate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling createMetalTariff.',
        );
      }
      // verify required parameter 'metalTariffCreate' is not null or undefined
      if (metalTariffCreate === null || metalTariffCreate === undefined) {
        throw new RequiredError(
          'metalTariffCreate',
          'Required parameter metalTariffCreate was null or undefined when calling createMetalTariff.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/metal-tariffs`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof metalTariffCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(metalTariffCreate !== undefined ? metalTariffCreate : {})
        : metalTariffCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} metalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMetalIdFavorite: async (lzId: number, metalId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling deleteMetalIdFavorite.',
        );
      }
      // verify required parameter 'metalId' is not null or undefined
      if (metalId === null || metalId === undefined) {
        throw new RequiredError(
          'metalId',
          'Required parameter metalId was null or undefined when calling deleteMetalIdFavorite.',
        );
      }
      const localVarPath = `/lzs/{lzId}/metal-dict-items/{metalId}`
        .replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)))
        .replace(`{${'metalId'}}`, encodeURIComponent(String(metalId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ClassifierCode} [classifierCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalDictList: async (classifierCode?: ClassifierCode, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/metal-dict-items`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (classifierCode !== undefined) {
        localVarQueryParameter['classifier-code'] = classifierCode;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {ClassifierCode} [classifierCode]
     * @param {string} [nameLike]
     * @param {boolean} [favorites]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalDictPageWithFavorites: async (
      lzId: number,
      page: number,
      classifierCode?: ClassifierCode,
      nameLike?: string,
      favorites?: boolean,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getMetalDictPageWithFavorites.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getMetalDictPageWithFavorites.',
        );
      }
      const localVarPath = `/v2/lzs/{lzId}/metal-dict-items`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (classifierCode !== undefined) {
        localVarQueryParameter['classifier-code'] = classifierCode;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      if (favorites !== undefined) {
        localVarQueryParameter['favorites'] = favorites;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ClassifierCode} [classifierCode]
     * @param {string} [nameLike]
     * @param {boolean} [favorites]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalDictWithFavorites: async (
      lzId: number,
      classifierCode?: ClassifierCode,
      nameLike?: string,
      favorites?: boolean,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getMetalDictWithFavorites.',
        );
      }
      const localVarPath = `/lzs/{lzId}/metal-dict-items`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (classifierCode !== undefined) {
        localVarQueryParameter['classifier-code'] = classifierCode;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      if (favorites !== undefined) {
        localVarQueryParameter['favorites'] = favorites;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} metalTariffId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffById: async (metalTariffId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'metalTariffId' is not null or undefined
      if (metalTariffId === null || metalTariffId === undefined) {
        throw new RequiredError(
          'metalTariffId',
          'Required parameter metalTariffId was null or undefined when calling getMetalTariffById.',
        );
      }
      const localVarPath = `/metal-tariffs/{metalTariffId}`.replace(
        `{${'metalTariffId'}}`,
        encodeURIComponent(String(metalTariffId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffListByPzuId: async (
      pzuId: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      priceFrom?: number,
      priceTo?: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling getMetalTariffListByPzuId.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/metal-tariffs`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (metalNameLike !== undefined) {
        localVarQueryParameter['metal-name-like'] = metalNameLike;
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses;
      }

      if (priceFrom !== undefined) {
        localVarQueryParameter['price-from'] = priceFrom;
      }

      if (priceTo !== undefined) {
        localVarQueryParameter['price-to'] = priceTo;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {Set<number>} [pzuIds]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffPageByLzId: async (
      lzId: number,
      page: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      pzuIds?: Set<number>,
      priceFrom?: number,
      priceTo?: number,
      metalClassifierCode?: string,
      sortList?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getMetalTariffPageByLzId.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getMetalTariffPageByLzId.',
        );
      }
      const localVarPath = `/lzs/{lzId}/metal-tariffs`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (metalNameLike !== undefined) {
        localVarQueryParameter['metal-name-like'] = metalNameLike;
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses;
      }

      if (pzuIds) {
        localVarQueryParameter['pzu-ids'] = pzuIds;
      }

      if (priceFrom) {
        localVarQueryParameter['price-from'] = priceFrom;
      }

      if (priceTo) {
        localVarQueryParameter['price-to'] = priceTo;
      }

      if (metalClassifierCode) {
        localVarQueryParameter['metal-classifier-code'] = metalClassifierCode;
      }

      if (sortList !== undefined) {
        localVarQueryParameter['sort'] = sortList;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffPageByPzuId: async (
      pzuId: number,
      page: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      priceFrom?: number,
      priceTo?: number,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling getMetalTariffPageByPzuId.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getMetalTariffPageByPzuId.',
        );
      }
      const localVarPath = `/v2/pzus/{pzuId}/metal-tariffs`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (metalNameLike !== undefined) {
        localVarQueryParameter['metal-name-like'] = metalNameLike;
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses;
      }

      if (priceFrom) {
        localVarQueryParameter['price-from'] = priceFrom;
      }

      if (priceTo) {
        localVarQueryParameter['price-to'] = priceTo;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ArrayWrapper} arrayWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setMetalDictWithFavorites: async (
      lzId: number,
      arrayWrapper: ArrayWrapper,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling setMetalDictWithFavorites.',
        );
      }
      // verify required parameter 'arrayWrapper' is not null or undefined
      if (arrayWrapper === null || arrayWrapper === undefined) {
        throw new RequiredError(
          'arrayWrapper',
          'Required parameter arrayWrapper was null or undefined when calling setMetalDictWithFavorites.',
        );
      }
      const localVarPath = `/lzs/{lzId}/metal-dict-items`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof arrayWrapper !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(arrayWrapper !== undefined ? arrayWrapper : {})
        : arrayWrapper || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} metalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setMetalIdFavorite: async (lzId: number, metalId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling setMetalIdFavorite.',
        );
      }
      // verify required parameter 'metalId' is not null or undefined
      if (metalId === null || metalId === undefined) {
        throw new RequiredError(
          'metalId',
          'Required parameter metalId was null or undefined when calling setMetalIdFavorite.',
        );
      }
      const localVarPath = `/lzs/{lzId}/metal-dict-items/{metalId}`
        .replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)))
        .replace(`{${'metalId'}}`, encodeURIComponent(String(metalId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} metalTariffId
     * @param {MetalTariffUpdate} metalTariffUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMetalTariff: async (
      metalTariffId: number,
      metalTariffUpdate: MetalTariffUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'metalTariffId' is not null or undefined
      if (metalTariffId === null || metalTariffId === undefined) {
        throw new RequiredError(
          'metalTariffId',
          'Required parameter metalTariffId was null or undefined when calling updateMetalTariff.',
        );
      }
      // verify required parameter 'metalTariffUpdate' is not null or undefined
      if (metalTariffUpdate === null || metalTariffUpdate === undefined) {
        throw new RequiredError(
          'metalTariffUpdate',
          'Required parameter metalTariffUpdate was null or undefined when calling updateMetalTariff.',
        );
      }
      const localVarPath = `/metal-tariffs/{metalTariffId}`.replace(
        `{${'metalTariffId'}}`,
        encodeURIComponent(String(metalTariffId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof metalTariffUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(metalTariffUpdate !== undefined ? metalTariffUpdate : {})
        : metalTariffUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MetalTariffControllerApi - functional programming interface
 * @export
 */
export const MetalTariffControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} pzuId
     * @param {MetalTariffCreate} metalTariffCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createMetalTariff(
      pzuId: number,
      metalTariffCreate: MetalTariffCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(configuration).createMetalTariff(
        pzuId,
        metalTariffCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} metalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteMetalIdFavorite(
      lzId: number,
      metalId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(configuration).deleteMetalIdFavorite(
        lzId,
        metalId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {ClassifierCode} [classifierCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMetalDictList(
      classifierCode?: ClassifierCode,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetalDictItem>>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(configuration).getMetalDictList(
        classifierCode,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {ClassifierCode} [classifierCode]
     * @param {string} [nameLike]
     * @param {boolean} [favorites]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMetalDictPageWithFavorites(
      lzId: number,
      page: number,
      classifierCode?: ClassifierCode,
      nameLike?: string,
      favorites?: boolean,
      sort?: Array<string>,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperMetalDictItemWithFavorites>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(
        configuration,
      ).getMetalDictPageWithFavorites(lzId, page, classifierCode, nameLike, favorites, sort, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ClassifierCode} [classifierCode]
     * @param {string} [nameLike]
     * @param {boolean} [favorites]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMetalDictWithFavorites(
      lzId: number,
      classifierCode?: ClassifierCode,
      nameLike?: string,
      favorites?: boolean,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetalDictItemWithFavorites>>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(
        configuration,
      ).getMetalDictWithFavorites(lzId, classifierCode, nameLike, favorites, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} metalTariffId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMetalTariffById(
      metalTariffId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetalTariffWithLz>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(configuration).getMetalTariffById(
        metalTariffId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMetalTariffListByPzuId(
      pzuId: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      priceFrom?: number,
      priceTo?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetalTariffWithLz>>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(
        configuration,
      ).getMetalTariffListByPzuId(pzuId, metalNameLike, statuses, priceFrom, priceTo, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {Set<number>} [pzuIds]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMetalTariffPageByLzId(
      lzId: number,
      page: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      pzuIds?: Set<number>,
      priceFrom?: number,
      priceTo?: number,
      metalClassifierCode?: string,
      sortList?: Array<string>,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperMetalTariffWithLz>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(configuration).getMetalTariffPageByLzId(
        lzId,
        page,
        metalNameLike,
        statuses,
        pzuIds,
        priceFrom,
        priceTo,
        metalClassifierCode,
        sortList,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMetalTariffPageByPzuId(
      pzuId: number,
      page: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      priceFrom?: number,
      priceTo?: number,
      sort?: Array<string>,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperMetalTariffWithLz>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(
        configuration,
      ).getMetalTariffPageByPzuId(pzuId, page, metalNameLike, statuses, priceFrom, priceTo, sort, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {ArrayWrapper} arrayWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setMetalDictWithFavorites(
      lzId: number,
      arrayWrapper: ArrayWrapper,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(
        configuration,
      ).setMetalDictWithFavorites(lzId, arrayWrapper, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} metalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setMetalIdFavorite(
      lzId: number,
      metalId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(configuration).setMetalIdFavorite(
        lzId,
        metalId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} metalTariffId
     * @param {MetalTariffUpdate} metalTariffUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateMetalTariff(
      metalTariffId: number,
      metalTariffUpdate: MetalTariffUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await MetalTariffControllerApiAxiosParamCreator(configuration).updateMetalTariff(
        metalTariffId,
        metalTariffUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * MetalTariffControllerApi - factory interface
 * @export
 */
export const MetalTariffControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} pzuId
     * @param {MetalTariffCreate} metalTariffCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMetalTariff(pzuId: number, metalTariffCreate: MetalTariffCreate, options?: any): AxiosPromise<IdWrapper> {
      return MetalTariffControllerApiFp(configuration)
        .createMetalTariff(pzuId, metalTariffCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {number} metalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMetalIdFavorite(lzId: number, metalId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return MetalTariffControllerApiFp(configuration)
        .deleteMetalIdFavorite(lzId, metalId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {ClassifierCode} [classifierCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalDictList(classifierCode?: ClassifierCode, options?: any): AxiosPromise<Array<MetalDictItem>> {
      return MetalTariffControllerApiFp(configuration)
        .getMetalDictList(classifierCode, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {ClassifierCode} [classifierCode]
     * @param {string} [nameLike]
     * @param {boolean} [favorites]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalDictPageWithFavorites(
      lzId: number,
      page: number,
      classifierCode?: ClassifierCode,
      nameLike?: string,
      favorites?: boolean,
      sort?: Array<string>,
      options?: any,
    ): AxiosPromise<PageWrapperMetalDictItemWithFavorites> {
      return MetalTariffControllerApiFp(configuration)
        .getMetalDictPageWithFavorites(lzId, page, classifierCode, nameLike, favorites, sort, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {ClassifierCode} [classifierCode]
     * @param {string} [nameLike]
     * @param {boolean} [favorites]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalDictWithFavorites(
      lzId: number,
      classifierCode?: ClassifierCode,
      nameLike?: string,
      favorites?: boolean,
      options?: any,
    ): AxiosPromise<Array<MetalDictItemWithFavorites>> {
      return MetalTariffControllerApiFp(configuration)
        .getMetalDictWithFavorites(lzId, classifierCode, nameLike, favorites, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} metalTariffId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffById(metalTariffId: number, options?: any): AxiosPromise<MetalTariffWithLz> {
      return MetalTariffControllerApiFp(configuration)
        .getMetalTariffById(metalTariffId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffListByPzuId(
      pzuId: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      priceFrom?: number,
      priceTo?: number,
      options?: any,
    ): AxiosPromise<Array<MetalTariffWithLz>> {
      return MetalTariffControllerApiFp(configuration)
        .getMetalTariffListByPzuId(pzuId, metalNameLike, statuses, priceFrom, priceTo, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {Set<number>} [pzuIds]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffPageByLzId(
      lzId: number,
      page: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      pzuIds?: Set<number>,
      priceFrom?: number,
      priceTo?: number,
      metalClassifierCode?: string,
      sortList?: Array<string>,
      options?: any,
    ): AxiosPromise<PageWrapperMetalTariffWithLz> {
      return MetalTariffControllerApiFp(configuration)
        .getMetalTariffPageByLzId(
          lzId,
          page,
          metalNameLike,
          statuses,
          pzuIds,
          priceFrom,
          priceTo,
          metalClassifierCode,
          sortList,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {string} [metalNameLike]
     * @param {Set<MetalTariffStatus>} [statuses]
     * @param {number} [priceFrom]
     * @param {number} [priceTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMetalTariffPageByPzuId(
      pzuId: number,
      page: number,
      metalNameLike?: string,
      statuses?: Set<MetalTariffStatus>,
      priceFrom?: number,
      priceTo?: number,
      sort?: Array<string>,
      options?: any,
    ): AxiosPromise<PageWrapperMetalTariffWithLz> {
      return MetalTariffControllerApiFp(configuration)
        .getMetalTariffPageByPzuId(pzuId, page, metalNameLike, statuses, priceFrom, priceTo, sort, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {ArrayWrapper} arrayWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setMetalDictWithFavorites(lzId: number, arrayWrapper: ArrayWrapper, options?: any): AxiosPromise<SuccessWrapper> {
      return MetalTariffControllerApiFp(configuration)
        .setMetalDictWithFavorites(lzId, arrayWrapper, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {number} metalId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setMetalIdFavorite(lzId: number, metalId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return MetalTariffControllerApiFp(configuration)
        .setMetalIdFavorite(lzId, metalId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} metalTariffId
     * @param {MetalTariffUpdate} metalTariffUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMetalTariff(
      metalTariffId: number,
      metalTariffUpdate: MetalTariffUpdate,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return MetalTariffControllerApiFp(configuration)
        .updateMetalTariff(metalTariffId, metalTariffUpdate, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * MetalTariffControllerApi - object-oriented interface
 * @export
 * @class MetalTariffControllerApi
 * @extends {BaseAPI}
 */
export class MetalTariffControllerApi extends BaseAPI {
  /**
   *
   * @param {number} pzuId
   * @param {MetalTariffCreate} metalTariffCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public createMetalTariff(pzuId: number, metalTariffCreate: MetalTariffCreate, options?: any) {
    return MetalTariffControllerApiFp(this.configuration)
      .createMetalTariff(pzuId, metalTariffCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {number} metalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public deleteMetalIdFavorite(lzId: number, metalId: number, options?: any) {
    return MetalTariffControllerApiFp(this.configuration)
      .deleteMetalIdFavorite(lzId, metalId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ClassifierCode} [classifierCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public getMetalDictList(classifierCode?: ClassifierCode, options?: any) {
    return MetalTariffControllerApiFp(this.configuration)
      .getMetalDictList(classifierCode, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {number} page
   * @param {ClassifierCode} [classifierCode]
   * @param {string} [nameLike]
   * @param {boolean} [favorites]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public getMetalDictPageWithFavorites(
    lzId: number,
    page: number,
    classifierCode?: ClassifierCode,
    nameLike?: string,
    favorites?: boolean,
    options?: any,
  ) {
    return MetalTariffControllerApiFp(this.configuration)
      .getMetalDictPageWithFavorites(lzId, page, classifierCode, nameLike, favorites, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {ClassifierCode} [classifierCode]
   * @param {string} [nameLike]
   * @param {boolean} [favorites]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public getMetalDictWithFavorites(
    lzId: number,
    classifierCode?: ClassifierCode,
    nameLike?: string,
    favorites?: boolean,
    options?: any,
  ) {
    return MetalTariffControllerApiFp(this.configuration)
      .getMetalDictWithFavorites(lzId, classifierCode, nameLike, favorites, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} metalTariffId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public getMetalTariffById(metalTariffId: number, options?: any) {
    return MetalTariffControllerApiFp(this.configuration)
      .getMetalTariffById(metalTariffId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {string} [metalNameLike]
   * @param {Set<MetalTariffStatus>} [statuses]
   * @param {number} [priceFrom]
   * @param {number} [priceTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public getMetalTariffListByPzuId(
    pzuId: number,
    metalNameLike?: string,
    statuses?: Set<MetalTariffStatus>,
    priceFrom?: number,
    priceTo?: number,
    options?: any,
  ) {
    return MetalTariffControllerApiFp(this.configuration)
      .getMetalTariffListByPzuId(pzuId, metalNameLike, statuses, priceFrom, priceTo, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {number} page
   * @param {string} [metalNameLike]
   * @param {Set<MetalTariffStatus>} [statuses]
   * @param {Set<number>} [pzuIds]
   * @param {number} [priceFrom]
   * @param {number} [priceTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public getMetalTariffPageByLzId(
    lzId: number,
    page: number,
    metalNameLike?: string,
    statuses?: Set<MetalTariffStatus>,
    pzuIds?: Set<number>,
    priceFrom?: number,
    priceTo?: number,
    options?: any,
  ) {
    return MetalTariffControllerApiFp(this.configuration)
      .getMetalTariffPageByLzId(lzId, page, metalNameLike, statuses, pzuIds, priceFrom, priceTo, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {number} page
   * @param {string} [metalNameLike]
   * @param {Set<MetalTariffStatus>} [statuses]
   * @param {number} [priceFrom]
   * @param {number} [priceTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public getMetalTariffPageByPzuId(
    pzuId: number,
    page: number,
    metalNameLike?: string,
    statuses?: Set<MetalTariffStatus>,
    priceFrom?: number,
    priceTo?: number,
    options?: any,
  ) {
    return MetalTariffControllerApiFp(this.configuration)
      .getMetalTariffPageByPzuId(pzuId, page, metalNameLike, statuses, priceFrom, priceTo, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {ArrayWrapper} arrayWrapper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public setMetalDictWithFavorites(lzId: number, arrayWrapper: ArrayWrapper, options?: any) {
    return MetalTariffControllerApiFp(this.configuration)
      .setMetalDictWithFavorites(lzId, arrayWrapper, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {number} metalId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public setMetalIdFavorite(lzId: number, metalId: number, options?: any) {
    return MetalTariffControllerApiFp(this.configuration)
      .setMetalIdFavorite(lzId, metalId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} metalTariffId
   * @param {MetalTariffUpdate} metalTariffUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetalTariffControllerApi
   */
  public updateMetalTariff(metalTariffId: number, metalTariffUpdate: MetalTariffUpdate, options?: any) {
    return MetalTariffControllerApiFp(this.configuration)
      .updateMetalTariff(metalTariffId, metalTariffUpdate, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PaymentControllerApi - axios parameter creator
 * @export
 */
export const PaymentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {BindingCreate} bindingCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBinding: async (lzId: number, bindingCreate: BindingCreate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createBinding.');
      }
      // verify required parameter 'bindingCreate' is not null or undefined
      if (bindingCreate === null || bindingCreate === undefined) {
        throw new RequiredError(
          'bindingCreate',
          'Required parameter bindingCreate was null or undefined when calling createBinding.',
        );
      }
      const localVarPath = `/lzs/{lzId}/binding-create`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof bindingCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(bindingCreate !== undefined ? bindingCreate : {})
        : bindingCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {UrlWrapper} urlWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFormUrl: async (lzId: number, urlWrapper: UrlWrapper, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling createFormUrl.');
      }
      // verify required parameter 'urlWrapper' is not null or undefined
      if (urlWrapper === null || urlWrapper === undefined) {
        throw new RequiredError(
          'urlWrapper',
          'Required parameter urlWrapper was null or undefined when calling createFormUrl.',
        );
      }
      const localVarPath = `/lzs/{lzId}/binding-form`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof urlWrapper !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(urlWrapper !== undefined ? urlWrapper : {})
        : urlWrapper || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {string} smsCode
     * @param {PaymentCreate} paymentCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPayment: async (
      psaId: number,
      paymentCreate: PaymentCreate,
      smsCode?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter psaId was null or undefined when calling createPayment.');
      }
      // verify required parameter 'paymentCreate' is not null or undefined
      if (paymentCreate === null || paymentCreate === undefined) {
        throw new RequiredError(
          'paymentCreate',
          'Required parameter paymentCreate was null or undefined when calling createPayment.',
        );
      }
      const localVarPath = `/psas/{psaId}/payments`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (smsCode && smsCode !== '') {
        localVarQueryParameter['sms-code'] = smsCode;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof paymentCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(paymentCreate !== undefined ? paymentCreate : {})
        : paymentCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * @param {StatementCorrection} statementCorrection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statementCorrection: async (statementCorrection: StatementCorrection, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'statementCorrection' is not null or undefined
      if (statementCorrection === null || statementCorrection === undefined) {
        throw new RequiredError(
          'statementCorrection',
          'Required parameter statementCorrection was null or undefined when calling statementCorrection.',
        );
      }
      const localVarPath = `/lzs/{lzId}/payments/fix-payment-descriptions`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(statementCorrection.lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (statementCorrection['payment-created-at-from']) {
        localVarQueryParameter['payment-created-at-from'] = statementCorrection['payment-created-at-from'];
      }

      localVarQueryParameter['encoding-to'] = 'utf-8';

      if (statementCorrection['payment-created-at-to']) {
        localVarQueryParameter['payment-created-at-to'] = statementCorrection['payment-created-at-to'];
      }

      if (statementCorrection['file']) {
        localVarFormParams.append('file', statementCorrection['file'] as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentFullInfo: async (paymentId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'paymentId' is not null or undefined
      if (paymentId === null || paymentId === undefined) {
        throw new RequiredError(
          'paymentId',
          'Required parameter paymentId was null or undefined when calling getPaymentFullInfo.',
        );
      }
      const localVarPath = `/payments/{paymentId}`.replace(`{${'paymentId'}}`, encodeURIComponent(String(paymentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaPayments: async (psaId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError(
          'psaId',
          'Required parameter psaId was null or undefined when calling getPaymentFullInfo.',
        );
      }
      const localVarPath = `psas/{psaId}/payments`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} phone
     * @param {string} template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSmsCode: async (phone: string, template?: string, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'paymentId' is not null or undefined
      if (phone === null || phone === undefined) {
        throw new RequiredError('phone', 'Required parameter paymentId was null or undefined when calling getSmsCode.');
      }
      const localVarPath = '/sms/random-code';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (phone) {
        localVarQueryParameter['phone'] = phone;
      }

      if (template) {
        localVarQueryParameter['template'] = template;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaItemsDataSet: async (
      { paymentCreatedAtFrom, paymentCreatedAtTo, lzIds }: IPsaItemsDataset,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/reports/psa-items/dataset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (paymentCreatedAtFrom) {
        localVarQueryParameter['payment-created-at-from'] =
          (paymentCreatedAtFrom as any) instanceof Date
            ? (paymentCreatedAtFrom as any).toISOString()
            : paymentCreatedAtFrom;
      }

      if (paymentCreatedAtTo) {
        localVarQueryParameter['payment-created-at-to'] =
          (paymentCreatedAtTo as any) instanceof Date ? (paymentCreatedAtTo as any).toISOString() : paymentCreatedAtTo;
      }

      if (lzIds) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupCommissions: async (
      page: number,
      lzIds?: number[],
      statuses?: PaymentStatus[],
      startDate?: string,
      endDate?: string,
      spFeePaymentFrom?: number,
      spFeePaymentTo?: number,
      businessCardId?: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getGroupCommissions.',
        );
      }
      const localVarPath = '/group-commissions';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (lzIds && lzIds.length) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }

      if (businessCardId) {
        localVarQueryParameter['business-card-id'] = businessCardId;
      }

      if (statuses && statuses.length) {
        localVarQueryParameter['statuses'] = statuses;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['start-date'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['end-date'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }

      if (spFeePaymentFrom) {
        localVarQueryParameter['sp-fee-payment-from'] = spFeePaymentFrom;
      }

      if (spFeePaymentTo) {
        localVarQueryParameter['sp-fee-payment-to'] = spFeePaymentTo;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdPayments: async (page: number, options: any = {}): Promise<RequestArgs> => {
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getGroupCommissions.',
        );
      }
      const localVarPath = '/sber-api/payments';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createGroupPayment: async (paymentId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (paymentId === null || paymentId === undefined) {
        throw new RequiredError(
          'paymentId',
          'Required parameter psaId was null or undefined when calling createGroupPayment.',
        );
      }

      const localVarPath = `/group-commissions/{paymentId}/perform-payment`.replace(
        `{${'paymentId'}}`,
        encodeURIComponent(String(paymentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    repeatErrorPayment: async (paymentId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (paymentId === null || paymentId === undefined) {
        throw new RequiredError(
          'paymentId',
          'Required parameter psaId was null or undefined when calling repeatErrorPayment.',
        );
      }

      const localVarPath = `/group-commissions/{paymentId}/repeat-error-payment`.replace(
        `{${'paymentId'}}`,
        encodeURIComponent(String(paymentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupCommissionsByPaymentId: async (paymentId: number, options: any = {}): Promise<RequestArgs> => {
      if (paymentId === null || paymentId === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getGroupCommissionsByPaymentId.',
        );
      }
      const localVarPath = `/group-commissions/{paymentId}/children`.replace(
        `{${'paymentId'}}`,
        encodeURIComponent(String(paymentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [idLike?]
     * @param {number[]} [lzIds?]
     * @param {number[]} [pzuIds?]
     * @param {PaymentStatus[]} [statuses?]
     * @param {string} [startDate?]
     * @param {string} [endDate?]
     * @param {number} [lzClientPaymentFrom?]
     * @param {number} [lzClientPaymentTo?]
     * @param {Array<string>} [sort?]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentsPage: async (
      page: number,
      idLike?: string | undefined,
      lzIds?: number[] | undefined,
      pzuIds?: number[] | undefined,
      statuses?: PaymentStatus[] | undefined,
      startDate?: string | undefined,
      endDate?: string | undefined,
      lzClientPaymentFrom?: number | undefined,
      lzClientPaymentTo?: number | undefined,
      paymentType?: string | undefined,
      gatewayType?: string,
      sort?: string[] | undefined,
      lzClientId?: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError('page', 'Required parameter page was null or undefined when calling getPaymentsPage.');
      }
      const localVarPath = `/payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (idLike !== undefined) {
        localVarQueryParameter['id-like'] = idLike;
      }

      if (lzIds) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }

      if (pzuIds) {
        localVarQueryParameter['pzu-ids'] = pzuIds;
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['start-date'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['end-date'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }

      if (lzClientPaymentFrom !== undefined) {
        localVarQueryParameter['lz-client-payment-from'] = lzClientPaymentFrom;
      }

      if (lzClientPaymentTo !== undefined) {
        localVarQueryParameter['lz-client-payment-to'] = lzClientPaymentTo;
      }

      if (paymentType !== undefined) {
        localVarQueryParameter['payment-type'] = paymentType;
      }

      if (gatewayType !== undefined) {
        localVarQueryParameter['gateway-types'] = gatewayType;
      }

      if (lzClientId !== undefined) {
        localVarQueryParameter['lz-client-id'] = lzClientId;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PaymentControllerApi - functional programming interface
 * @export
 */
export const PaymentControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {BindingCreate} bindingCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createBinding(
      lzId: number,
      bindingCreate: BindingCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).createBinding(
        lzId,
        bindingCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {UrlWrapper} urlWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createFormUrl(
      lzId: number,
      urlWrapper: UrlWrapper,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrlWrapper>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).createFormUrl(
        lzId,
        urlWrapper,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {string} smsCode
     * @param {PaymentCreate} paymentCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPayment(
      psaId: number,
      paymentCreate: PaymentCreate,
      smsCode?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).createPayment(
        psaId,
        paymentCreate,
        smsCode,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * @param {StatementCorrection} statementCorrection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async statementCorrection(
      statementCorrection: StatementCorrection,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatementCorrection>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).statementCorrection(
        statementCorrection,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentFullInfo(
      paymentId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentFullInfo>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).getPaymentFullInfo(
        paymentId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },

    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaPayments(
      psaId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PsaPaymentList>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).getPsaPayments(
        psaId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} phone
     * @param {string} template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSmsCode(
      phone: string,
      template?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentFullInfo>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).getSmsCode(
        phone,
        template,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaItemsDataSet(
      filterList: IPsaItemsDataset,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string[]>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).getPsaItemsDataSet(
        filterList,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGroupCommissions(
      page: number,
      lzIds?: number[],
      statuses?: PaymentStatus[],
      startDate?: string,
      endDate?: string,
      spFeePaymentFrom?: number,
      spFeePaymentTo?: number,
      businessCardId?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperGroupCommissionPayment>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).getGroupCommissions(
        page,
        lzIds,
        statuses,
        startDate,
        endDate,
        spFeePaymentFrom,
        spFeePaymentTo,
        businessCardId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSberIdPayments(
      page: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperSberIdPayments>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).getSberIdPayments(
        page,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGroupCommissionsByPaymentId(
      paymentId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentFullInfo[]>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(
        configuration,
      ).getGroupCommissionsByPaymentId(paymentId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createGroupPayment(
      paymentId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).createGroupPayment(
        paymentId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async repeatErrorPayment(
      paymentId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).repeatErrorPayment(
        paymentId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [idLike?]
     * @param {number[]} [lzIds?]
     * @param {number[]} [pzuIds?]
     * @param {Set<PaymentStatus>} [statuses?]
     * @param {string} [startDate?]
     * @param {string} [endDate?]
     * @param {number} [lzClientPaymentFrom?]
     * @param {number} [lzClientPaymentTo?]
     * @param {string} [paymentType?]
     * @param {Array<string>} [sort?]
     * @param {*} [options?] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentsPage(
      page: number,
      idLike?: string | undefined,
      pzuIds?: number[] | undefined,
      statuses?: PaymentStatus[] | undefined,
      startDate?: string | undefined,
      endDate?: string | undefined,
      lzClientPaymentFrom?: number | undefined,
      lzClientPaymentTo?: number | undefined,
      paymentType?: string | undefined,
      gatewayType?: string,
      sort?: string[] | undefined,
      lzIds?: number[] | undefined,
      lzClientId?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPaymentWithPzuAndClient>> {
      const localVarAxiosArgs = await PaymentControllerApiAxiosParamCreator(configuration).getPaymentsPage(
        page,
        idLike,
        lzIds,
        pzuIds,
        statuses,
        startDate,
        endDate,
        lzClientPaymentFrom,
        lzClientPaymentTo,
        paymentType,
        gatewayType,
        sort,
        lzClientId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PaymentControllerApi - factory interface
 * @export
 */
export const PaymentControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {BindingCreate} bindingCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createBinding(lzId: number, bindingCreate: BindingCreate, options?: any): AxiosPromise<IdWrapper> {
      return PaymentControllerApiFp(configuration)
        .createBinding(lzId, bindingCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {UrlWrapper} urlWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createFormUrl(lzId: number, urlWrapper: UrlWrapper, options?: any): AxiosPromise<UrlWrapper> {
      return PaymentControllerApiFp(configuration)
        .createFormUrl(lzId, urlWrapper, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {PaymentCreate} paymentCreate
     * @param {string} smsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPayment(
      psaId: number,
      paymentCreate: PaymentCreate,
      smsCode?: string,
      options?: any,
    ): AxiosPromise<IdWrapper> {
      return PaymentControllerApiFp(configuration)
        .createPayment(psaId, paymentCreate, smsCode, options)
        .then(request => request(axios, basePath));
    },
    /**
     * @param {StatementCorrection} statementCorrection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    statementCorrection(statementCorrection: StatementCorrection, options?: any): AxiosPromise<StatementCorrection> {
      return PaymentControllerApiFp(configuration)
        .statementCorrection(statementCorrection, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentFullInfo(paymentId: number, options?: any): AxiosPromise<PaymentFullInfo> {
      return PaymentControllerApiFp(configuration)
        .getPaymentFullInfo(paymentId, options)
        .then(request => request(axios, basePath));
    },

    /**
     *
     * @param {number} paymentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaPayments(psaId: number, options?: any): AxiosPromise<PsaPaymentList> {
      return PaymentControllerApiFp(configuration)
        .getPsaPayments(psaId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} phone
     * @param {string} template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSmsCode(phone: string, template?: string, options?: any): AxiosPromise<PaymentFullInfo> {
      return PaymentControllerApiFp(configuration)
        .getSmsCode(phone, template, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaItemsDataSet(filterList: IPsaItemsDataset, options?: any): AxiosPromise<string[]> {
      return PaymentControllerApiFp(configuration)
        .getPsaItemsDataSet(filterList, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupCommissions(
      page: number,
      lzIds?: number[],
      statuses?: PaymentStatus[],
      startDate?: string,
      endDate?: string,
      spFeePaymentFrom?: number,
      spFeePaymentTo?: number,
      businessCardId?: number,
      options?: any,
    ): AxiosPromise<PageWrapperGroupCommissionPayment> {
      return PaymentControllerApiFp(configuration)
        .getGroupCommissions(
          page,
          lzIds,
          statuses,
          startDate,
          endDate,
          spFeePaymentFrom,
          spFeePaymentTo,
          businessCardId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [number] page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSberIdPayments(page: number, options?: any): AxiosPromise<PageWrapperSberIdPayments> {
      return PaymentControllerApiFp(configuration)
        .getSberIdPayments(page, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroupCommissionsByPaymentId(paymentId: number, options?: any): AxiosPromise<PaymentFullInfo[]> {
      return PaymentControllerApiFp(configuration)
        .getGroupCommissionsByPaymentId(paymentId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createGroupPayment(paymentId: number, options?: any): AxiosPromise<IdWrapper> {
      return PaymentControllerApiFp(configuration)
        .createGroupPayment(paymentId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    repeatErrorPayment(paymentId: number, options?: any): AxiosPromise<IdWrapper> {
      return PaymentControllerApiFp(configuration)
        .repeatErrorPayment(paymentId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [idLike]
     * @param {Set<number>} [pzuIds]
     * @param {PaymentStatus[]} [statuses]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number} [lzClientPaymentFrom]
     * @param {number} [lzClientPaymentTo]
     * @param {string} [paymentType]
     * @param {string} [gatewayType]
     * @param {number} [lzClientId]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentsPage(
      page: number,
      idLike?: string | undefined,
      lzIds?: number[] | undefined,
      pzuIds?: number[] | undefined,
      statuses?: PaymentStatus[] | undefined,
      startDate?: string | undefined,
      endDate?: string | undefined,
      lzClientPaymentFrom?: number | undefined,
      lzClientPaymentTo?: number | undefined,
      paymentType?: string | undefined,
      gatewayType?: string,
      lzClientId?: number,
      sort?: string[] | undefined,
      options?: any,
    ): AxiosPromise<PageWrapperPaymentWithPzuAndClient> {
      return PaymentControllerApiFp(configuration)
        .getPaymentsPage(
          page,
          idLike,
          pzuIds,
          statuses,
          startDate,
          endDate,
          lzClientPaymentFrom,
          lzClientPaymentTo,
          paymentType,
          gatewayType,
          sort,
          lzIds,
          lzClientId,
          options,
        )
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PaymentControllerApi - object-oriented interface
 * @export
 * @class PaymentControllerApi
 * @extends {BaseAPI}
 */
export class PaymentControllerApi extends BaseAPI {
  /**
   *
   * @param {number} lzId
   * @param {BindingCreate} bindingCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentControllerApi
   */
  public createBinding(lzId: number, bindingCreate: BindingCreate, options?: any) {
    return PaymentControllerApiFp(this.configuration)
      .createBinding(lzId, bindingCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {UrlWrapper} urlWrapper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentControllerApi
   */
  public createFormUrl(lzId: number, urlWrapper: UrlWrapper, options?: any) {
    return PaymentControllerApiFp(this.configuration)
      .createFormUrl(lzId, urlWrapper, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} psaId
   * @param {PaymentCreate} paymentCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentControllerApi
   */
  public createPayment(psaId: number, paymentCreate: PaymentCreate, options?: any) {
    return PaymentControllerApiFp(this.configuration)
      .createPayment(psaId, paymentCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} paymentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentControllerApi
   */
  public getPaymentFullInfo(paymentId: number, options?: any) {
    return PaymentControllerApiFp(this.configuration)
      .getPaymentFullInfo(paymentId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} page
   * @param {string} [idLike]
   * @param {Set<number>} [pzuIds]
   * @param {Set<PaymentStatus>} [statuses]
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {number} [lzClientPaymentFrom]
   * @param {number} [lzClientPaymentTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentControllerApi
   */
  public getPaymentsPage(
    page: number,
    idLike?: string,
    pzuIds?: number[] | undefined,
    statuses?: PaymentStatus[] | undefined,
    startDate?: string,
    endDate?: string,
    lzClientPaymentFrom?: number,
    lzClientPaymentTo?: number,
    options?: any,
  ) {
    return PaymentControllerApiFp(this.configuration)
      .getPaymentsPage(
        page,
        idLike,
        pzuIds,
        statuses,
        startDate,
        endDate,
        lzClientPaymentFrom,
        lzClientPaymentTo,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PsaControllerApi - axios parameter creator
 * @export
 */
export const PsaControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} psaId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPsaScan: async (psaId: number, file?: any, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter psaId was null or undefined when calling addPsaScan.');
      }
      const localVarPath = `/psas/{psaId}/scans`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {PsaCreate} psaCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPsa: async (pzuId: number, psaCreate: PsaCreate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError('pzuId', 'Required parameter pzuId was null or undefined when calling createPsa.');
      }
      // verify required parameter 'psaCreate' is not null or undefined
      if (psaCreate === null || psaCreate === undefined) {
        throw new RequiredError(
          'psaCreate',
          'Required parameter psaCreate was null or undefined when calling createPsa.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/psas`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (psaCreate.vehicleCheckId) {
        localVarQueryParameter['vehicle-check-id'] = psaCreate.vehicleCheckId;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }

      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof psaCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(psaCreate !== undefined ? psaCreate : {})
        : psaCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaSetStatus} psaSetStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPsaStatus: async (psaId: number, psaSetStatus: PsaSetStatus, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter pzuId was null or undefined when calling setPsaStatus.');
      }

      const localVarPath = `/psas/{psaId}/set-status`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof psaSetStatus !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(psaSetStatus !== undefined ? psaSetStatus : {})
        : psaSetStatus || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaItemCreate} psaItemCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPsaItem: async (psaId: number, psaItemCreate: PsaItemCreate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter psaId was null or undefined when calling createPsaItem.');
      }
      // verify required parameter 'psaItemCreate' is not null or undefined
      if (psaItemCreate === null || psaItemCreate === undefined) {
        throw new RequiredError(
          'psaItemCreate',
          'Required parameter psaItemCreate was null or undefined when calling createPsaItem.',
        );
      }
      const localVarPath = `/psas/{psaId}/psa-items`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof psaItemCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(psaItemCreate !== undefined ? psaItemCreate : {})
        : psaItemCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePsaItem: async (psaItemId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaItemId' is not null or undefined
      if (psaItemId === null || psaItemId === undefined) {
        throw new RequiredError(
          'psaItemId',
          'Required parameter psaItemId was null or undefined when calling deletePsaItem.',
        );
      }
      const localVarPath = `/psa-items/{psaItemId}`.replace(`{${'psaItemId'}}`, encodeURIComponent(String(psaItemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePsaScan: async (scanId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'scanId' is not null or undefined
      if (scanId === null || scanId === undefined) {
        throw new RequiredError(
          'scanId',
          'Required parameter scanId was null or undefined when calling deletePsaScan.',
        );
      }
      const localVarPath = `/scans/{scanId}`.replace(`{${'scanId'}}`, encodeURIComponent(String(scanId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePsa: async (psaId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'scanId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter psaId was null or undefined when calling deletePsa.');
      }
      const localVarPath = `/psas/{psaId}`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaItemList: async (psaId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter psaId was null or undefined when calling getPsaItemList.');
      }
      const localVarPath = `/psas/{psaId}/psa-items`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPassportReport: async (lzClientId: number, psaId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling getPsaItemList.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/passport-check-info`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (psaId) {
        localVarQueryParameter['psaId'] = psaId;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaScan: async (scanId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'scanId' is not null or undefined
      if (scanId === null || scanId === undefined) {
        throw new RequiredError('scanId', 'Required parameter scanId was null or undefined when calling getPsaScan.');
      }
      const localVarPath = `/scans/{scanId}`.replace(`{${'scanId'}}`, encodeURIComponent(String(scanId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaScanPassport: async (lzClientId?: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzClientId' is not null or undefined
      if (lzClientId === null || lzClientId === undefined) {
        throw new RequiredError(
          'lzClientId',
          'Required parameter lzClientId was null or undefined when calling getPsaScan.',
        );
      }
      const localVarPath = `/lz-clients/{lzClientId}/passport-scan`.replace(
        `{${'lzClientId'}}`,
        encodeURIComponent(String(lzClientId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {number} [idLike]
     * @param {EPaymentMethod} [paymentType]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaTotalPaymentsPage: async (
      page: number,
      idLike?: number,
      paymentType?: EPaymentMethod,
      sort?: Array<string>,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getPsaTotalPaymentsPage.',
        );
      }
      const localVarPath = `/psas/total-payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (idLike !== undefined) {
        localVarQueryParameter['id-like'] = idLike;
      }

      if (paymentType !== undefined) {
        localVarQueryParameter['payment-type'] = paymentType;
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaForPartyPayments: async (page: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getPsaTotalPaymentsPage.',
        );
      }
      const localVarPath = `/v2/psas/total-payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      // if (idLike !== undefined) {
      //   localVarQueryParameter['id-like'] = idLike;
      // }

      // if (paymentType !== undefined) {
      //   localVarQueryParameter['payment-type'] = paymentType;
      // }

      // if (sort !== undefined) {
      //   localVarQueryParameter['sort'] = sort;
      // }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaWithClientAndScan: async (psaId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError(
          'psaId',
          'Required parameter psaId was null or undefined when calling getPsaWithClientAndScan.',
        );
      }
      const localVarPath = `/psas/{psaId}`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaIndexesById: async (psaId: string, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError(
          'psaId',
          'Required parameter psaId was null or undefined when calling getPsaWithClientAndScan.',
        );
      }
      const localVarPath = `/compliance/psa-indexes/{psaId}`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {string} [lzNameLike]
     * @param {number} [idLike]
     * @param {Set<number>} [pzuIds]
     * @param {Set<PsaStatus>} [psaStatuses]
     * @param {number} [scanCount]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaWithClientLzAndScanPage: async (
      page: number,
      startDate?: string,
      endDate?: string,
      idLike?: bigint,
      pzuIds?: number[],
      psaStatuses?: PsaStatus[],
      paymentType?: EPaymentMethod,
      scanCount?: number | string,
      sort?: Array<string>,
      lzNameLike?: string,
      lzId?: number[],
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getPsaWithClientLzAndScanPage.',
        );
      }
      const localVarPath = `/psas`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['start-date'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['end-date'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }

      if (idLike !== undefined) {
        localVarQueryParameter['id-like'] = idLike;
      }

      if (pzuIds) {
        localVarQueryParameter['pzu-ids'] = pzuIds;
      }

      if (lzId) {
        localVarQueryParameter['lz-ids'] = lzId;
      }

      let paidIndex: number | undefined = undefined;

      if (psaStatuses) {
        paidIndex = psaStatuses.findIndex(val => val === PsaStatus.Paid);
      }

      if (psaStatuses && paidIndex !== undefined && paidIndex !== -1 && paymentType === 'CASH') {
        let data = psaStatuses.slice();
        data[paidIndex] = PsaStatus.PaidCash;
        localVarQueryParameter['psa-statuses'] = data;
      }

      if (psaStatuses && (paidIndex === -1 || paymentType !== 'CASH')) {
        localVarQueryParameter['psa-statuses'] = psaStatuses;
      }
      if (!paymentType && psaStatuses?.includes(PsaStatus.Paid)) {
        localVarQueryParameter['psa-statuses'] = [...psaStatuses, PsaStatus.PaidCash];
      }
      if (paymentType) {
        localVarQueryParameter['payment-type'] = paymentType;
      }
      if (scanCount !== undefined && scanCount !== '') {
        localVarQueryParameter['scan-count'] = scanCount;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      if (lzNameLike) {
        localVarQueryParameter['lz-name-like'] = lzNameLike;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },

    /**
     *
     * @param {number} page
     * @param {string} startDate
     * @param {string} endDate
     * @param {Array<number>} pzuIds
     * @param {string} passportSn
     * @param {string} psaNumber
     * @param {string} paymentFrom
     * @param {string} paymentTo
     * @param {Array<number>} lzIds
     * @param {Array<string>} lzClientIds
     * @param {string} weightIndex
     * @param {string} scanIndex
     * @param {string} priceIndex
     * @param {string} hour24Index
     * @param {string} searchValue
     * @param {Array<string>} [sort]
     */
    getPsaListCompliance: async (
      page: number,
      startDate?: string,
      endDate?: string,
      pzuIds?: number[],
      lzIds?: number[],
      passportSn?: string,
      psaNumber?: string,
      paymentFrom?: number,
      paymentTo?: number,
      weightIndex?: string,
      scanIndex?: string,
      priceIndex?: string,
      hour24Index?: string,
      lzClientIds?: string[],
      searchValue?: string,
      sort?: string[],
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getPsaListCompliance.',
        );
      }
      const localVarPath = `/compliance/psa-indexes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }
      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }
      if (pzuIds !== undefined) {
        localVarQueryParameter['pzu-ids'] = pzuIds;
      }
      if (lzIds !== undefined) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }
      if (passportSn) {
        localVarQueryParameter['lz-client-passport-sn-like'] = passportSn;
      }
      if (psaNumber) {
        localVarQueryParameter['psa-virtual-id-like'] = psaNumber;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['psa-created-at-from'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }
      if (endDate !== undefined) {
        localVarQueryParameter['psa-created-at-to'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }
      if (paymentFrom) {
        localVarQueryParameter['lz-client-payment-from'] = paymentFrom;
      }
      if (paymentTo) {
        localVarQueryParameter['lz-client-payment-to'] = paymentTo;
      }
      if (weightIndex !== undefined) {
        localVarQueryParameter['weight-index'] = weightIndex;
      }
      if (scanIndex !== undefined) {
        localVarQueryParameter['scan-index'] = scanIndex;
      }
      if (priceIndex !== undefined) {
        localVarQueryParameter['price-index'] = priceIndex;
      }
      if (hour24Index !== undefined) {
        localVarQueryParameter['hour24-index'] = hour24Index;
      }
      if (lzClientIds !== undefined) {
        localVarQueryParameter['lz-client-ids'] = lzClientIds;
      }
      if (searchValue) {
        localVarQueryParameter['psa-virtual-id-like'] = searchValue;
      }
      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaUpdate} psaUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDraftPsa: async (psaId: number, psaUpdate: PsaUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (psaId === null || psaId === undefined) {
        throw new RequiredError('psaId', 'Required parameter psaId was null or undefined when calling updateDraftPsa.');
      }
      // verify required parameter 'psaUpdate' is not null or undefined
      if (psaUpdate === null || psaUpdate === undefined) {
        throw new RequiredError(
          'psaUpdate',
          'Required parameter psaUpdate was null or undefined when calling updateDraftPsa.',
        );
      }
      const localVarPath = `/psas/{psaId}`.replace(`{${'psaId'}}`, encodeURIComponent(String(psaId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof psaUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(psaUpdate !== undefined ? psaUpdate : {})
        : psaUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaItemId
     * @param {PsaItemUpdate} psaItemUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePsaItem: async (psaItemId: number, psaItemUpdate: PsaItemUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaItemId' is not null or undefined
      if (psaItemId === null || psaItemId === undefined) {
        throw new RequiredError(
          'psaItemId',
          'Required parameter psaItemId was null or undefined when calling updatePsaItem.',
        );
      }
      // verify required parameter 'psaItemUpdate' is not null or undefined
      if (psaItemUpdate === null || psaItemUpdate === undefined) {
        throw new RequiredError(
          'psaItemUpdate',
          'Required parameter psaItemUpdate was null or undefined when calling updatePsaItem.',
        );
      }
      const localVarPath = `/psa-items/{psaItemId}`.replace(`{${'psaItemId'}}`, encodeURIComponent(String(psaItemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof psaItemUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(psaItemUpdate !== undefined ? psaItemUpdate : {})
        : psaItemUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} pzuId
     * @param {string} psaStatus
     * @param {string} startDate
     * @param {string} endDate
     * @param {string} paymentType
     * @param {boolean} hasScan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaJournal: async (
      pzuId: string,
      psaStatuses?: string[],
      startDate?: string,
      endDate?: string,
      paymentType?: string,
      hasScan?: boolean,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/psas/journal`;
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (pzuId !== undefined) {
        localVarQueryParameter['pzu-id'] = pzuId;
      }
      let paidIndex: number | undefined = undefined;

      if (psaStatuses) {
        paidIndex = psaStatuses.findIndex(val => val === PsaStatus.Paid);
      }

      if (psaStatuses && paidIndex !== undefined && paidIndex !== -1 && paymentType === 'CASH') {
        let data = psaStatuses.slice();
        data[paidIndex] = PsaStatus.PaidCash;
        localVarQueryParameter['psa-statuses'] = data;
      }

      if (psaStatuses && (paidIndex === -1 || paymentType !== 'CASH')) {
        localVarQueryParameter['psa-statuses'] = psaStatuses;
      }

      if (!paymentType && psaStatuses?.includes(PsaStatus.Paid)) {
        localVarQueryParameter['psa-statuses'] = [...psaStatuses, PsaStatus.PaidCash];
      }

      if (startDate !== undefined) {
        localVarQueryParameter['start-date'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['end-date'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }
      if (paymentType !== undefined) {
        localVarQueryParameter['payment-type'] = paymentType;
      }
      if (hasScan !== undefined) {
        localVarQueryParameter['has-scan'] = hasScan;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PsaControllerApi - functional programming interface
 * @export
 */
export const PsaControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} psaId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPsaScan(
      psaId: number,
      file?: any,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).addPsaScan(psaId, file, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {PsaCreate} psaCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPsa(
      pzuId: number,
      psaCreate: PsaCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).createPsa(
        pzuId,
        psaCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaSetStatus} psaSetStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setPsaStatus(
      psaId: number,
      psaSetStatus: PsaSetStatus,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).setPsaStatus(
        psaId,
        psaSetStatus,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaItemCreate} psaItemCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPsaItem(
      psaId: number,
      psaItemCreate: PsaItemCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).createPsaItem(
        psaId,
        psaItemCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePsaItem(
      psaItemId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).deletePsaItem(
        psaItemId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePsaScan(
      scanId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).deletePsaScan(scanId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePsa(
      psaId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).deletePsa(psaId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaItemList(
      psaId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PsaItemInfo>>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaItemList(psaId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPassportReport(
      lzClientId: number,
      psaId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PassportInfo>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPassportReport(
        lzClientId,
        psaId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaScan(
      scanId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaScan(scanId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaScanPassport(
      lzClientId?: number | undefined,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaScanPassport(
        lzClientId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {number} [idLike]
     * @param {EPaymentMethod} [paymentType]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaTotalPaymentsPage(
      page: number,
      idLike?: number,
      paymentType?: EPaymentMethod,
      sort?: Array<string>,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPsaTotalPayment>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaTotalPaymentsPage(
        page,
        idLike,
        paymentType,
        sort,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaForPartyPayments(
      page: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPsaTotalPayment>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaForPartyPayments(
        page,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaWithClientAndScan(
      psaId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PsaWithClientAndScan>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaWithClientAndScan(
        psaId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaIndexesById(
      psaId: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PsaIndex>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaIndexesById(
        psaId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number} [psaNumber]
     * @param {Array<number>} [pzuIds]
     * @param {Array<number>} [lzIds]
     * @param {Array<string>} [lzClientIds]
     * @param {string} [passportSn]
     * @param {string} [psaNumber]
     * @param {string} [paymentFrom]
     * @param {string} [paymentTo]
     * @param {string} [weightIndex]
     * @param {string} [scanIndex]
     * @param {string} [priceIndex]
     * @param {string} [hour24Index]
     * @param {string} [searchValue]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaCompliance(
      page: number,
      startDate?: string,
      endDate?: string,
      pzuIds?: number[],
      lzIds?: number[],
      passportSn?: string,
      psaNumber?: string,
      paymentFrom?: number,
      paymentTo?: number,
      weightIndex?: string,
      scanIndex?: string,
      priceIndex?: string,
      hour24Index?: string,
      lzClientIds?: string[],
      searchValue?: string,
      sort?: string[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPsaComplience>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaListCompliance(
        page,
        startDate,
        endDate,
        pzuIds,
        lzIds,
        passportSn,
        psaNumber,
        paymentFrom,
        paymentTo,
        weightIndex,
        scanIndex,
        priceIndex,
        hour24Index,
        lzClientIds,
        searchValue,
        sort,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    async getPsaWithClientLzAndScanPage(
      page: number,
      startDate?: string,
      endDate?: string,
      idLike?: bigint,
      pzuIds?: number[],
      psaStatuses?: PsaStatus[],
      paymentType?: EPaymentMethod,
      scanCount?: number,
      sort?: Array<string>,
      lzNameLike?: string,
      lzId?: number[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPsaWithClientLzAndScan>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaWithClientLzAndScanPage(
        page,
        startDate,
        endDate,
        idLike,
        pzuIds,
        psaStatuses,
        paymentType,
        scanCount,
        sort,
        lzNameLike,
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaUpdate} psaUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateDraftPsa(
      psaId: number,
      psaUpdate: PsaUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).updateDraftPsa(
        psaId,
        psaUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} psaItemId
     * @param {PsaItemUpdate} psaItemUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePsaItem(
      psaItemId: number,
      psaItemUpdate: PsaItemUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).updatePsaItem(
        psaItemId,
        psaItemUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} pzuId
     * @param {string} psaStatus
     * @param {string} startDate
     * @param {string} endDate
     * @param {string} paymentType
     * @param {boolean} hasScan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaJournal(
      pzuId: string,
      psaStatuses?: string[],
      startDate?: string,
      endDate?: string,
      paymentType?: string,
      hasScan?: boolean,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await PsaControllerApiAxiosParamCreator(configuration).getPsaJournal(
        pzuId,
        psaStatuses,
        startDate,
        endDate,
        paymentType,
        hasScan,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PsaControllerApi - factory interface
 * @export
 */
export const PsaControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} psaId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPsaScan(psaId: number, file?: any, options?: any): AxiosPromise<IdWrapper> {
      return PsaControllerApiFp(configuration)
        .addPsaScan(psaId, file, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {PsaCreate} psaCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPsa(pzuId: number, psaCreate: PsaCreate, options?: any): AxiosPromise<IdWrapper> {
      return PsaControllerApiFp(configuration)
        .createPsa(pzuId, psaCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaSetStatus} psaSetStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPsaStatus(psaId: number, psaSetStatus: PsaSetStatus, options?: any): AxiosPromise<SuccessWrapper> {
      return PsaControllerApiFp(configuration)
        .setPsaStatus(psaId, psaSetStatus, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaItemCreate} psaItemCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPsaItem(psaId: number, psaItemCreate: PsaItemCreate, options?: any): AxiosPromise<IdWrapper> {
      return PsaControllerApiFp(configuration)
        .createPsaItem(psaId, psaItemCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePsaItem(psaItemId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return PsaControllerApiFp(configuration)
        .deletePsaItem(psaItemId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePsaScan(scanId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return PsaControllerApiFp(configuration)
        .deletePsaScan(scanId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePsa(psaId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return PsaControllerApiFp(configuration)
        .deletePsa(psaId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaItemList(psaId: number, options?: any): AxiosPromise<Array<PsaItemInfo>> {
      return PsaControllerApiFp(configuration)
        .getPsaItemList(psaId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPassportReport(lzClientId: number, psaId: number, options?: any): AxiosPromise<PassportInfo> {
      return PsaControllerApiFp(configuration)
        .getPassportReport(lzClientId, psaId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaScan(scanId: number, options?: any): AxiosPromise<Array<string>> {
      return PsaControllerApiFp(configuration)
        .getPsaScan(scanId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzClientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaScanPassport(lzClientId?: number, options?: any): AxiosPromise<Array<string>> {
      return PsaControllerApiFp(configuration)
        .getPsaScanPassport(lzClientId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {number} [idLike]
     * @param {EPaymentMethod} [paymentType]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaTotalPaymentsPage(
      page: number,
      idLike?: number,
      paymentType?: EPaymentMethod,
      sort?: Array<string>,
      options?: any,
    ): AxiosPromise<PageWrapperPsaTotalPayment> {
      return PsaControllerApiFp(configuration)
        .getPsaTotalPaymentsPage(page, idLike, paymentType, sort, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaForPartyPayments(page: number, options?: any): AxiosPromise<PageWrapperPsaTotalPayment> {
      return PsaControllerApiFp(configuration)
        .getPsaForPartyPayments(page, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaWithClientAndScan(psaId: number, options?: any): AxiosPromise<PsaWithClientAndScan> {
      return PsaControllerApiFp(configuration)
        .getPsaWithClientAndScan(psaId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaIndexesById(psaId: string, options?: any): AxiosPromise<PsaIndex> {
      return PsaControllerApiFp(configuration)
        .getPsaIndexesById(psaId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number} [idLike]
     * @param {string} [lzNameLike]
     * @param {Set<number>} [pzuIds]
     * @param {Set<PsaStatus>} [psaStatuses]
     * @param {Set<EPaymentMethod>} [paymentType]
     * @param {number} [scanCount]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaWithClientLzAndScanPage(
      page: number,
      startDate?: string,
      endDate?: string,
      idLike?: bigint,
      pzuIds?: number[],
      psaStatuses?: PsaStatus[],
      paymentType?: EPaymentMethod,
      scanCount?: number,
      sort?: Array<string>,
      lzNameLike?: string,
      lzId?: number[],
      options?: any,
    ): AxiosPromise<PageWrapperPsaWithClientLzAndScan> {
      return PsaControllerApiFp(configuration)
        .getPsaWithClientLzAndScanPage(
          page,
          startDate,
          endDate,
          idLike,
          pzuIds,
          psaStatuses,
          paymentType,
          scanCount,
          sort,
          lzNameLike,
          lzId,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} startDate
     * @param {string} endDate
     * @param {Array<number>} pzuIds
     * @param {Array<number>} lzIds
     * @param {string} passportSn
     * @param {string} psaNumber
     * @param {string} paymentFrom
     * @param {string} paymentTo
     * @param {string} weightIndex
     * @param {string} scanIndex
     * @param {string} priceIndex
     * @param {string} hour24Index
     * @param {string} searchValue
     * @param {Array<string>} lzClientIds
     * @param {Array<string>} [sort]
     */
    getPsaListCompliance(
      page: number,
      startDate?: string,
      endDate?: string,
      pzuIds?: number[],
      lzIds?: number[],
      passportSn?: string,
      psaNumber?: string,
      paymentFrom?: number,
      paymentTo?: number,
      weightIndex?: string,
      scanIndex?: string,
      priceIndex?: string,
      hour24Index?: string,
      lzClientIds?: string[],
      searchValue?: string,
      sort?: string[],
      options?: any,
    ): AxiosPromise<PageWrapperPsaComplience> {
      return PsaControllerApiFp(configuration)
        .getPsaCompliance(
          page,
          startDate,
          endDate,
          pzuIds,
          lzIds,
          passportSn,
          psaNumber,
          paymentFrom,
          paymentTo,
          weightIndex,
          scanIndex,
          priceIndex,
          hour24Index,
          lzClientIds,
          searchValue,
          sort,
          options,
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaId
     * @param {PsaUpdate} psaUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDraftPsa(psaId: number, psaUpdate: PsaUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return PsaControllerApiFp(configuration)
        .updateDraftPsa(psaId, psaUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} psaItemId
     * @param {PsaItemUpdate} psaItemUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePsaItem(psaItemId: number, psaItemUpdate: PsaItemUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return PsaControllerApiFp(configuration)
        .updatePsaItem(psaItemId, psaItemUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} pzuId
     * @param {string} psaStatus
     * @param {string} startDate
     * @param {string} endDate
     * @param {string} paymentType
     * @param {boolean} hasScan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaJournal(
      pzuId: string,
      psaStatuses?: string[],
      startDate?: string,
      endDate?: string,
      paymentType?: string,
      hasScan?: boolean,
      options?: any,
    ): AxiosPromise<Array<string>> {
      return PsaControllerApiFp(configuration)
        .getPsaJournal(pzuId, psaStatuses, startDate, endDate, paymentType, hasScan, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PsaControllerApi - object-oriented interface
 * @export
 * @class PsaControllerApi
 * @extends {BaseAPI}
 */
export class PsaControllerApi extends BaseAPI {
  /**
   *
   * @param {number} psaId
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public addPsaScan(psaId: number, file?: any, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .addPsaScan(psaId, file, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {PsaCreate} psaCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public createPsa(pzuId: number, psaCreate: PsaCreate, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .createPsa(pzuId, psaCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} psaId
   * @param {PsaItemCreate} psaItemCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public createPsaItem(psaId: number, psaItemCreate: PsaItemCreate, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .createPsaItem(psaId, psaItemCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} psaItemId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public deletePsaItem(psaItemId: number, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .deletePsaItem(psaItemId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} scanId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public deletePsaScan(scanId: number, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .deletePsaScan(scanId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} psaId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public getPsaItemList(psaId: number, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .getPsaItemList(psaId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} scanId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public getPsaScan(scanId: number, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .getPsaScan(scanId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} page
   * @param {number} [size]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public getPsaTotalPaymentsPage(page: number, size?: number, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .getPsaTotalPaymentsPage(page, size, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} psaId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public getPsaWithClientAndScan(psaId: number, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .getPsaWithClientAndScan(psaId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} page
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {number} [idLike]
   * @param {Set<number>} [pzuIds]
   * @param {Set<PsaStatus>} [psaStatuses]
   * @param {Set<EPaymentMethod>} [paymentType]
   * @param {number} [scanCount]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public getPsaWithClientLzAndScanPage(
    page: number,
    startDate?: string,
    endDate?: string,
    idLike?: bigint,
    pzuIds?: number[],
    psaStatuses?: PsaStatus[],
    paymentType?: EPaymentMethod,
    scanCount?: number,
    options?: any,
  ) {
    return PsaControllerApiFp(this.configuration)
      .getPsaWithClientLzAndScanPage(
        page,
        startDate,
        endDate,
        idLike,
        pzuIds,
        psaStatuses,
        paymentType,
        scanCount,
        options,
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} psaId
   * @param {PsaUpdate} psaUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public updateDraftPsa(psaId: number, psaUpdate: PsaUpdate, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .updateDraftPsa(psaId, psaUpdate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} psaItemId
   * @param {PsaItemUpdate} psaItemUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PsaControllerApi
   */
  public updatePsaItem(psaItemId: number, psaItemUpdate: PsaItemUpdate, options?: any) {
    return PsaControllerApiFp(this.configuration)
      .updatePsaItem(psaItemId, psaItemUpdate, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PzuControllerApi - axios parameter creator
 * @export
 */
export const PzuControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} pzuId
     * @param {IdWrapper} idWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPzuUser: async (pzuId: number, idWrapper: IdWrapper, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError('pzuId', 'Required parameter pzuId was null or undefined when calling addPzuUser.');
      }
      // verify required parameter 'idWrapper' is not null or undefined
      if (idWrapper === null || idWrapper === undefined) {
        throw new RequiredError(
          'idWrapper',
          'Required parameter idWrapper was null or undefined when calling addPzuUser.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/users`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof idWrapper !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(idWrapper !== undefined ? idWrapper : {})
        : idWrapper || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PzuCreate} pzuCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPzu: async (pzuCreate: PzuCreate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuCreate' is not null or undefined
      if (pzuCreate === null || pzuCreate === undefined) {
        throw new RequiredError(
          'pzuCreate',
          'Required parameter pzuCreate was null or undefined when calling createPzu.',
        );
      }
      const localVarPath = `/pzus`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof pzuCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(pzuCreate !== undefined ? pzuCreate : {})
        : pzuCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePzuUser: async (pzuId: number, userId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError('pzuId', 'Required parameter pzuId was null or undefined when calling deletePzuUser.');
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling deletePzuUser.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/users/{userId}`
        .replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)))
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzu: async (pzuId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError('pzuId', 'Required parameter pzuId was null or undefined when calling getPzu.');
      }
      const localVarPath = `/pzus/{pzuId}`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {number} [size]
     * @param {string} [nameLike]
     * @param {Set<PricingMethod>} [pricingMethods]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuInfoPageByLzId: async (
      lzId: number,
      page: number,
      size?: number,
      nameLike?: string,
      pricingMethods?: Set<PricingMethod>,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getPzuInfoPageByLzId.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getPzuInfoPageByLzId.',
        );
      }
      const localVarPath = `/lzs/{lzId}/pzus`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      if (pricingMethods) {
        localVarQueryParameter['pricing-methods'] = pricingMethods;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuUsers: async (pzuId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError('pzuId', 'Required parameter pzuId was null or undefined when calling getPzuUsers.');
      }
      const localVarPath = `/pzus/{pzuId}/users`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuUsersPage: async (pzuId: number, page: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError(
          'pzuId',
          'Required parameter pzuId was null or undefined when calling getPzuUsersPage.',
        );
      }
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError('page', 'Required parameter page was null or undefined when calling getPzuUsersPage.');
      }
      const localVarPath = `/v2/pzus/{pzuId}/users`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuWithLzPage: async (
      page: number,
      nameLike?: string,
      sort?: Array<string>,
      lzIds?: number[],
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError('page', 'Required parameter page was null or undefined when calling getPzuWithLzPage.');
      }
      const localVarPath = `/pzus`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      if (nameLike !== undefined) {
        localVarQueryParameter['name-like'] = nameLike;
      }

      if (lzIds && lzIds.length && !Number.isNaN(lzIds[0])) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {PzuUpdate} pzuUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePzu: async (pzuId: number, pzuUpdate: PzuUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError('pzuId', 'Required parameter pzuId was null or undefined when calling updatePzu.');
      }
      // verify required parameter 'pzuUpdate' is not null or undefined
      if (pzuUpdate === null || pzuUpdate === undefined) {
        throw new RequiredError(
          'pzuUpdate',
          'Required parameter pzuUpdate was null or undefined when calling updatePzu.',
        );
      }
      const localVarPath = `/pzus/{pzuId}`.replace(`{${'pzuId'}}`, encodeURIComponent(String(pzuId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof pzuUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(pzuUpdate !== undefined ? pzuUpdate : {})
        : pzuUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PzuSetPaymentLimits} paymentLimits
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPaymentLimits: async (
      pzuId: number,
      paymentLimits: PzuSetPaymentLimits,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'pzuCreate' is not null or undefined
      if (paymentLimits === null || paymentLimits === undefined) {
        throw new RequiredError(
          'pzuCreate',
          'Required parameter pzuCreate was null or undefined when calling createPzu.',
        );
      }
      const localVarPath = `/pzus/{pzuId}/set-payment-limits`.replace(
        `{${'pzuId'}}`,
        encodeURIComponent(String(pzuId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof paymentLimits !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(paymentLimits !== undefined ? paymentLimits : {})
        : paymentLimits || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentLimitsBalance: async (pzuId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (pzuId === null || pzuId === undefined) {
        throw new RequiredError('pzuId', 'Required parameter pzuId was null or undefined when calling getPzuUsers.');
      }
      const localVarPath = `/pzus/{pzuId}/payment-limits-balance`.replace(
        `{${'pzuId'}}`,
        encodeURIComponent(String(pzuId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PzuControllerApi - functional programming interface
 * @export
 */
export const PzuControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} pzuId
     * @param {IdWrapper} idWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addPzuUser(
      pzuId: number,
      idWrapper: IdWrapper,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).addPzuUser(
        pzuId,
        idWrapper,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {PzuCreate} pzuCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPzu(
      pzuCreate: PzuCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).createPzu(pzuCreate, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePzuUser(
      pzuId: number,
      userId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).deletePzuUser(
        pzuId,
        userId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPzu(
      pzuId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PzuWithLz>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).getPzu(pzuId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {number} [size]
     * @param {string} [nameLike]
     * @param {Set<PricingMethod>} [pricingMethods]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPzuInfoPageByLzId(
      lzId: number,
      page: number,
      size?: number,
      nameLike?: string,
      pricingMethods?: Set<PricingMethod>,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPzuInfo>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).getPzuInfoPageByLzId(
        lzId,
        page,
        size,
        nameLike,
        pricingMethods,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPzuUsers(
      pzuId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PzuUserInfo>>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).getPzuUsers(pzuId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPzuUsersPage(
      pzuId: number,
      page: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPzuUserInfo>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).getPzuUsersPage(
        pzuId,
        page,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPzuWithLzPage(
      page: number,
      nameLike?: string,
      sort?: Array<string>,
      lzIds?: any,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperPzuWithLz>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).getPzuWithLzPage(
        page,
        nameLike,
        sort,
        lzIds,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {PzuUpdate} pzuUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePzu(
      pzuId: number,
      pzuUpdate: PzuUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).updatePzu(
        pzuId,
        pzuUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {PzuSetPaymentLimits} paymentLimits
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setPaymentLimits(
      pzuId: number,
      paymentLimits: PzuSetPaymentLimits,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).setPaymentLimits(
        pzuId,
        paymentLimits,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentLimitsBalance(
      pzuId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PzuPaymentLimitsBalance>> {
      const localVarAxiosArgs = await PzuControllerApiAxiosParamCreator(configuration).getPaymentLimitsBalance(
        pzuId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * PzuControllerApi - factory interface
 * @export
 */
export const PzuControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} pzuId
     * @param {IdWrapper} idWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addPzuUser(pzuId: number, idWrapper: IdWrapper, options?: any): AxiosPromise<SuccessWrapper> {
      return PzuControllerApiFp(configuration)
        .addPzuUser(pzuId, idWrapper, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {PzuCreate} pzuCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPzu(pzuCreate: PzuCreate, options?: any): AxiosPromise<IdWrapper> {
      return PzuControllerApiFp(configuration)
        .createPzu(pzuCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePzuUser(pzuId: number, userId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return PzuControllerApiFp(configuration)
        .deletePzuUser(pzuId, userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzu(pzuId: number, options?: any): AxiosPromise<PzuWithLz> {
      return PzuControllerApiFp(configuration)
        .getPzu(pzuId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {number} page
     * @param {number} [size]
     * @param {string} [nameLike]
     * @param {Set<PricingMethod>} [pricingMethods]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuInfoPageByLzId(
      lzId: number,
      page: number,
      size?: number,
      nameLike?: string,
      pricingMethods?: Set<PricingMethod>,
      options?: any,
    ): AxiosPromise<PageWrapperPzuInfo> {
      return PzuControllerApiFp(configuration)
        .getPzuInfoPageByLzId(lzId, page, size, nameLike, pricingMethods, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuUsers(pzuId: number, options?: any): AxiosPromise<Array<PzuUserInfo>> {
      return PzuControllerApiFp(configuration)
        .getPzuUsers(pzuId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuUsersPage(pzuId: number, page: number, options?: any): AxiosPromise<PageWrapperPzuUserInfo> {
      return PzuControllerApiFp(configuration)
        .getPzuUsersPage(pzuId, page, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {any} [lzIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuWithLzPage(
      page: number,
      nameLike?: string,
      sort?: Array<string>,
      lzIds?: any,
      options?: any,
    ): AxiosPromise<PageWrapperPzuWithLz> {
      return PzuControllerApiFp(configuration)
        .getPzuWithLzPage(page, nameLike, sort, lzIds, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {PzuUpdate} pzuUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePzu(pzuId: number, pzuUpdate: PzuUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return PzuControllerApiFp(configuration)
        .updatePzu(pzuId, pzuUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {PzuSetPaymentLimits} paymentLimits
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPaymentLimits(pzuId: number, paymentLimits: PzuSetPaymentLimits, options?: any): AxiosPromise<SuccessWrapper> {
      return PzuControllerApiFp(configuration)
        .setPaymentLimits(pzuId, paymentLimits, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} pzuId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentLimitsBalance(pzuId: number, options?: any): AxiosPromise<PzuPaymentLimitsBalance> {
      return PzuControllerApiFp(configuration)
        .getPaymentLimitsBalance(pzuId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PzuControllerApi - object-oriented interface
 * @export
 * @class PzuControllerApi
 * @extends {BaseAPI}
 */
export class PzuControllerApi extends BaseAPI {
  /**
   *
   * @param {number} pzuId
   * @param {IdWrapper} idWrapper
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public addPzuUser(pzuId: number, idWrapper: IdWrapper, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .addPzuUser(pzuId, idWrapper, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PzuCreate} pzuCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public createPzu(pzuCreate: PzuCreate, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .createPzu(pzuCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public deletePzuUser(pzuId: number, userId: number, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .deletePzuUser(pzuId, userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public getPzu(pzuId: number, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .getPzu(pzuId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {number} page
   * @param {number} [size]
   * @param {string} [nameLike]
   * @param {Set<PricingMethod>} [pricingMethods]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public getPzuInfoPageByLzId(
    lzId: number,
    page: number,
    size?: number,
    nameLike?: string,
    pricingMethods?: Set<PricingMethod>,
    options?: any,
  ) {
    return PzuControllerApiFp(this.configuration)
      .getPzuInfoPageByLzId(lzId, page, size, nameLike, pricingMethods, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public getPzuUsers(pzuId: number, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .getPzuUsers(pzuId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {number} page
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public getPzuUsersPage(pzuId: number, page: number, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .getPzuUsersPage(pzuId, page, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} page
   * @param {string} [nameLike]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public getPzuWithLzPage(page: number, nameLike?: string, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .getPzuWithLzPage(page, nameLike, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} pzuId
   * @param {PzuUpdate} pzuUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PzuControllerApi
   */
  public updatePzu(pzuId: number, pzuUpdate: PzuUpdate, options?: any) {
    return PzuControllerApiFp(this.configuration)
      .updatePzu(pzuId, pzuUpdate, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ReportControllerApi - axios parameter creator
 * @export
 */
export const ReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzPaymentAmountsReport: async (
      startDate?: string,
      endDate?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/reports/lz-payment-amounts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['start-date'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['end-date'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [paymentSumFrom]
     * @param {string} [paymentSumTo]
     * @param {string} [pzuCountFrom]
     * @param {string} [pzuCountTo]
     * @param {string} [lzTotalIndex]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzReportIndex: async (
      paymentSumFrom?: string,
      paymentSumTo?: string,
      pzuCountFrom?: string,
      pzuCountTo?: string,
      lzTotalIndex?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/compliance/lz-indexes/csv`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (paymentSumFrom !== undefined) {
        localVarQueryParameter['payment-sum-from'] = paymentSumFrom;
      }
      if (paymentSumTo !== undefined) {
        localVarQueryParameter['payment-sum-to'] = paymentSumTo;
      }
      if (pzuCountFrom !== undefined) {
        localVarQueryParameter['pzu-count-from'] = pzuCountFrom;
      }
      if (pzuCountTo !== undefined) {
        localVarQueryParameter['pzu-count-to'] = pzuCountFrom;
      }
      if (lzTotalIndex !== undefined) {
        localVarQueryParameter['lz-total-index'] = lzTotalIndex;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuccessfulPaymentAmountsReport: async (
      startDate?: string,
      endDate?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/reports/payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['start-date'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['end-date'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number[]} [lzIds]
     * @param {number[]} [pzuIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionReport: async (
      startDate: string,
      endDate: string,
      lzIds: number[],
      pzuIds?: number[],
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/compliance/reports/psa-items`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (startDate) {
        localVarQueryParameter['psa-created-at-from'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate;
      }

      if (endDate) {
        localVarQueryParameter['psa-created-at-to'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate;
      }

      if (lzIds.length) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }

      if (pzuIds?.length) {
        localVarQueryParameter['pzu-ids'] = pzuIds;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzMetalAnalytics: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getCommission.');
      }

      const localVarPath = `/reports/lz/{lzId}/metal-analytics`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzMetalValume: async (
      lzId: number,
      classifierCode: string,
      filterList: IPaymentListFilterValue,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter lzId was null or undefined when calling getCommission.');
      }
      if (classifierCode === null || classifierCode === undefined) {
        throw new RequiredError(
          'classifierCode',
          'Required parameter classifierCode was null or undefined when calling getLzMetalAnalytics.',
        );
      }
      const localVarPath = `/reports/lz/{lzId}/metal-volume`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (classifierCode) {
        localVarQueryParameter['classifier-code'] = classifierCode;
      }

      if (filterList.dateFrom) {
        localVarQueryParameter['payment-from'] = filterList.dateFrom;
      }

      if (filterList.dateTo) {
        localVarQueryParameter['payment-to'] = filterList.dateTo;
      }

      if (filterList.period) {
        localVarQueryParameter['group-by'] = filterList.period;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {IPsaItemsDataset} [filterList]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaItemsDataSet: async (filterList: IPsaItemsDataset, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = '/reports/psa-items/dataset';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (filterList.paymentCreatedAtFrom) {
        localVarQueryParameter['payment-created-at-from'] =
          (filterList.paymentCreatedAtFrom as any) instanceof Date
            ? (filterList.paymentCreatedAtFrom as any).toISOString()
            : filterList.paymentCreatedAtFrom;
      }

      if (filterList.paymentCreatedAtTo) {
        localVarQueryParameter['payment-created-at-to'] =
          (filterList.paymentCreatedAtTo as any) instanceof Date
            ? (filterList.paymentCreatedAtTo as any).toISOString()
            : filterList.paymentCreatedAtTo;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReportControllerApi - functional programming interface
 * @export
 */
export const ReportControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzPaymentAmountsReport(
      startDate?: string,
      endDate?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await ReportControllerApiAxiosParamCreator(configuration).getLzPaymentAmountsReport(
        startDate,
        endDate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} [paymentSumFrom]
     * @param {string} [paymentSumTo]
     * @param {string} [pzuCountFrom]
     * @param {string} [pzuCountTo]
     * @param {string} [lzTotalIndex]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzReportIndex(
      paymentSumFrom?: string,
      paymentSumTo?: string,
      pzuCountFrom?: string,
      pzuCountTo?: string,
      lzTotalIndex?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await ReportControllerApiAxiosParamCreator(configuration).getLzReportIndex(
        paymentSumFrom,
        paymentSumTo,
        pzuCountFrom,
        pzuCountTo,
        lzTotalIndex,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSuccessfulPaymentAmountsReport(
      startDate?: string,
      endDate?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await ReportControllerApiAxiosParamCreator(
        configuration,
      ).getSuccessfulPaymentAmountsReport(startDate, endDate, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number[]} [lzIds]
     * @param {number[]} [pzuIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionReport(
      startDate: string,
      endDate: string,
      lzIds: number[],
      pzuIds?: number[],
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await ReportControllerApiAxiosParamCreator(configuration).getTransactionReport(
        startDate,
        endDate,
        lzIds,
        pzuIds,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzMetalAnalytics(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsWrapper>> {
      const localVarAxiosArgs = await ReportControllerApiAxiosParamCreator(configuration).getLzMetalAnalytics(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLzMetalValume(
      lzId: number,
      classifierCode: string,
      filterList: IPaymentListFilterValue,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LzMetalValume[]>> {
      const localVarAxiosArgs = await ReportControllerApiAxiosParamCreator(configuration).getLzMetalValume(
        lzId,
        classifierCode,
        filterList,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {IPsaItemsDataset} filterList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPsaItemsDataSet(
      filterList: IPsaItemsDataset,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string[]>> {
      const localVarAxiosArgs = await ReportControllerApiAxiosParamCreator(configuration).getPsaItemsDataSet(
        filterList,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ReportControllerApi - factory interface
 * @export
 */
export const ReportControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzPaymentAmountsReport(startDate?: string, endDate?: string, options?: any): AxiosPromise<Array<string>> {
      return ReportControllerApiFp(configuration)
        .getLzPaymentAmountsReport(startDate, endDate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} [paymentSumFrom]
     * @param {string} [paymentSumTo]
     * @param {string} [pzuCountFrom]
     * @param {string} [pzuCountTo]
     * @param {string} [lzTotalIndex]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzReportIndex(
      paymentSumFrom?: string,
      paymentSumTo?: string,
      pzuCountFrom?: string,
      pzuCountTo?: string,
      lzTotalIndex?: string,
      options?: any,
    ): AxiosPromise<Array<string>> {
      return ReportControllerApiFp(configuration)
        .getLzReportIndex(paymentSumFrom, paymentSumTo, pzuCountFrom, pzuCountTo, lzTotalIndex, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuccessfulPaymentAmountsReport(
      startDate?: string,
      endDate?: string,
      options?: any,
    ): AxiosPromise<Array<string>> {
      return ReportControllerApiFp(configuration)
        .getSuccessfulPaymentAmountsReport(startDate, endDate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number[]} [lzIds]
     * @param {number[]} [pzuIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionReport(
      startDate: string,
      endDate: string,
      lzIds: number[],
      pzuIds?: number[],
      options?: any,
    ): AxiosPromise<Array<string>> {
      return ReportControllerApiFp(configuration)
        .getTransactionReport(startDate, endDate, lzIds, pzuIds, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzMetalAnalytics(lzId: number, options?: any): AxiosPromise<AnalyticsWrapper> {
      return ReportControllerApiFp(configuration)
        .getLzMetalAnalytics(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzMetalValume(
      lzId: number,
      classifierCode: string,
      filterList: IPaymentListFilterValue,
      options?: any,
    ): AxiosPromise<LzMetalValume[]> {
      return ReportControllerApiFp(configuration)
        .getLzMetalValume(lzId, classifierCode, filterList, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {IPsaItemsDataset} filterList
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPsaItemsDataSet(filterList: IPsaItemsDataset, options?: any): AxiosPromise<string[]> {
      return ReportControllerApiFp(configuration)
        .getPsaItemsDataSet(filterList, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ReportControllerApi - object-oriented interface
 * @export
 * @class ReportControllerApi
 * @extends {BaseAPI}
 */
export class ReportControllerApi extends BaseAPI {
  /**
   *
   * @param {string} [startDate]
   * @param {string} [endDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportControllerApi
   */
  public getLzPaymentAmountsReport(startDate?: string, endDate?: string, options?: any) {
    return ReportControllerApiFp(this.configuration)
      .getLzPaymentAmountsReport(startDate, endDate, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UserControllerApi - axios parameter creator
 * @export
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {UserCreate} userCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser: async (userCreate: UserCreate, smsCode?: string, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'userCreate' is not null or undefined
      if (userCreate === null || userCreate === undefined) {
        throw new RequiredError(
          'userCreate',
          'Required parameter userCreate was null or undefined when calling createUser.',
        );
      }
      const localVarPath = `/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (smsCode && smsCode !== '') {
        localVarQueryParameter['sms-code'] = smsCode;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof userCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(userCreate !== undefined ? userCreate : {})
        : userCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentUser: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/users/current`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuAllowedUsers: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'lzId',
          'Required parameter lzId was null or undefined when calling getPzuAllowedUsers.',
        );
      }
      const localVarPath = `/lzs/{lzId}/pzu-allowed-users`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {Array<string>} [sort]
     * @param {string} [fioLike]
     * @param {UserStatus[]} [statuses]
     * @param {number[]} [lzIds]
     * @param {UserRole[]} [roles]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfoWithLzPage: async (
      page: number,
      fioLike?: string,
      statuses?: UserStatus[],
      lzIds?: number[],
      roles?: UserRole[],
      sort?: Array<string>,
      size?: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getUserInfoWithLzPage.',
        );
      }
      const localVarPath = `/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (fioLike) {
        localVarQueryParameter['fio-like'] = fioLike;
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses;
      }

      if (lzIds) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }

      if (roles) {
        localVarQueryParameter['roles'] = roles;
      }

      if (sort && sort.length) {
        localVarQueryParameter['sort'] = sort;
      }

      if (size) {
        localVarQueryParameter['size'] = size;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {Array<string>} [sort]
     * @param {string} [fioLike]
     * @param {UserStatus[]} [statuses]
     * @param {number[]} [lzIds]
     * @param {UserRole[]} [roles]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfoWithLzPageV2: async (
      page: number,
      fioLike?: string,
      statuses?: UserStatus[],
      lzIds?: number[],
      roles?: UserRole[],
      sort?: Array<string>,
      size?: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getUserInfoWithLzPage.',
        );
      }
      const localVarPath = `/v2/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (fioLike) {
        localVarQueryParameter['fio-like'] = fioLike;
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses;
      }

      if (lzIds) {
        localVarQueryParameter['lz-ids'] = lzIds;
      }

      if (roles) {
        localVarQueryParameter['roles'] = roles;
      }

      if (sort && sort.length) {
        localVarQueryParameter['sort'] = sort;
      }

      if (size) {
        localVarQueryParameter['size'] = size;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfoWithLzPzus: async (userId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling getUserInfoWithLzPzus.',
        );
      }
      const localVarPath = `/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reactivateUser: async (userId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling reactivateUser.',
        );
      }
      const localVarPath = `/users/{userId}/reactivate`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetRoles} userSetRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setRoles: async (userId: number, userSetRoles: UserSetRoles, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setRoles.');
      }
      // verify required parameter 'userSetRoles' is not null or undefined
      if (userSetRoles === null || userSetRoles === undefined) {
        throw new RequiredError(
          'userSetRoles',
          'Required parameter userSetRoles was null or undefined when calling setRoles.',
        );
      }
      const localVarPath = `/users/{userId}/set-roles`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof userSetRoles !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(userSetRoles !== undefined ? userSetRoles : {})
        : userSetRoles || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetStatus} userSetStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setStatus: async (userId: number, userSetStatus: UserSetStatus, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setStatus.');
      }
      // verify required parameter 'userSetStatus' is not null or undefined
      if (userSetStatus === null || userSetStatus === undefined) {
        throw new RequiredError(
          'userSetStatus',
          'Required parameter userSetStatus was null or undefined when calling setStatus.',
        );
      }
      const localVarPath = `/users/{userId}/set-status`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof userSetStatus !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(userSetStatus !== undefined ? userSetStatus : {})
        : userSetStatus || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {number} avatarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setAvatarId: async (userId: number, avatarId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setStatus.');
      }
      // verify required parameter 'userSetStatus' is not null or undefined
      if (avatarId === null || avatarId === undefined) {
        throw new RequiredError(
          'avatarId',
          'Required parameter avatarId was null or undefined when calling setAvatarId.',
        );
      }
      const localVarPath = `/users/{userId}/set-avatar`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof avatarId !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(avatarId !== undefined ? avatarId : {})
        : avatarId || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserUpdate} userUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser: async (userId: number, userUpdate: UserUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling updateUser.');
      }
      // verify required parameter 'userUpdate' is not null or undefined
      if (userUpdate === null || userUpdate === undefined) {
        throw new RequiredError(
          'userUpdate',
          'Required parameter userUpdate was null or undefined when calling updateUser.',
        );
      }
      const localVarPath = `/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof userUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(userUpdate !== undefined ? userUpdate : {})
        : userUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetLoginTwoFactorMode} twoFactorMode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setLogin2fa: async (
      userId: number,
      twoFactorMode: UserSetLoginTwoFactorMode,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setLogin2fa.');
      }
      // verify required parameter 'userSetRoles' is not null or undefined
      if (twoFactorMode === null || twoFactorMode === undefined) {
        throw new RequiredError(
          'twoFactorMode',
          'Required parameter twoFactorMode was null or undefined when calling setLogin2fa.',
        );
      }
      const localVarPath = `/users/{userId}/set-login-2fa`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof twoFactorMode !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(twoFactorMode !== undefined ? twoFactorMode : {})
        : twoFactorMode || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserControllerApi - functional programming interface
 * @export
 */
export const UserControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {UserCreate} userCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUser(
      userCreate: UserCreate,
      smsCode?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).createUser(
        userCreate,
        smsCode,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currentUser(
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoWithLzPzus>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).currentUser(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPzuAllowedUsers(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserInfoWithLz>>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).getPzuAllowedUsers(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [fioLike]
     * @param {UserStatus[]} [statuses]
     * @param {number[]} [lzIds]
     * @param {UserRole[]} [roles]
     * @param {Array<string>} [sort]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserInfoWithLzPage(
      page: number,
      fioLike?: string,
      statuses?: UserStatus[],
      lzIds?: number[],
      roles?: UserRole[],
      sort?: Array<string>,
      size?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperUserInfoWithLz>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).getUserInfoWithLzPage(
        page,
        fioLike,
        statuses,
        lzIds,
        roles,
        sort,
        size,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [fioLike]
     * @param {UserStatus[]} [statuses]
     * @param {number[]} [lzIds]
     * @param {UserRole[]} [roles]
     * @param {Array<string>} [sort]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserInfoWithLzPageV2(
      page: number,
      fioLike?: string,
      statuses?: UserStatus[],
      lzIds?: number[],
      roles?: UserRole[],
      sort?: Array<string>,
      size?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperUserInfoWithLzV2>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).getUserInfoWithLzPageV2(
        page,
        fioLike,
        statuses,
        lzIds,
        roles,
        sort,
        size,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserInfoWithLzPzus(
      userId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoWithLzPzus>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).getUserInfoWithLzPzus(
        userId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reactivateUser(
      userId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).reactivateUser(userId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetRoles} userSetRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setRoles(
      userId: number,
      userSetRoles: UserSetRoles,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).setRoles(
        userId,
        userSetRoles,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetStatus} userSetStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setStatus(
      userId: number,
      userSetStatus: UserSetStatus,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).setStatus(
        userId,
        userSetStatus,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {number} avatarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setAvatarId(
      userId: number,
      avatarId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).setAvatarId(
        userId,
        avatarId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserUpdate} userUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUser(
      userId: number,
      userUpdate: UserUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).updateUser(
        userId,
        userUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetLoginTwoFactorMode} setLogin2fa
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setLogin2fa(
      userId: number,
      setLogin2fa: UserSetLoginTwoFactorMode,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await UserControllerApiAxiosParamCreator(configuration).setLogin2fa(
        userId,
        setLogin2fa,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * UserControllerApi - factory interface
 * @export
 */
export const UserControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {UserCreate} userCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(userCreate: UserCreate, smsCode?: string, options?: any): AxiosPromise<IdWrapper> {
      return UserControllerApiFp(configuration)
        .createUser(userCreate, smsCode, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currentUser(options?: any): AxiosPromise<UserInfoWithLzPzus> {
      return UserControllerApiFp(configuration)
        .currentUser(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPzuAllowedUsers(lzId: number, options?: any): AxiosPromise<Array<UserInfoWithLz>> {
      return UserControllerApiFp(configuration)
        .getPzuAllowedUsers(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [fioLike]
     * @param {Set<UserStatus>} [statuses]
     * @param {Set<number>} [lzIds]
     * @param {Set<UserRole>} [roles]
     * @param {Array<string>} [sort]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfoWithLzPage(
      page: number,
      fioLike?: string,
      statuses?: UserStatus[],
      lzIds?: number[],
      roles?: UserRole[],
      sort?: Array<string> | undefined,
      size?: number,
      options?: any,
    ): AxiosPromise<PageWrapperUserInfoWithLz> {
      return UserControllerApiFp(configuration)
        .getUserInfoWithLzPage(page, fioLike, statuses, lzIds, roles, sort, size, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {string} [fioLike]
     * @param {Set<UserStatus>} [statuses]
     * @param {Set<number>} [lzIds]
     * @param {Set<UserRole>} [roles]
     * @param {Array<string>} [sort]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfoWithLzPageV2(
      page: number,
      fioLike?: string,
      statuses?: UserStatus[],
      lzIds?: number[],
      roles?: UserRole[],
      sort?: Array<string> | undefined,
      size?: number,
      options?: any,
    ): AxiosPromise<PageWrapperUserInfoWithLzV2> {
      return UserControllerApiFp(configuration)
        .getUserInfoWithLzPageV2(page, fioLike, statuses, lzIds, roles, sort, size, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfoWithLzPzus(userId: number, options?: any): AxiosPromise<UserInfoWithLzPzus> {
      return UserControllerApiFp(configuration)
        .getUserInfoWithLzPzus(userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reactivateUser(userId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return UserControllerApiFp(configuration)
        .reactivateUser(userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetRoles} userSetRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setRoles(userId: number, userSetRoles: UserSetRoles, options?: any): AxiosPromise<SuccessWrapper> {
      return UserControllerApiFp(configuration)
        .setRoles(userId, userSetRoles, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetStatus} userSetStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setStatus(userId: number, userSetStatus: UserSetStatus, options?: any): AxiosPromise<SuccessWrapper> {
      return UserControllerApiFp(configuration)
        .setStatus(userId, userSetStatus, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {number} avatarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setAvatarId(userId: number, avatarId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return UserControllerApiFp(configuration)
        .setAvatarId(userId, avatarId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {UserUpdate} userUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(userId: number, userUpdate: UserUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return UserControllerApiFp(configuration)
        .updateUser(userId, userUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetLoginTwoFactorMode} twoFactorMode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setLogin2fa(userId: number, twoFactorMode: UserSetLoginTwoFactorMode, options?: any): AxiosPromise<SuccessWrapper> {
      return UserControllerApiFp(configuration)
        .setLogin2fa(userId, twoFactorMode, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * UserControllerApi - object-oriented interface
 * @export
 * @class UserControllerApi
 * @extends {BaseAPI}
 */
export class UserControllerApi extends BaseAPI {
  /**
   *
   * @param {UserCreate} userCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public createUser(userCreate: UserCreate, options?: any) {
    return UserControllerApiFp(this.configuration)
      .createUser(userCreate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public currentUser(options?: any) {
    return UserControllerApiFp(this.configuration)
      .currentUser(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} lzId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public getPzuAllowedUsers(lzId: number, options?: any) {
    return UserControllerApiFp(this.configuration)
      .getPzuAllowedUsers(lzId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} page
   * @param {string} [fioLike]
   * @param {UserStatus[]} [statuses]
   * @param {number[]} [lzIds]
   * @param {UserRole[]} [roles]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public getUserInfoWithLzPage(
    page: number,
    fioLike?: string,
    statuses?: UserStatus[],
    lzIds?: number[],
    roles?: UserRole[],
    options?: any,
  ) {
    return UserControllerApiFp(this.configuration)
      .getUserInfoWithLzPage(page, fioLike, statuses, lzIds, roles, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public getUserInfoWithLzPzus(userId: number, options?: any) {
    return UserControllerApiFp(this.configuration)
      .getUserInfoWithLzPzus(userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public reactivateUser(userId: number, options?: any) {
    return UserControllerApiFp(this.configuration)
      .reactivateUser(userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {UserSetRoles} userSetRoles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public setRoles(userId: number, userSetRoles: UserSetRoles, options?: any) {
    return UserControllerApiFp(this.configuration)
      .setRoles(userId, userSetRoles, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {UserSetStatus} userSetStatus
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public setStatus(userId: number, userSetStatus: UserSetStatus, options?: any) {
    return UserControllerApiFp(this.configuration)
      .setStatus(userId, userSetStatus, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {UserUpdate} userUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserControllerApi
   */
  public updateUser(userId: number, userUpdate: UserUpdate, options?: any) {
    return UserControllerApiFp(this.configuration)
      .updateUser(userId, userUpdate, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * MailListControllerApi - factory interface
 * @export
 */
export const MailListControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {MailListCreate} pzuCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMailList(mailListCreate: MailListCreate, options?: any): AxiosPromise<IdWrapper> {
      return MailListControllerApiFp(configuration)
        .createMailList(mailListCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} mailListId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMailListById(mailListId: number, options?: any): AxiosPromise<MailList> {
      return MailListControllerApiFp(configuration)
        .getMailListById(mailListId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMailLists(page: number, options?: any): AxiosPromise<PageWrapperMailLists> {
      return MailListControllerApiFp(configuration)
        .getMailLists(page, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} mailListId
     * @param {MailListUpdate} mailListUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMailList(mailListId: number, mailListUpdate: MailListUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return MailListControllerApiFp(configuration)
        .updateMailList(mailListId, mailListUpdate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} mailListId
     * @param {BooleanWrapper} booleanWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setMailListBlocked(
      mailListId: number,
      booleanWrapper: BooleanWrapper,
      options?: any,
    ): AxiosPromise<SuccessWrapper> {
      return MailListControllerApiFp(configuration)
        .setBlockMailList(mailListId, booleanWrapper, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const MailListControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {MailListCreate} mailListCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createMailList(
      mailListCreate: MailListCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await MailListControllerApiAxiosParamCreator(configuration).createMailList(
        mailListCreate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} mailListId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMailListById(
      mailListId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailList>> {
      const localVarAxiosArgs = await MailListControllerApiAxiosParamCreator(configuration).getMailListById(
        mailListId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} [nameLike]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMailLists(
      page: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperMailLists>> {
      const localVarAxiosArgs = await MailListControllerApiAxiosParamCreator(configuration).getMailLists(page, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} mailListId
     * @param {MailListUpdate} mailListUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateMailList(
      mailListId: number,
      mailListUpdate: MailListUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await MailListControllerApiAxiosParamCreator(configuration).updateMailList(
        mailListId,
        mailListUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} userId
     * @param {UserSetRoles} userSetRoles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setBlockMailList(
      mailListId: number,
      booleanWrapper: BooleanWrapper,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await MailListControllerApiAxiosParamCreator(configuration).setBlockMailList(
        mailListId,
        booleanWrapper,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const MailListControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {MailListCreate} mailListCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMailList: async (mailListCreate: MailListCreate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuCreate' is not null or undefined
      if (mailListCreate === null || mailListCreate === undefined) {
        throw new RequiredError(
          'mailListCreate',
          'Required parameter mailListCreate was null or undefined when calling mailListCreate.',
        );
      }
      const localVarPath = `/mail-lists`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof mailListCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(mailListCreate !== undefined ? mailListCreate : {})
        : mailListCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} mailListId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMailListById: async (mailListId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'pzuId' is not null or undefined
      if (mailListId === null || mailListId === undefined) {
        throw new RequiredError(
          'mailListId',
          'Required parameter pzuId was null or undefined when calling getMailListById.',
        );
      }
      const localVarPath = `/mail-lists/{mailListId}`.replace(
        `{${'mailListId'}}`,
        encodeURIComponent(String(mailListId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMailLists: async (page: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError('page', 'Required parameter page was null or undefined when calling getMailLists.');
      }
      const localVarPath = `/mail-lists`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} mailListId
     * @param {MailListUpdate} mailListUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMailList: async (
      mailListId: number,
      mailListUpdate: MailListUpdate,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (mailListId === null || mailListId === undefined) {
        throw new RequiredError(
          'mailListId',
          'Required parameter lzId was null or undefined when calling mailListUpdate.',
        );
      }
      // verify required parameter 'lzUpdate' is not null or undefined
      if (mailListUpdate === null || mailListUpdate === undefined) {
        throw new RequiredError(
          'mailListUpdate',
          'Required parameter mailListUpdate was null or undefined when calling mailListUpdate.',
        );
      }
      const localVarPath = `/mail-lists/{mailListId}`.replace(
        `{${'mailListId'}}`,
        encodeURIComponent(String(mailListId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof mailListUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(mailListUpdate !== undefined ? mailListUpdate : {})
        : mailListUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} mailListId
     * @param {BooleanWrapper} booleanWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setBlockMailList: async (
      mailListId: number,
      booleanWrapper: BooleanWrapper,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      if (mailListId === null || mailListId === undefined) {
        throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setRoles.');
      }
      // verify required parameter 'userSetRoles' is not null or undefined
      if (booleanWrapper === null || booleanWrapper === undefined) {
        throw new RequiredError(
          'booleanWrapper',
          'Required parameter booleanWrapper was null or undefined when calling setRoles.',
        );
      }
      const localVarPath = `/mail-lists/{mailListId}/set-active`.replace(
        `{${'mailListId'}}`,
        encodeURIComponent(String(mailListId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof booleanWrapper !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(booleanWrapper !== undefined ? booleanWrapper : {})
        : booleanWrapper || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionControllerApi - factory interface
 * @export
 */
export const TransactionControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} page
     * @param {string} [psaVirtualIdLike]
     * @param {number} [hasPassportScan]
     * @param {number} [hasPsaScan]
     * @param {string} [psaCreatedAtFrom]
     * @param {string} [psaCreatedAtTo]
     * @param {number} [lzClientPaymentFrom]
     * @param {number} [lzClientPaymentTo]
     * @param {string} [lzNameLike]
     * @param {string} [pzuNameLike]
     * @param {string} [lzClientPassportSnLike]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsList(
      page?: number,
      psaVirtualIdLike?: string,
      hasPassportScan?: number,
      hasPsaScan?: number,
      psaCreatedAtFrom?: string,
      psaCreatedAtTo?: string,
      lzClientPaymentFrom?: number,
      lzClientPaymentTo?: number,
      lzClientPassportSnLike?: string,
      lzNameLike?: string,
      pzuNameLike?: string,
      lzId?: number,
      sort?: string[] | undefined,
      lzClientId?: number | undefined,
      options?: any,
    ): AxiosPromise<PageWrapperTransactionsList> {
      return TransactionControllerApiFp(configuration)
        .getTransactionsPage(
          page,
          psaVirtualIdLike,
          hasPassportScan,
          hasPsaScan,
          psaCreatedAtFrom,
          psaCreatedAtTo,
          lzClientPaymentFrom,
          lzClientPaymentTo,
          lzClientPassportSnLike,
          lzNameLike,
          pzuNameLike,
          lzId,
          sort,
          lzClientId,
          options,
        )
        .then(request => request(axios, basePath));
    },

    getTransactionInfo(
      page: number,
      lzId: number,
      sort: Array<string>,
      searchValue?: string,
      options?: any,
    ): AxiosPromise<PageWrapperTransactionsList> {
      return TransactionControllerApiFp(configuration)
        .getTransactionInfo(page, lzId, sort, searchValue, options)
        .then(request => request(axios, basePath));
    },

    getLzTransactionInfo(
      page: number,
      sort?: Array<string>,
      searchValue?: string,
      inn?: string,
      businessAddress?: string,
      options?: any,
    ): AxiosPromise<PageWrapperLzInfo> {
      return TransactionControllerApiFp(configuration)
        .getLzTransactionInfo(page, sort, searchValue, inn, businessAddress, options)
        .then(request => request(axios, basePath));
    },
    getLzIndexes(
      page: number,
      sort?: Array<string>,
      searchValue?: string,
      paymentSumFrom?: number,
      paymentSumTo?: number,
      pzuCountFrom?: string,
      pzuCountTo?: string,
      lzTotalIndex?: string,
      options?: any,
    ): AxiosPromise<PageWrapperLzInfo> {
      return TransactionControllerApiFp(configuration)
        .getLzIndexes(
          page,
          sort,
          searchValue,
          paymentSumFrom,
          paymentSumTo,
          pzuCountFrom,
          pzuCountTo,
          lzTotalIndex,
          options,
        )
        .then(request => request(axios, basePath));
    },
    getLzTransactionMoreInfo(
      lzId?: number,
      paymentFrom?: string,
      paymentTo?: string,
      period?: string,
      options?: any,
    ): AxiosPromise<ComplianceLzData[]> {
      return TransactionControllerApiFp(configuration)
        .getLzTransactionMoreInfo(lzId, paymentFrom, paymentTo, period, options)
        .then(request => request(axios, basePath));
    },
    getPzuTransactionMonthlyVolume(
      lzId?: number,
      paymentFrom?: string,
      paymentTo?: string,
      period?: string,
      options?: any,
    ): AxiosPromise<ComplianceLzData[]> {
      return TransactionControllerApiFp(configuration)
        .getPzuTransactionMonthlyVolume(lzId, paymentFrom, paymentTo, period, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const TransactionControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} page
     * @param {string} [psaVirtualIdLike]
     * @param {number} [hasPassportScan]
     * @param {number} [hasPsaScan]
     * @param {string} [psaCreatedAtFrom]
     * @param {string} [psaCreatedAtTo]
     * @param {number} [lzClientPaymentFrom]
     * @param {number} [lzClientPaymentTo]
     * @param {string} [lzNameLike]
     * @param {string} [pzuNameLike]
     * @param {string} [lzClientPassportSnLike]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransactionsPage(
      page?: number,
      psaVirtualIdLike?: string,
      hasPassportScan?: number,
      hasPsaScan?: number,
      psaCreatedAtFrom?: string,
      psaCreatedAtTo?: string,
      lzClientPaymentFrom?: number,
      lzClientPaymentTo?: number,
      lzClientPassportSnLike?: string,
      lzNameLike?: string,
      pzuNameLike?: string,
      lzId?: number,
      sort?: string[] | undefined,
      lzClientId?: number | undefined,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperTransactionsList>> {
      const localVarAxiosArgs = await TransactionControllerApiAxiosParamCreator(configuration).getTransactionsPage(
        page,
        psaVirtualIdLike,
        hasPassportScan,
        hasPsaScan,
        psaCreatedAtFrom,
        psaCreatedAtTo,
        lzClientPaymentFrom,
        lzClientPaymentTo,
        lzClientPassportSnLike,
        lzNameLike,
        pzuNameLike,
        lzId,
        sort,
        lzClientId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    async getTransactionInfo(
      page: number,
      lzId: number,
      sort: Array<string>,
      searchValue?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperTransactionsList>> {
      const localVarAxiosArgs = await TransactionControllerApiAxiosParamCreator(configuration).getTransactionInfo(
        page,
        lzId,
        sort,
        searchValue,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    async getLzTransactionInfo(
      page: number,
      sort?: Array<string>,
      searchValue?: string,
      inn?: string,
      businessAddress?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLzInfo>> {
      const localVarAxiosArgs = await TransactionControllerApiAxiosParamCreator(configuration).getLzTransactionInfo(
        page,
        sort,
        searchValue,
        inn,
        businessAddress,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    async getLzIndexes(
      page: number,
      sort?: Array<string>,
      searchValue?: string,
      paymentSumFrom?: number,
      paymentSumTo?: number,
      pzuCountFrom?: string,
      pzuCountTo?: string,
      lzTotalIndex?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperLzInfo>> {
      const localVarAxiosArgs = await TransactionControllerApiAxiosParamCreator(configuration).getLzIndexes(
        page,
        sort,
        searchValue,
        paymentSumFrom,
        paymentSumTo,
        pzuCountFrom,
        pzuCountTo,
        lzTotalIndex,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    async getLzTransactionMoreInfo(
      lzId?: any,
      paymentFrom?: string,
      paymentTo?: string,
      period?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceLzData[]>> {
      const localVarAxiosArgs = await TransactionControllerApiAxiosParamCreator(configuration).getLzTransactionMoreInfo(
        lzId,
        paymentFrom,
        paymentTo,
        period,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    async getPzuTransactionMonthlyVolume(
      pzuId?: any,
      paymentFrom?: string,
      paymentTo?: string,
      period?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceLzData[]>> {
      const localVarAxiosArgs = await TransactionControllerApiAxiosParamCreator(
        configuration,
      ).getPzuTransactionMonthlyVolume(pzuId, paymentFrom, paymentTo, period, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const TransactionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} page
     * @param {string} [psaVirtualIdLike]
     * @param {number} [hasPassportScan]
     * @param {number} [hasPsaScan]
     * @param {string} [psaCreatedAtFrom]
     * @param {string} [psaCreatedAtTo]
     * @param {number} [lzClientPaymentFrom]
     * @param {number} [lzClientPaymentTo]
     * @param {string} [lzNameLike]
     * @param {string} [pzuNameLike]
     * @param {string} [lzClientPassportSnLike]
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionsPage: async (
      page?: number,
      psaVirtualIdLike?: string,
      hasPassportScan?: number,
      hasPsaScan?: number,
      psaCreatedAtFrom?: string,
      psaCreatedAtTo?: string,
      lzClientPaymentFrom?: number,
      lzClientPaymentTo?: number,
      lzClientPassportSnLike?: string,
      lzNameLike?: string,
      pzuNameLike?: string,
      lzId?: number,
      sort?: Array<string>,
      lzClientId?: number,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/compliance/transactions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (psaVirtualIdLike !== undefined) {
        localVarQueryParameter['psa-virtual-id-like'] = psaVirtualIdLike;
      }

      if (hasPassportScan !== undefined && hasPassportScan !== 0) {
        localVarQueryParameter['has-passport-scan'] = hasPassportScan;
      }

      if (hasPsaScan !== undefined && hasPsaScan !== 0) {
        localVarQueryParameter['has-psa-scan'] = hasPsaScan;
      }

      if (psaCreatedAtFrom !== undefined) {
        localVarQueryParameter['psa-created-at-from'] =
          (psaCreatedAtFrom as any) instanceof Date ? (psaCreatedAtFrom as any).toISOString() : psaCreatedAtFrom;
      }

      if (psaCreatedAtTo !== undefined) {
        localVarQueryParameter['psa-created-at-to'] =
          (psaCreatedAtTo as any) instanceof Date ? (psaCreatedAtTo as any).toISOString() : psaCreatedAtTo;
      }

      if (lzClientPaymentFrom !== undefined) {
        localVarQueryParameter['lz-client-payment-from'] = lzClientPaymentFrom;
      }

      if (lzClientPaymentTo !== undefined) {
        localVarQueryParameter['lz-client-payment-to'] = lzClientPaymentTo;
      }

      if (lzClientPassportSnLike !== undefined) {
        localVarQueryParameter['lz-client-passport-sn-like'] = lzClientPassportSnLike;
      }

      if (pzuNameLike !== undefined) {
        localVarQueryParameter['pzu-name-like'] = pzuNameLike;
      }

      if (lzNameLike !== undefined) {
        localVarQueryParameter['lz-name-like'] = lzNameLike;
      }

      if (lzId !== undefined) {
        localVarQueryParameter['lz-id'] = lzId;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      if (lzClientId) {
        localVarQueryParameter['lz-client-id'] = lzClientId;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    getTransactionInfo: async (
      page: number,
      lzId: number,
      sort: Array<string>,
      searchValue?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getTransactionsPage.',
        );
      }

      const localVarPath = `/compliance/reports/pzus/rolling-year-payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (lzId !== undefined) {
        localVarQueryParameter['lz-id'] = lzId;
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      if (searchValue !== undefined) {
        localVarQueryParameter['name-like'] = searchValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} searchValue
     * @param {string} inn
     * @param {string} businessAddress
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzTransactionInfo: async (
      page: number,
      sort?: Array<string>,
      searchValue?: string,
      inn?: string,
      businessAddress?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getTransactionsPage.',
        );
      }
      const localVarPath = `/compliance/reports/lzs/rolling-year-payments`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      if (searchValue !== undefined && searchValue !== '') {
        localVarQueryParameter['name-like'] = searchValue;
      }

      if (inn !== undefined) {
        localVarQueryParameter['inn-like'] = inn;
      }

      if (businessAddress !== undefined && businessAddress !== '') {
        localVarQueryParameter['business-address-like'] = businessAddress;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} page
     * @param {string} searchValue
     * @param {string} paymentSumFrom
     * @param {string} paymentSumTo
     * @param {string} pzuCountFrom
     * @param {string} pzuCountTo
     * @param {Array<string>} [sort]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLzIndexes: async (
      page: number,
      sort?: Array<string>,
      searchValue?: string,
      paymentSumFrom?: number,
      paymentSumTo?: number,
      pzuCountFrom?: string,
      pzuCountTo?: string,
      lzTotalIndex?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      if (page === null || page === undefined) {
        throw new RequiredError(
          'page',
          'Required parameter page was null or undefined when calling getTransactionsPage.',
        );
      }
      const localVarPath = `/compliance/lz-indexes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort;
      }

      if (searchValue !== undefined && searchValue !== '') {
        localVarQueryParameter['lz-name-like'] = searchValue;
      }

      if (paymentSumFrom !== undefined) {
        localVarQueryParameter['payment-sum-from'] = paymentSumFrom;
      }

      if (paymentSumTo !== undefined && paymentSumTo) {
        localVarQueryParameter['payment-sum-to'] = paymentSumTo;
      }
      if (pzuCountFrom !== undefined && pzuCountFrom) {
        localVarQueryParameter['pzu-count-from'] = pzuCountFrom;
      }
      if (pzuCountTo !== undefined && pzuCountTo !== '') {
        localVarQueryParameter['pzu-count-to'] = pzuCountTo;
      }
      if (lzTotalIndex !== undefined) {
        localVarQueryParameter['lz-total-index'] = lzTotalIndex;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    getLzTransactionMoreInfo: async (
      lzId?: any,
      paymentFrom?: string,
      paymentTo?: string,
      period?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/reports/lz/${lzId}/monthly-volume`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (paymentFrom !== undefined) {
        localVarQueryParameter['payment-from'] = paymentFrom;
      }

      if (paymentTo !== undefined) {
        localVarQueryParameter['payment-to'] = paymentTo;
      }

      if (period !== undefined) {
        localVarQueryParameter['group-by'] = period;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    getPzuTransactionMonthlyVolume: async (
      pzuId?: any,
      paymentFrom?: string,
      paymentTo?: string,
      period?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/reports/pzu/${pzuId}/monthly-volume`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (paymentFrom !== undefined) {
        localVarQueryParameter['payment-from'] = paymentFrom;
      }

      if (paymentTo !== undefined) {
        localVarQueryParameter['payment-to'] = paymentTo;
      }

      if (period !== undefined) {
        localVarQueryParameter['group-by'] = period;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FileControllerApi - factory interface
 * @export
 */
export const FileControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPassportScan(file: any, options?: any): AxiosPromise<AddFile> {
      return FileControllerApiFp(configuration)
        .loadPassportScan(file, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recognizePassportScan(fileId: number, options?: any): AxiosPromise<PassportData> {
      return FileControllerApiFp(configuration)
        .recognizePassportScan(fileId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPassportScanByScanId(scanId: number, options?: any): AxiosPromise<Array<string>> {
      return FileControllerApiFp(configuration)
        .getPassportScanByScanId(scanId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} size
     * @param {string} tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQrCodeForMobileUpload(tag: string, size?: number, options?: any): AxiosPromise<Array<string>> {
      return FileControllerApiFp(configuration)
        .getQrCodeForMobileUpload(tag, size, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {any} [file]
     * @param {string} [jwt]
     * @param {string} [tag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMobileFile(file: any, jwt: string, tag: string, options?: any): AxiosPromise<AddFile> {
      return FileControllerApiFp(configuration)
        .loadMobileFile(file, jwt, tag, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLoadedFiles(tag?: string, options?: any): AxiosPromise<number[]> {
      return FileControllerApiFp(configuration)
        .getLoadedFiles(tag, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const FileControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loadPassportScan(
      file: any,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddFile>> {
      const localVarAxiosArgs = await FileControllerApiAxiosParamCreator(configuration).loadPassportScan(file, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recognizePassportScan(
      fileId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PassportData>> {
      const localVarAxiosArgs = await FileControllerApiAxiosParamCreator(configuration).recognizePassportScan(
        fileId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPassportScanByScanId(
      fileId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string[]>> {
      const localVarAxiosArgs = await FileControllerApiAxiosParamCreator(configuration).getPassportScanByScanId(
        fileId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getQrCodeForMobileUpload(
      tag: string,
      size?: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string[]>> {
      const localVarAxiosArgs = await FileControllerApiAxiosParamCreator(configuration).getQrCodeForMobileUpload(
        tag,
        size,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {any} [file]
     * @param {string} [jwt]
     * @param {string} [tag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loadMobileFile(
      file: any,
      jwt: string,
      tag: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddFile>> {
      const localVarAxiosArgs = await FileControllerApiAxiosParamCreator(configuration).loadMobileFile(
        file,
        jwt,
        tag,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLoadedFiles(
      tag?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number[]>> {
      const localVarAxiosArgs = await FileControllerApiAxiosParamCreator(configuration).getLoadedFiles(tag, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const FileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPassportScan: async (file: any, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError('file', 'Required parameter file was null or undefined when calling loadPassportScan.');
      }
      const localVarPath = `/files`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      localVarQueryParameter['recognize'] = true;
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recognizePassportScan: async (fileId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      if (fileId === null || fileId === undefined) {
        throw new RequiredError(
          'fileId',
          'Required parameter fileId was null or undefined when calling recognizePassportScan.',
        );
      }
      const localVarPath = `/files/{fileId}/recognize-passport-scan`.replace(
        `{${'fileId'}}`,
        encodeURIComponent(String(fileId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPassportScanByScanId: async (scanId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'scanId' is not null or undefined
      if (scanId === null || scanId === undefined) {
        throw new RequiredError(
          'scanId',
          'Required parameter scanId was null or undefined when calling getPassportScanByScanId.',
        );
      }
      const localVarPath = `/psas/{scanId}/passport-scan`.replace(`{${'scanId'}}`, encodeURIComponent(String(scanId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} tag
     * @param {number} size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQrCodeForMobileUpload: async (tag: string, size?: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'scanId' is not null or undefined
      if (tag === null || tag === undefined) {
        throw new RequiredError(
          'tag',
          'Required parameter scanId was null or undefined when calling getQrCodeForMobileUpload.',
        );
      }
      const localVarPath = '/files/mobile-upload/qr-code';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (tag) {
        localVarQueryParameter['tag'] = tag;
      }

      if (size) {
        localVarQueryParameter['size'] = size;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {any} [file]
     * @param {string} [jwt]
     * @param {string} [tag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMobileFile: async (file: File, jwt: string, tag: string, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError('file', 'Required parameter file was null or undefined when calling loadMobileFile.');
      }

      if (jwt === null || jwt === undefined) {
        throw new RequiredError('jwt', 'Required parameter file was null or undefined when calling loadMobileFile.');
      }

      if (tag === null || tag === undefined) {
        throw new RequiredError('tag', 'Required parameter file was null or undefined when calling loadMobileFile.');
      }

      const localVarPath = '/files/mobile-upload';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (jwt) {
        localVarQueryParameter['jwt'] = jwt;
      }

      if (tag) {
        localVarQueryParameter['tag'] = tag;
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);

      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLoadedFiles: async (tag?: string, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = '/files';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (tag) {
        localVarQueryParameter['tag'] = tag;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * NewsControllerApiFactory - factory interface
 * @export
 */
export const NewsControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNews(newsType?: string | null, options?: any): AxiosPromise<PageWrapperNews> {
      return NewsControllerApiFp(configuration)
        .getNews(newsType, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {NewsCreate} newsCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createNews(newsCreate: NewsCreate, options?: any): AxiosPromise<IdWrapper> {
      return NewsControllerApiFp(configuration)
        .createNews(newsCreate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} newsId
     * @param {NewsUpdate} newsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNews(newsId: number, newsUpdate: NewsUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return NewsControllerApiFp(configuration)
        .updateNews(newsId, newsUpdate, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const NewsControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNews(
      newsType?: string | null,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageWrapperNews>> {
      const localVarAxiosArgs = await NewsControllerApiAxiosParamCreator(configuration).getNews(newsType, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {NewsCreate} newsCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createNews(
      newsCreate: NewsCreate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await NewsControllerApiAxiosParamCreator(configuration).createNews(newsCreate, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} newsId
     * @param {NewsUpdate} newsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateNews(
      newsId: number,
      newsUpdate: NewsUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await NewsControllerApiAxiosParamCreator(configuration).updateNews(
        newsId,
        newsUpdate,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const NewsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNews: async (newsType?: string | null, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/news`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }

      if (newsType !== undefined && newsType !== null) {
        queryParameters.set('news-type', newsType);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {any} newsCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createNews: async (newsCreate: NewsCreate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'newsCreate' is not null or undefined
      if (newsCreate === null || newsCreate === undefined) {
        throw new RequiredError(
          'newsCreate',
          'Required parameter newsCreate was null or undefined when calling newsCreate.',
        );
      }
      const localVarPath = '/news';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof newsCreate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(newsCreate !== undefined ? newsCreate : {})
        : newsCreate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} newsId
     * @param {NewsUpdate} newsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNews: async (newsId: number, newsUpdate: NewsUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'metalTariffId' is not null or undefined
      if (newsId === null || newsId === undefined) {
        throw new RequiredError('newsId', 'Required parameter newsId was null or undefined when calling updateNews.');
      }
      // verify required parameter 'metalTariffUpdate' is not null or undefined
      if (newsUpdate === null || newsUpdate === undefined) {
        throw new RequiredError(
          'newsUpdate',
          'Required parameter newsUpdate was null or undefined when calling updateNews.',
        );
      }
      const localVarPath = `/news/{newsId}`.replace(`{${'newsId'}}`, encodeURIComponent(String(newsId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof newsUpdate !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(newsUpdate !== undefined ? newsUpdate : {})
        : newsUpdate || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LzDocumentControllerApiFactory - factory interface
 * @export
 */
export const LzDocumentControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {ILoadDocumentData} loadData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDocument(loadData: ILoadDocumentData, options?: any): AxiosPromise<{ id: number }> {
      return LzDocumentControllerApiFp(configuration)
        .loadDocument(loadData, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentsByLzId(lzId: number, options?: any): AxiosPromise<DocumentInfo[]> {
      return LzDocumentControllerApiFp(configuration)
        .getDocumentsByLzId(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComplianceDocumentsByLzId(lzId: number, options?: any): AxiosPromise<DocumentInfo[]> {
      return LzDocumentControllerApiFp(configuration)
        .getComplianceDocumentsByLzId(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} documentId
     * @param {ComplianceDocumentInfo} documentUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocument(documentId: number, documentUpdateData: ComplianceDocumentInfo, options?: any): AxiosPromise<SuccessWrapper> {
      return LzDocumentControllerApiFp(configuration)
        .updateDocument(documentId, documentUpdateData, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadDocumentById(docId: number, options?: any): AxiosPromise<any> {
      return LzDocumentControllerApiFp(configuration)
        .downloadDocumentById(docId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLzDocument(docId: number, options?: any): AxiosPromise<SuccessWrapper> {
      return LzDocumentControllerApiFp(configuration)
        .deleteLzDocument(docId, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const LzDocumentControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     * @param {ILoadDocumentData} loadData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loadDocument(
      loadData: ILoadDocumentData,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ id: number }>> {
      const localVarAxiosArgs = await DocumentControllerApiAxiosParamCreator(configuration).loadDocument(
        loadData,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocumentsByLzId(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentInfo[]>> {
      const localVarAxiosArgs = await DocumentControllerApiAxiosParamCreator(configuration).getDocumentsByLzId(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getComplianceDocumentsByLzId(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentInfo[]>> {
      const localVarAxiosArgs = await DocumentControllerApiAxiosParamCreator(configuration).getComplianceDocumentsByLzId(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} documentId
     * @param {ComplianceDocumentInfo} documentUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateDocument(
    documentId: number,
    documentUpdateData: ComplianceDocumentInfo,
    options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await DocumentControllerApiAxiosParamCreator(configuration).updateDocument(
      documentId,
      documentUpdateData,
      options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async downloadDocumentById(
      docId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await DocumentControllerApiAxiosParamCreator(configuration).downloadDocumentById(
        docId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} scanId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteLzDocument(
      scanId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await DocumentControllerApiAxiosParamCreator(configuration).deleteLzDocument(
        scanId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const DocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {ILoadDocumentData} loadData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDocument: async (loadData: ILoadDocumentData, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (loadData === null || loadData === undefined) {
        throw new RequiredError('file', 'Required parameter file was null or undefined when calling loadPassportScan.');
      }
      const localVarPath = `/lzs/{lzId}/documents`.replace(`{${'lzId'}}`, encodeURIComponent(String(loadData.lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (loadData.file !== undefined) {
        localVarFormParams.append('file', loadData.file as any);
      }

      if (loadData.type !== undefined) {
        localVarQueryParameter['type'] = loadData.type;
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocumentsByLzId: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
          'fileId',
          'Required parameter lzId was null or undefined when calling getDocumentsByLzId.',
        );
      }
      const localVarPath = `/lzs/{lzId}/documents`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getComplianceDocumentsByLzId: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError(
        'fileId',
        'Required parameter lzId was null or undefined when calling getDocumentsByLzId.',
        );
      }
      const localVarPath = `/lzs/{lzId}/documents/compliance`.replace(`{${'lzId'}}`, encodeURIComponent(String(lzId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
        typeof configuration.apiKey === 'function'
        ? await configuration.apiKey('Authorization')
        : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} documentId
     * @param {ComplianceDocumentInfo} documentUpdateData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocument: async (documentId: number, documentUpdateData: ComplianceDocumentInfo, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      if (documentId === null || documentId === undefined) {
        throw new RequiredError('documentId', 'Required parameter documentId was null or undefined when calling updateDocument.');
      }
      // verify required parameter 'documentUpdateData' is not null or undefined
      if (documentUpdateData === null || documentUpdateData === undefined) {
        throw new RequiredError(
        'documentUpdateData',
        'Required parameter documentUpdateData was null or undefined when calling updateDocument.',
        );
      }
      const localVarPath = `/documents/{documentId}/compliance`.replace(`{${'documentId'}}`, encodeURIComponent(String(documentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
        typeof configuration.apiKey === 'function'
        ? await configuration.apiKey('Authorization')
        : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof documentUpdateData !== 'string';
      const needsSerialization =
      nonString && configuration && configuration.isJsonMime
      ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
      : nonString;
      localVarRequestOptions.data = needsSerialization
      ? JSON.stringify(documentUpdateData !== undefined ? documentUpdateData : {})
      : documentUpdateData || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadDocumentById: async (docId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'docId' is not null or undefined
      if (docId === null || docId === undefined) {
        throw new RequiredError(
          'docId',
          'Required parameter lzId was null or undefined when calling downloadDocumentById.',
        );
      }
      const localVarPath = `/documents/{docId}`.replace(`{${'docId'}}`, encodeURIComponent(String(docId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLzDocument: async (docId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'docId' is not null or undefined
      if (docId === null || docId === undefined) {
        throw new RequiredError(
          'scanId',
          'Required parameter scanId was null or undefined when calling deleteLzDocument.',
        );
      }
      const localVarPath = `/documents/{documentId}`.replace(`{${'documentId'}}`, encodeURIComponent(String(docId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CounterpartyControllerApiFactory - factory interface
 * @export
 */
export const CounterpartyControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {string} inn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportByInn(inn: string, options?: any): AxiosPromise<any> {
      return CounterpartyControllerApiFp(configuration)
        .getReportByInn(inn, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportByReportId(reportId: number, options?: any): AxiosPromise<any> {
      return CounterpartyControllerApiFp(configuration)
        .getReportByReportId(reportId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestReportsByLzId(lzId: number, options?: any): AxiosPromise<CounterpartyReports> {
      return CounterpartyControllerApiFp(configuration)
        .getLatestReportsByLzId(lzId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {ISearchValues} searchValues
     * @throws {RequiredError}
     */
    getAllReports(searchValues: ISearchValues, options?: any): AxiosPromise<CounterpartyReports> {
      return CounterpartyControllerApiFp(configuration)
        .getAllReports(searchValues, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const CounterpartyControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} inn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReportByInn(
      inn: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await CounterpartyControllerApiAxiosParamCreator(configuration).getReportByInn(
        inn,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReportByReportId(
      reportId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdWrapper>> {
      const localVarAxiosArgs = await CounterpartyControllerApiAxiosParamCreator(configuration).getReportByReportId(
        reportId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestReportsByLzId(
      lzId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounterpartyReports>> {
      const localVarAxiosArgs = await CounterpartyControllerApiAxiosParamCreator(configuration).getLatestReportsByLzId(
        lzId,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {string} ISearchValues
     * @throws {RequiredError}
     */
    async getAllReports(
      searchValues: ISearchValues,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CounterpartyReports>> {
      const localVarAxiosArgs = await CounterpartyControllerApiAxiosParamCreator(configuration).getAllReports(
        searchValues,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * CounterpartyControllerApiAxiosParamCreator - axios parameter creator
 * @export
 */
export const CounterpartyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} inn
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportByInn: async (inn: string, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'paymentId' is not null or undefined
      if (inn === null || inn === undefined || inn === '') {
        throw new RequiredError('inn', 'Required parameter inn was null or undefined when calling getReportByInn.');
      }
      const localVarPath = `/counterparty/inn/{inn}`.replace(`{${'inn'}}`, encodeURIComponent(String(inn)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} reportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReportByReportId: async (reportId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'paymentId' is not null or undefined
      if (reportId === null || reportId === undefined) {
        throw new RequiredError(
          'reportId',
          'Required parameter reportId was null or undefined when calling getReportByReportId.',
        );
      }
      const localVarPath = `/counterparty/report/{reportId}`.replace(
        `{${'reportId'}}`,
        encodeURIComponent(String(reportId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestReportsByLzId: async (lzId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'paymentId' is not null or undefined
      if (lzId === null || lzId === undefined) {
        throw new RequiredError('lzId', 'Required parameter inn was null or undefined when calling getReportByInn.');
      }
      const localVarPath = `/counterparty/lz/{lzId}/latest-reports`.replace(
        `{${'lzId'}}`,
        encodeURIComponent(String(lzId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {ISearchValues} searchValues
     * @throws {RequiredError}
     */
    getAllReports: async (searchValues: ISearchValues, options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/counterparty/latest-reports`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (searchValues.inn) {
        localVarQueryParameter['inn-like'] = searchValues.inn;
      }

      if (searchValues.name) {
        localVarQueryParameter['name-like'] = searchValues.name;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

export const VehicleControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVehicleInfoByNumber(number: string, options?: any): AxiosPromise<IVehicleInfo> {
      return VehicleControllerApiFp(configuration)
        .getVehicleInfoByNumber(number, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVehicleModels(options?: any): AxiosPromise<any> {
      return VehicleControllerApiFp(configuration)
        .getVehicleModels(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVehicleBrands(options?: any): AxiosPromise<IVehicleModel[]> {
      return VehicleControllerApiFp(configuration)
        .getVehicleBrands(options)
        .then(request => request(axios, basePath));
    },
  };
};

export const VehicleControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVehicleInfoByNumber(
      number: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IVehicleInfo>> {
      const localVarAxiosArgs = await VehicleControllerApiAxiosParamCreator(configuration).getVehicleInfoByNumber(
        number,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVehicleModels(
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IVehicleInfo>> {
      const localVarAxiosArgs = await VehicleControllerApiAxiosParamCreator(configuration).getVehicleModels(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVehicleBrands(
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IVehicleModel[]>> {
      const localVarAxiosArgs = await VehicleControllerApiAxiosParamCreator(configuration).getVehicleBrands(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * VehicleControllerApiAxiosParamCreator - axios parameter creator
 * @export
 */
export const VehicleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVehicleInfoByNumber: async (number: string, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'paymentId' is not null or undefined
      if (number === null || number === undefined) {
        throw new RequiredError(
          'number',
          'Required parameter inn was null or undefined when calling getVehicleInfoByNumber.',
        );
      }
      const localVarPath = `/vehicle/info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (number) {
        localVarQueryParameter['number'] = number;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVehicleModels: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/vehicle/models`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVehicleBrands: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/vehicle/brands`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

export const VendorControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorSettings(options?: any): AxiosPromise<VendorSettings> {
      return VendorControllerApiFp(configuration)
        .getVendorSettings(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {vendorSettings} VendorSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateVendorSettings(vendorSettings: VendorSettingsUpdate, options?: any): AxiosPromise<SuccessWrapper> {
      return VendorControllerApiFp(configuration)
        .updateVendorSettings(vendorSettings, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const VendorControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getVendorSettings(
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorSettings>> {
      const localVarAxiosArgs = await VendorControllerApiAxiosParamCreator(configuration).getVendorSettings(options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {vendorSettings} VendorSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateVendorSettings(
      vendorSettings: VendorSettingsUpdate,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessWrapper>> {
      const localVarAxiosArgs = await VendorControllerApiAxiosParamCreator(configuration).updateVendorSettings(
        vendorSettings,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * VendorControllerApiAxiosParamCreator - axios parameter creator
 * @export
 */
export const VendorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getVendorSettings: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = '/vendor/settings';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {vendorSettings} VendorSettingsUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateVendorSettings: async (vendorSettings: VendorSettingsUpdate, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'vendorSettings' is not null or undefined
      if (vendorSettings === null || vendorSettings === undefined) {
        throw new RequiredError(
          'vendorSettings',
          'Required parameter userCreate was null or undefined when calling changeVendorSettings.',
        );
      }
      const localVarPath = `/vendor/settings`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof vendorSettings !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(vendorSettings !== undefined ? vendorSettings : {})
        : vendorSettings || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LzDocumentControllerApiFactory - factory interface
 * @export
 */
export const ComplianceControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentSettings(options?: any): AxiosPromise<ComplianceSettings> {
      return ComplianceControllerApiFp(configuration)
        .getCurrentSettings(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndexDefSettings(options?: any): AxiosPromise<ComplianceSettings> {
      return ComplianceControllerApiFp(configuration)
        .getIndexDefSettings(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndexSettingsById(id: number, options?: any): AxiosPromise<ComplianceSettings> {
      return ComplianceControllerApiFp(configuration)
        .getIndexSettingsById(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndexHistorySettings(
      createdAt?: string,
      createAtTo?: string,
      options?: any,
    ): AxiosPromise<ComplianceSettingsHistory[]> {
      return ComplianceControllerApiFp(configuration)
        .getIndexHistorySettings(createdAt, createAtTo, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {ComplianceSettings} settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setIndexSettings(settings: ComplianceSettings, options?: any): AxiosPromise<ComplianceSettings> {
      return ComplianceControllerApiFp(configuration)
        .setIndexSettings(settings, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const ComplianceControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCurrentSettings(
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettings>> {
      const localVarAxiosArgs = await ComplianceControllerApiAxiosParamCreator(configuration).getCurrentSettings(
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIndexDefSettings(
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettings>> {
      const localVarAxiosArgs = await ComplianceControllerApiAxiosParamCreator(configuration).getIndexDefSettings(
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIndexSettingsById(
      id: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettings>> {
      const localVarAxiosArgs = await ComplianceControllerApiAxiosParamCreator(configuration).getIndexSettingsById(
        id,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} lzId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIndexHistorySettings(
      createdAt?: string,
      createAtTo?: string,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettingsHistory[]>> {
      const localVarAxiosArgs = await ComplianceControllerApiAxiosParamCreator(configuration).getIndexHistorySettings(
        createdAt,
        createAtTo,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {ComplianceSettings} settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setIndexSettings(
      settings: ComplianceSettings,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettings>> {
      const localVarAxiosArgs = await ComplianceControllerApiAxiosParamCreator(configuration).setIndexSettings(
        settings,
        options,
      );
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const ComplianceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentSettings: async (options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined

      const localVarPath = '/compliance/index-settings/current';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndexDefSettings: async (options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined

      const localVarPath = '/compliance/index-settings/default';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndexSettingsById: async (id: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined

      const localVarPath = `/compliance/index-settings/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIndexHistorySettings: async (
      createdAt?: string,
      createAtTo?: string,
      options: any = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined

      const localVarPath = '/compliance/index-settings/history';
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (createdAt) {
        localVarQueryParameter['created-at-from'] = createdAt;
      }

      if (createAtTo) {
        localVarQueryParameter['created-at-to'] = createAtTo;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ComplianceSettings} settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setIndexSettings: async (settings: ComplianceSettings, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'lzId' is not null or undefined
      if (settings === null || settings === undefined) {
        throw new RequiredError(
          'settings',
          'Required parameter settings was null or undefined when calling setIndexSettings.',
        );
      }
      const localVarPath = `/compliance/index-settings`;

      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      const nonString = typeof settings !== 'string';
      const needsSerialization =
        nonString && configuration && configuration.isJsonMime
          ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
          : nonString;
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(settings !== undefined ? settings : {})
        : settings || '';

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CounterpartyControllerApiFactory - factory interface
 * @export
 */
export const CommissionDocumentControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  return {
    /**
     *
     * @param {number} commissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommissionDocuments(commissionId: number, options?: any): AxiosPromise<Array<{ id: number; name: string }>> {
      return CommissionDocumentControllerApiFp(configuration)
        .getCommissionDocuments(commissionId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} commissionDocId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommissionDocumentById(commissionDocId: number, options?: any): AxiosPromise<any> {
      return CommissionDocumentControllerApiFp(configuration)
        .getCommissionDocumentById(commissionDocId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} commissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCommissionDocuments(commissionId: number, file: any, options?: any): AxiosPromise<any> {
      return CommissionDocumentControllerApiFp(configuration)
        .createCommissionDocuments(commissionId, file, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCommissionDocument(documentId: number, options?: any): AxiosPromise<any> {
      return CommissionDocumentControllerApiFp(configuration)
        .deleteCommissionDocument(documentId, options)
        .then(request => request(axios, basePath));
    },
  };
};

export const CommissionDocumentControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} commissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCommissionDocuments(
      commissionId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ id: number; name: string }>>> {
      const localVarAxiosArgs = await CommissionDocumentControllerApiAxiosParamCreator(
        configuration,
      ).getCommissionDocuments(commissionId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} commissionDocId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCommissionDocumentById(
      commissionDocId: number,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettings>> {
      const localVarAxiosArgs = await CommissionDocumentControllerApiAxiosParamCreator(
        configuration,
      ).getCommissionDocumentById(commissionDocId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} commissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCommissionDocuments(
      commissionId: number,
      file: any,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettings>> {
      const localVarAxiosArgs = await CommissionDocumentControllerApiAxiosParamCreator(
        configuration,
      ).createCommissionDocuments(commissionId, file, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteCommissionDocument(
      documentId: number,
      file: any,
      options?: any,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceSettings>> {
      const localVarAxiosArgs = await CommissionDocumentControllerApiAxiosParamCreator(
        configuration,
      ).deleteCommissionDocument(documentId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: (configuration?.basePath || basePath) + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

export const CommissionDocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} [commissionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommissionDocuments: async (commissionId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (commissionId === null || commissionId === undefined) {
        throw new RequiredError(
          'commissionId',
          'Required parameter psaId was null or undefined when calling getCommissionDocuments.',
        );
      }
      const localVarPath = `/commissions/{commissionId}/commission-documents`.replace(
        `{${'commissionId'}}`,
        encodeURIComponent(String(commissionId)),
      );

      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [commissionDocId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommissionDocumentById: async (commissionDocId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (commissionDocId === null || commissionDocId === undefined) {
        throw new RequiredError(
          'commissionId',
          'Required parameter psaId was null or undefined when calling getCommissionDocuments.',
        );
      }
      const localVarPath = `/commission-documents/{commissionDocumentId}`.replace(
        `{${'commissionDocumentId'}}`,
        encodeURIComponent(String(commissionDocId)),
      );

      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} psaId
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCommissionDocuments: async (commissionId: number, file: any, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'psaId' is not null or undefined
      if (commissionId === null || commissionId === undefined) {
        throw new RequiredError(
          'commissionId',
          'Required parameter psaId was null or undefined when calling createCommissionDocuments.',
        );
      }
      const localVarPath = `/commissions/{commissionId}/commission-documents`.replace(
        `{${'commissionId'}}`,
        encodeURIComponent(String(commissionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCommissionDocument: async (documentId: number, options: any = {}): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      if (documentId === null || documentId === undefined) {
        throw new RequiredError(
          'documentId',
          'Required parameter scanId was null or undefined when calling deleteCommissionDocument.',
        );
      }
      const localVarPath = `/commission-documents/{commissionDocumentId}`.replace(
        `{${'commissionDocumentId'}}`,
        encodeURIComponent(String(documentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('Authorization')
            : await configuration.apiKey;
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue;
      }

      const queryParameters = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        queryParameters.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.query) {
        queryParameters.set(key, options.query[key]);
      }
      localVarUrlObj.search = new URLSearchParams(queryParameters).toString();
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};
